// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
:root {
  --color: #000;
  --app-max-content-width: 1440px;
  --app-header-max-width: 1920px;
}

:root {
  --color: #000;
  --app-max-content-width: 1440px;
  --app-header-max-width: 1920px;
}

.dashboard-main {
  height: calc(100dvh - 106px - var(--marketing-banner-height, 0px));
  overflow: hidden;
  overscroll-behavior: none;
  display: flex;
  flex-direction: column;
  margin-right: 0;
  font-family: var(--font-family);
  padding-left: 40px;
  padding-right: 40px;
}
@media screen and (max-width: 480px) {
  .dashboard-main {
    padding-left: 0;
    padding-right: 0;
  }
}

.dashboard-shell {
  background: #F7F7F8;
}

.dashboard-marketing-banner {
  position: fixed;
  top: 64px;
  left: 0;
  right: 0;
  z-index: 1090;
  width: 100%;
  box-sizing: border-box;
  background: #ececef;
  border-bottom: 1px solid #d6d8de;
}

.dashboard-marketing-banner-inner {
  box-sizing: border-box;
  max-width: var(--app-header-max-width);
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 8px 20px 8px 24px;
  position: relative;
}

.dashboard-marketing-content {
  display: flex;
  align-items: center;
  gap: 14px;
  min-width: 0;
  flex: 1;
}

.dashboard-marketing-badge-wrap {
  display: inline-flex;
  align-items: center;
  gap: 0;
  flex-shrink: 0;
}

.dashboard-marketing-icon {
  color: #2E75B6;
  font-size: 16px !important;
}

.dashboard-marketing-badge {
  color: #2E75B6;
  background: #E1E8EF;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 6px;
  line-height: 0;
}

.dashboard-marketing-text-wrap {
  flex: 1 1 0;
  min-width: 0;
  transition: opacity 0.25s ease, transform 0.25s ease;
  opacity: 1;
  transform: translateY(0);
}

.dashboard-marketing-text-wrap.is-fading {
  opacity: 0;
  transform: translateY(4px);
}

.dashboard-marketing-text {
  color: #1f2937;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.dashboard-marketing-indicators {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.dashboard-marketing-indicator {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #8f9198;
  opacity: 0.8;
}

.dashboard-marketing-indicator.is-active {
  width: 26px;
  border-radius: 999px;
  background: #2E75B6;
  opacity: 1;
}

.revamp-super-user-pill, .dashboard-super-user-pill {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 1px solid #D7D7DA;
  border-radius: 999px;
  padding: 5px 14px 5px 10px;
  background: #ffffff;
  flex-shrink: 0;
  white-space: nowrap;
}

.dashboard-super-user-pill.is-centered {
  margin: 0 auto;
}

.dashboard-super-user-text {
  font-size: 14px !important;
  font-weight: 400;
  color: #6E6E77 !important;
  line-height: 20px;
}

.revamp-super-user-banner {
  position: fixed;
  top: 64px;
  left: 0;
  right: 0;
  z-index: 1090;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px 24px;
  background: #F2F2F3;
  border-bottom: 1px solid #E8E8EC;
  width: 100%;
  box-sizing: border-box;
}

.revamp-super-user-text {
  font-size: 14px !important;
  font-weight: 400;
  color: #6E6E77 !important;
  line-height: 20px;
}

.dashboard-marketing-close {
  color: #717784 !important;
  flex-shrink: 0;
  margin-left: 2px !important;
  width: 28px;
  height: 28px;
}
.dashboard-marketing-close:hover {
  background: rgba(0, 0, 0, 0.05);
}

@media screen and (max-width: 480px) {
  .dashboard-main {
    height: calc(100dvh - 118px - var(--marketing-banner-height, 0px));
  }
  .dashboard-marketing-banner-inner {
    padding: 8px 10px;
    gap: 10px;
    align-items: center;
  }
  .dashboard-marketing-content {
    align-items: center;
    gap: 8px;
  }
  .dashboard-marketing-badge {
    padding: 6px;
    color: #2E75B6;
  }
  .dashboard-marketing-text {
    font-size: 14px;
    line-height: 20px;
    -webkit-line-clamp: unset;
    line-clamp: unset;
    display: block;
    overflow: visible;
  }
  .dashboard-marketing-text-wrap {
    max-width: calc(100vw - 100px);
  }
  .dashboard-marketing-indicator {
    width: 7px;
    height: 7px;
  }
  .dashboard-marketing-indicator.is-active {
    width: 16px;
  }
}
.version-wrapper-dashboard {
  padding: 10px 24px;
  width: 100vw;
  max-width: var(--app-header-max-width);
  margin-left: calc(50% - 50vw);
}
.version-wrapper-dashboard .tc-pp-container {
  width: 100%;
  display: flex;
  flex-direction: row;
}
.version-wrapper-dashboard .tc-pp-container .terms-wrapper {
  width: 100%;
  display: flex;
  flex-direction: row;
}
.version-wrapper-dashboard .tc-pp-container .terms-wrapper .tc-content {
  color: gray;
  font-size: 14px;
  text-decoration: underline;
  cursor: pointer;
}
.version-wrapper-dashboard .tc-pp-container .pp-wrapper {
  width: 100%;
}
.version-wrapper-dashboard .tc-pp-container .pp-wrapper p {
  color: gray;
  font-size: 14px;
  text-decoration: underline;
  cursor: pointer;
}
.version-wrapper-dashboard .tc-pp-container .hr-divider {
  padding: 0 10px;
}

.MuiAppBar-root.revamp-appbar {
  background: #ffffff !important;
  color: #20242e;
  box-shadow: none;
  border-bottom: 1px solid #bdbdc2;
  position: fixed !important;
  left: 0;
  right: 0;
  width: 100%;
  top: 0 !important;
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}
.MuiAppBar-root .MuiToolbar-root {
  min-height: 64px;
}
.MuiAppBar-root .MuiToolbar-root .header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  width: 100%;
}
.MuiAppBar-root .MuiToolbar-root .header .header-logo {
  max-width: 160px;
  display: flex;
  align-items: center;
}
.MuiAppBar-root .MuiToolbar-root .header .header-logo svg {
  font-size: 30px;
}
.MuiAppBar-root .MuiToolbar-root .header .header-logo img {
  width: 100%;
  min-width: 100%;
  max-width: 100%;
  margin-left: 16px;
}
@media (max-width: 540px) {
  .MuiAppBar-root .MuiToolbar-root .header .header-logo img {
    margin-left: 0px;
    min-width: 110px;
  }
}
@media (max-width: 540px) {
  .MuiAppBar-root .MuiToolbar-root .header .header-logo .MuiButtonBase-root {
    padding-left: 0px;
  }
}
@media (max-width: 540px) {
  .MuiAppBar-root .MuiToolbar-root .header {
    align-items: center;
    row-gap: 8px;
  }
}
.MuiAppBar-root .MuiToolbar-root .logout-btn .MuiButtonBase-root {
  padding: 7px 16px;
}
@media (max-width: 540px) {
  .MuiAppBar-root .MuiToolbar-root .logout-btn .MuiButtonBase-root {
    padding: 10px 9px;
    min-width: 50px;
  }
}
.MuiAppBar-root .MuiToolbar-root .logout-btn .app-bar .select-dropdown .MuiInputBase-root {
  border: 1px solid #fff;
  width: 120px;
}
.MuiAppBar-root .MuiToolbar-root .logout-btn .app-bar .select-dropdown .MuiInputBase-root .MuiOutlinedInput-notchedOutline {
  border: none;
}
.MuiAppBar-root .MuiToolbar-root .logout-btn .app-bar .select-dropdown .MuiInputBase-root .MuiSelect-outlined {
  padding-left: 32px;
}
@media (max-width: 540px) {
  .MuiAppBar-root .MuiToolbar-root .logout-btn .app-bar .select-dropdown .MuiInputBase-root {
    width: 60px;
  }
  .MuiAppBar-root .MuiToolbar-root .logout-btn .app-bar .select-dropdown .MuiInputBase-root .MuiSelect-outlined {
    padding-left: 0px;
    color: transparent !important;
  }
}
.MuiAppBar-root .MuiToolbar-root .logout-btn .app-bar .select-dropdown .MuiInputBase-root.Mui-focused {
  font-family: var(--font-family);
}
.MuiAppBar-root .MuiToolbar-root .logout-btn .app-bar .select-dropdown .MuiInputBase-root.Mui-focused .MuiOutlinedInput-notchedOutline {
  display: none;
}

.revamp-appbar-spacer {
  height: calc(64px + var(--super-user-banner-height, 0px) + var(--marketing-banner-height, 0px));
}

body.nav-scrolled-away {
  /* version-wrapper is hidden on mobile — nothing left to subtract for it when header also
     hides, but the marketing banner (if present) still needs its own room reserved */
}
body.nav-scrolled-away .MuiAppBar-root.revamp-appbar {
  transform: translateY(-64px);
}
body.nav-scrolled-away .dashboard-marketing-banner {
  transform: translateY(-64px);
}
body.nav-scrolled-away .revamp-appbar-spacer {
  height: var(--marketing-banner-height, 0px);
}
body.nav-scrolled-away .dashboard-main {
  height: calc(100dvh - 46px - var(--marketing-banner-height, 0px));
}
@media screen and (max-width: 480px) {
  body.nav-scrolled-away .revamp-appbar-spacer {
    height: var(--marketing-banner-height, 0px);
  }
  body.nav-scrolled-away .dashboard-main {
    height: calc(100dvh - 46px - var(--marketing-banner-height, 0px));
  }
}
@media screen and (max-width: 600px) {
  body.nav-scrolled-away .dashboard-main {
    height: calc(100dvh - var(--marketing-banner-height, 0px));
  }
}

.revamp-header {
  box-sizing: border-box;
  width: 100%;
  max-width: var(--app-header-max-width);
  margin: 0 auto;
  min-height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 24px;
}
@media screen and (max-width: 480px) {
  .revamp-header {
    padding: 10px;
  }
}

.revamp-header-left {
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  gap: 24px;
  min-width: 0;
}

.revamp-mobile-menu-btn {
  display: none !important;
}

.revamp-brand-logo {
  height: 42px;
  max-width: 130px;
  object-fit: contain;
  object-position: left center;
}

.revamp-header-tabs {
  display: flex;
  align-items: center;
}

.revamp-tab.MuiButtonBase-root {
  min-width: unset;
  border-radius: 8px;
  color: #3d3d42;
  text-transform: none;
  font-size: 14px;
  font-weight: 400;
  font-family: var(--font-family);
  padding: 8px;
  gap: 8px;
  min-height: 36px;
}
.revamp-tab:hover {
  background: #F5F6F8 !important;
}
.revamp-tab.Mui-disabled {
  opacity: 0.5;
}
.revamp-tab.active.MuiButtonBase-root {
  background: var(--color);
  color: var(--color-contrast-text);
}
.revamp-tab.active.MuiButtonBase-root:hover {
  background: var(--color) !important;
}

.revamp-tab-label {
  display: inline;
}

.revamp-tab-icon-wrap {
  width: 16px;
  height: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.revamp-header-right {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-left: 12px;
}

.revamp-search-container {
  font-size: 14px;
}
.revamp-search-container .revamp-search-header-text {
  font-size: inherit !important;
  font-family: var(--font-family) !important;
}
.revamp-search-container.is-expanded {
  width: min(450px, 100%);
  max-width: 450px;
}

@media screen and (max-width: 900px) {
  .revamp-mobile-menu-btn {
    display: inline-flex !important;
    width: 34px;
    height: 34px;
    color: #3d3d42;
  }
  .revamp-header-left {
    gap: 10px;
  }
  .revamp-brand-logo {
    width: 120px;
    min-width: 120px;
    height: 28px;
  }
  .revamp-header-right {
    gap: 8px;
  }
  .revamp-user-info {
    display: none;
  }
  .revamp-lang-btn.MuiButtonBase-root {
    padding: 5px 8px;
  }
}
@media screen and (min-width: 1201px) and (max-width: 1380px) {
  .revamp-header-left {
    gap: 6px;
  }
  .revamp-brand-logo {
    width: 115px;
    min-width: 100px;
    height: 28px;
  }
  .revamp-tab.MuiButtonBase-root {
    font-size: 13px;
    padding: 6px 8px;
    gap: 5px;
  }
  .revamp-search-container {
    font-size: 13px;
  }
  .revamp-header-right {
    gap: 8px;
  }
  .revamp-lang-btn.MuiButtonBase-root {
    padding: 5px 8px;
    gap: 5px;
    font-size: 13px;
  }
}
@media screen and (min-width: 1024px) and (max-width: 1200px) {
  .revamp-header-left {
    gap: 4px;
  }
  .revamp-brand-logo {
    width: 100px;
    min-width: 90px;
    height: 26px;
  }
  .revamp-tab.MuiButtonBase-root {
    font-size: 12px;
    padding: 6px 7px;
    gap: 4px;
  }
  .revamp-search-container {
    font-size: 12px;
  }
  .revamp-header-right {
    gap: 6px;
  }
  .revamp-lang-btn.MuiButtonBase-root {
    padding: 5px 7px;
    gap: 4px;
    font-size: 12px;
  }
}
@media screen and (min-width: 901px) and (max-width: 1023px) {
  .revamp-header-left {
    gap: 6px;
  }
  .revamp-brand-logo {
    width: 100px;
    min-width: 90px;
    height: 26px;
  }
  .revamp-tab-label {
    display: none;
  }
  .revamp-tab.MuiButtonBase-root {
    padding: 6px;
    gap: 0;
    min-width: 36px;
  }
  .revamp-search-container {
    font-size: 13px;
  }
  .revamp-header-right {
    gap: 6px;
  }
  .revamp-user-info {
    display: none;
  }
  .revamp-lang-btn.MuiButtonBase-root {
    padding: 5px 8px;
    gap: 4px;
    font-size: 13px;
  }
}
.revamp-lang-btn.MuiButtonBase-root {
  min-width: unset;
  border-radius: 8px;
  background: rgba(10, 10, 10, 0.05);
  color: #3d3d42;
  font-family: var(--font-family);
  text-transform: none;
  padding: 8px;
  gap: 8px;
  font-size: 14px;
}
.revamp-lang-btn.MuiButtonBase-root:hover {
  background: #F2F2F3;
}

.revamp-globe-icon {
  width: 16px;
  height: 16px;
}
.revamp-globe-icon svg {
  width: 16px;
  height: 16px;
}

.revamp-chevron-icon {
  width: 8px;
  height: 5px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.revamp-chevron-icon svg {
  width: 8px;
  height: 5px;
  display: block;
}

.revamp-lang-menu .MuiPaper-root {
  border: 1px solid #dfe3ef;
  border-radius: 10px;
  margin-top: 6px;
  min-width: 140px;
  box-shadow: 0 10px 24px rgba(23, 33, 61, 0.12);
}
.revamp-lang-menu .MuiMenuItem-root {
  font-size: 14px;
  color: #2d3345;
}
.revamp-lang-menu .MuiMenuItem-root.Mui-selected {
  background: #eef2ff;
  color: #20285c;
  font-weight: 600;
}

.revamp-bell-wrap {
  width: 32px;
  height: 32px;
  border-radius: 64px;
  background: rgba(10, 10, 10, 0.05);
  display: flex;
  align-items: center;
  justify-content: center;
}
.revamp-bell-wrap:hover {
  background: rgba(10, 10, 10, 0.1);
}

.revamp-notification-icon svg {
  position: absolute;
  width: 18px;
  height: 18px;
  right: 0px;
}

.revamp-user-info {
  text-align: right;
  min-width: 80px;
  max-width: 180px;
}
.revamp-user-info .name {
  font-size: 14px;
  color: #18181b;
  line-height: 18px;
  font-weight: 400;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.revamp-user-info .role {
  font-size: 12px;
  color: #3d3d42;
  line-height: 16px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.revamp-user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.revamp-user-avatar svg {
  width: 40px;
  height: 40px;
}

.revamp-profile-trigger {
  width: 40px;
  height: 40px;
  padding: 0;
}

.revamp-profile-overlay {
  position: fixed;
  inset: 0;
  background: rgba(16, 19, 31, 0.35);
  z-index: 1390;
}

.revamp-profile-menu-panel {
  position: fixed;
  top: 66px;
  right: calc((100vw - min(100vw, 1920px)) / 2 + 24px);
  width: 260px;
  min-height: 85px;
  gap: 4px;
  opacity: 1;
  border-radius: 8px;
  padding: 10px;
  background: var(--color);
  box-shadow: 0px 10px 24px rgba(20, 27, 62, 0.35);
  display: flex;
  flex-direction: column;
  z-index: 1400;
}

.revamp-profile-menu-user {
  display: none;
  flex-direction: column;
  padding: 4px 8px 8px;
  margin-bottom: 4px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);
}
.revamp-profile-menu-user .name {
  color: var(--color-contrast-text);
  font-size: 15px;
  line-height: 20px;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: var(--font-family) !important;
}
.revamp-profile-menu-user .role {
  color: var(--color-contrast-text);
  opacity: 0.7;
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: var(--font-family) !important;
}
@media screen and (max-width: 1023px) {
  .revamp-profile-menu-user {
    display: flex;
  }
}

.revamp-profile-menu-row {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 40px;
  border-radius: 6px;
  padding: 0 8px;
}
.revamp-profile-menu-row .item-icon {
  color: var(--color-contrast-text);
  font-size: 18px;
}
.revamp-profile-menu-row .item-text {
  color: var(--color-contrast-text);
  font-size: 15px;
  line-height: 20px;
  font-weight: 400;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: var(--font-family) !important;
}
.revamp-profile-menu-row.clickable {
  cursor: pointer;
}
.revamp-profile-menu-row.clickable:hover {
  background: rgba(255, 255, 255, 0.08);
}

@media screen and (max-width: 900px) {
  .revamp-profile-menu-panel {
    top: auto;
    bottom: 80px;
    left: 16px;
    right: auto;
  }
}
.MuiStack-root.dashboard-heading {
  flex-direction: row;
  max-width: 100% !important;
  padding: 16px 10px 16px 10px;
  align-items: center;
  justify-content: space-between;
  background: transparent;
  border: 0;
  box-shadow: none;
  gap: 16px;
  flex-shrink: 0;
}
.MuiStack-root.dashboard-heading .black-btn {
  text-transform: capitalize;
  letter-spacing: 0.25px;
  border-radius: 8px;
  min-height: 40px;
  font-family: var(--font-family) !important;
}
@media screen and (max-width: 480px) {
  .MuiStack-root.dashboard-heading {
    padding-top: 8px;
  }
}

.dashboard-heading-copy {
  flex: 1 1 auto;
  min-width: 0;
}

.pending-approval-banner {
  border: 1px solid #d6dce9;
}

.dashboard-welcome-title {
  color: #000000 !important;
  line-height: 1.2;
  font-family: var(--font-family) !important;
  font-size: 18px !important;
  font-weight: 600 !important;
}

.dashboard-welcome-subtitle {
  color: #6e6e77;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  font-family: var(--font-family) !important;
}
.dashboard-welcome-subtitle .attention-count {
  color: #f00214;
  font-weight: 500;
}

.dashboard-status-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 26px;
  padding: 0 14px;
  border: 1px solid #bdbdc2;
  border-radius: 999px;
  background: #efeff1;
  cursor: default;
}

.dashboard-status-chip-icon {
  font-size: 16px !important;
  color: #6e6e77;
}

.dashboard-status-chip-label {
  color: #1f1f23;
  font-family: var(--font-family) !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  line-height: 20px !important;
}

.dashboard-status-tooltip-popper .dashboard-status-tooltip {
  background: #6E6E77 !important;
  color: #ffffff !important;
  border-radius: 4px !important;
  max-width: 360px;
  padding: 12px 14px !important;
}
.dashboard-status-tooltip-popper .dashboard-status-tooltip-arrow {
  color: #6E6E77 !important;
  font-size: 18px !important;
}

.dashboard-status-tooltip-text {
  font-family: var(--font-family) !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  line-height: 20px !important;
  color: #ffffff;
}

@media screen and (min-width: 900px) {
  .dashboard-welcome-subtitle {
    font-size: 16px;
    line-height: 24px;
    color: #6e6e77;
  }
  .dashboard-welcome-subtitle .attention-count {
    font-size: 16px;
  }
}
.dashboard-heading .header-btns .MuiButtonBase-root {
  border-radius: 8px;
  font-weight: 400;
  min-height: 40px;
  padding: 8px 16px;
}
.dashboard-heading .header-btns .MuiButtonBase-root .MuiTypography-root {
  font-size: 14px;
  line-height: normal;
  font-weight: 400;
  font-family: var(--font-family) !important;
}

.dashboard-heading .header-btns {
  flex-wrap: nowrap;
  align-items: center;
  min-width: 0;
}

.dashboard-header-search {
  flex: 1 1 auto;
  min-width: 120px;
  max-width: 370px;
}
.dashboard-header-search .MuiOutlinedInput-root {
  width: 100%;
  min-height: 40px;
  border-radius: 8px;
  background: #ffffff;
  color: #3d3d42;
  font-family: var(--font-family) !important;
}
.dashboard-header-search .MuiOutlinedInput-root .MuiOutlinedInput-input {
  padding: 10px 12px 10px 0;
  font-size: 14px;
  line-height: 20px;
  color: #3d3d42;
}
.dashboard-header-search .MuiOutlinedInput-root .MuiOutlinedInput-input::placeholder {
  color: #6E6E77;
  opacity: 1;
}
.dashboard-header-search .MuiOutlinedInput-root .MuiInputAdornment-root {
  color: #6e6e77;
  margin-right: 8px;
}
.dashboard-header-search .MuiOutlinedInput-root .MuiSvgIcon-root {
  font-size: 16px;
  color: #6B7280;
}

.MuiInputBase-root .MuiOutlinedInput-notchedOutline {
  border-color: #BDBDC2;
}

.dashboard-heading .header-btns .revamp-extra-btn {
  display: none;
}

.dashboard-heading .header-btns .dashboard-refresh-btn.MuiButtonBase-root {
  border: 0;
  background: transparent;
  color: #2e75b6;
  min-height: 40px;
  min-width: 102px;
  padding: 8px 12px;
  flex-shrink: 0;
  align-self: center;
}
.dashboard-heading .header-btns .dashboard-refresh-btn.MuiButtonBase-root .MuiTypography-root {
  color: #2e75b6;
  font-weight: 400;
}
.dashboard-heading .header-btns .dashboard-refresh-btn.MuiButtonBase-root .MuiButton-startIcon {
  margin-right: 6px;
}
.dashboard-heading .header-btns .dashboard-refresh-btn.MuiButtonBase-root .MuiButton-startIcon .MuiSvgIcon-root {
  font-size: 18px;
}
.dashboard-heading .header-btns .dashboard-refresh-btn.MuiButtonBase-root:hover {
  border: 0;
  background: rgba(46, 117, 182, 0.08) !important;
}

.dashboard-heading .header-btns .MuiButton-contained {
  box-shadow: none;
}

.dashboard-heading .header-btns .send-link-btn.MuiButtonBase-root {
  border: 1px solid var(--color);
  background: #ffffff;
  color: #215c20;
  border-radius: 8px;
  min-height: 40px;
  padding: 8px 16px;
  text-transform: none;
  flex-shrink: 0;
}
.dashboard-heading .header-btns .send-link-btn.MuiButtonBase-root .MuiTypography-root {
  color: var(--color);
}
.dashboard-heading .header-btns .send-link-btn.MuiButtonBase-root .MuiButton-startIcon {
  margin-right: 8px;
}
.dashboard-heading .header-btns .send-link-btn.MuiButtonBase-root .MuiButton-startIcon svg {
  width: 16px;
  height: 16px;
}

.dashboard-heading .header-btns .MuiButton-contained.MuiButtonBase-root {
  background: var(--color);
  color: var(--color-contrast-text);
  flex-shrink: 0;
}
.dashboard-heading .header-btns .new-application-btn.MuiButtonBase-root {
  min-width: 192px;
}

.dashboard-heading .header-btns .MuiButtonBase-root {
  white-space: nowrap;
}

@media screen and (max-width: 900px) {
  .MuiStack-root.dashboard-heading {
    padding: 16px 20px;
    gap: 14px;
  }
  .dashboard-welcome-title {
    font-size: 28px;
  }
  .dashboard-welcome-subtitle {
    font-size: 14px;
    line-height: 20px;
  }
  .dashboard-status-chip {
    min-height: 32px;
    padding: 0 12px;
  }
  .dashboard-status-chip-label {
    font-size: 13px !important;
  }
  .dashboard-heading .header-btns {
    gap: 8px;
    min-width: 0;
  }
  .dashboard-header-search {
    flex: 1 1 auto;
    min-width: 100px;
    max-width: 370px;
  }
  .dashboard-heading .header-btns .MuiButtonBase-root {
    min-width: 0;
    padding-left: 12px;
    padding-right: 12px;
    min-height: 36px;
  }
  .dashboard-heading .header-btns .MuiButtonBase-root .MuiTypography-root {
    font-size: 13px;
  }
}
@media screen and (max-width: 600px) {
  .MuiStack-root.dashboard-heading {
    flex-wrap: nowrap;
    flex-direction: row;
    align-items: center;
  }
  .dashboard-heading .header-btns {
    gap: 8px;
    min-width: 0;
    align-items: center;
  }
  .dashboard-heading .header-btns .MuiButtonBase-root {
    width: 36px;
    height: 36px;
    min-width: 36px !important;
    min-height: 36px !important;
    padding: 0;
    flex-shrink: 0;
  }
  .dashboard-heading .header-btns .MuiButtonBase-root .MuiButton-startIcon {
    margin: 0;
  }
  .dashboard-heading .header-btns .MuiButtonBase-root .MuiTypography-root {
    font-size: 14px;
    line-height: 1;
  }
  .quote-history-actions .MuiButtonBase-root {
    width: 36px;
    height: 36px;
    min-width: 36px !important;
    min-height: 36px !important;
    padding: 0;
    flex-shrink: 0;
  }
  .quote-history-actions .MuiButtonBase-root .MuiButton-startIcon {
    margin: 0;
  }
  .quote-history-actions {
    gap: 8px;
    align-items: center;
  }
  .dashboard-header-search {
    flex: 1 1 auto;
    min-width: 80px;
  }
  .dashboard-heading .header-btns .dashboard-refresh-btn.MuiButtonBase-root {
    padding: 0;
  }
  .dashboard-status-chip {
    min-height: 30px;
    padding: 0 10px;
  }
  .dashboard-status-chip-label {
    font-size: 12px !important;
    line-height: 18px !important;
  }
  .dashboard-heading .header-btns .new-application-btn.MuiButtonBase-root {
    min-width: 0;
  }
}
.MuiPopover-root .MuiPaper-root .dialog-wrapper.MuiBox-root .each-create {
  border: 1px solid var(--color);
  margin: 8px 18px;
  padding: 6px;
  border-radius: 4px;
  cursor: pointer;
}
.MuiPopover-root .MuiPaper-root .dialog-wrapper.MuiBox-root .each-create .dialog-icon {
  background-color: #DDDEE9;
  height: 32px;
  width: 32px;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  display: flex;
}
.MuiPopover-root .MuiPaper-root .dialog-wrapper.MuiBox-root .each-create .dialog-icon svg {
  width: 19px;
  color: var(--color);
}
.MuiPopover-root .MuiPaper-root .dialog-wrapper.MuiBox-root .each-create .dialog-text .dialog-header {
  font-size: 14px;
  font-weight: 500;
  color: var(--color);
}
.MuiPopover-root .MuiPaper-root .dialog-wrapper.MuiBox-root .each-create .dialog-text .dialog-label {
  font-size: 14px;
  font-weight: 400;
  color: #718899;
}
.MuiPopover-root .MuiPaper-root .dialog-wrapper.MuiBox-root .each-create:hover {
  background-color: #EAF3F5;
}
.MuiPopover-root .MuiPaper-root .dialog-wrapper:not(:first-child) svg path {
  stroke: var(--color);
}
.MuiPopover-root .MuiPaper-root .dialog-wrapper:first-child .each-create {
  margin-top: 18px;
}
.MuiPopover-root .MuiPaper-root .dialog-wrapper:last-child .each-create {
  margin-bottom: 18px;
}

.cstPopover .MuiPaper-root {
  left: auto !important;
  top: 140px !important;
  right: 30px;
}
.cstPopover .cstLocIcon path {
  stroke: var(--color) !important;
}

.program-salesrep-dialog .MuiDialog-paper {
  border-radius: 12px;
  max-width: 600px;
  width: 100%;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);
}
.program-salesrep-dialog .select-app-type-dialog .select-app-type-header {
  background-color: #f5f5f5;
  border-bottom: 1px solid #e0e0e0;
}
.program-salesrep-dialog .select-app-type-dialog .select-app-type-header .select-app-type-title {
  font-size: 18px;
  font-weight: 600;
  color: #2b2b30;
}
.program-salesrep-dialog .select-app-type-dialog .select-app-type-header .select-app-type-close-btn {
  color: #666;
}
.program-salesrep-dialog .MuiGrid-root .MuiFormControl-root {
  width: 100%;
}
.program-salesrep-dialog .MuiGrid-root .MuiBox-root {
  animation: slideIn 0.3s ease-in-out;
}
@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.program-salesrep-dialog .MuiAutocomplete-paper {
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
  border-radius: 8px;
}
.program-salesrep-dialog .MuiAutocomplete-popper {
  max-width: 100% !important;
}
.program-salesrep-dialog .MuiAutocomplete-listbox {
  padding: 8px 0;
}
.program-salesrep-dialog .MuiAutocomplete-listbox .MuiAutocomplete-option:hover {
  background-color: rgba(66, 133, 244, 0.08);
}
.program-salesrep-dialog .MuiAutocomplete-listbox .MuiAutocomplete-option[aria-selected=true] {
  background-color: rgba(66, 133, 244, 0.12);
}
.program-salesrep-dialog .MuiAutocomplete-listbox .MuiAutocomplete-option[aria-selected=true]:hover {
  background-color: rgba(66, 133, 244, 0.12);
}
.program-salesrep-dialog .MuiOutlinedInput-root {
  border-radius: 8px;
  transition: all 0.2s ease-in-out;
}
.program-salesrep-dialog .MuiOutlinedInput-root:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}
.program-salesrep-dialog .MuiOutlinedInput-root.Mui-focused {
  box-shadow: 0 2px 12px rgba(66, 133, 244, 0.15);
}
.program-salesrep-dialog .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline {
  border-color: #f44336;
}
.program-salesrep-dialog .MuiInputLabel-root {
  color: #666;
}
.program-salesrep-dialog .MuiInputLabel-root.Mui-error {
  color: #f44336;
}
.program-salesrep-dialog .MuiFormHelperText-root {
  margin-top: 4px;
  font-size: 12px;
}
.program-salesrep-dialog .MuiFormHelperText-root.Mui-error {
  color: #f44336;
}
.program-salesrep-dialog .MuiButton-outlined {
  text-transform: none;
  color: var(--color);
  border-color: var(--color);
  border-radius: 8px;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease-in-out;
}
.program-salesrep-dialog .MuiButton-outlined:active {
  transform: scale(0.98);
}
.program-salesrep-dialog .MuiButton-contained {
  text-transform: none;
  background-color: var(--color);
  border-radius: 8px;
  padding: 8px 24px;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.2s ease-in-out;
  box-shadow: 0 2px 8px rgba(66, 133, 244, 0.3);
}
.program-salesrep-dialog .MuiButton-contained:hover {
  opacity: 0.88;
  box-shadow: 0 4px 12px rgba(66, 133, 244, 0.4);
}
.program-salesrep-dialog .MuiButton-contained:active {
  transform: scale(0.98);
}
.program-salesrep-dialog .MuiButton-contained:disabled {
  background-color: #ccc;
  box-shadow: none;
}
.program-salesrep-dialog .MuiBox-root[role=presentation] > .MuiBox-root {
  padding: 24px;
}

.create-app-dialog .MuiDialog-paper {
  border-radius: 12px;
  max-width: 480px;
  width: 100%;
}
.create-app-dialog .select-app-type-dialog {
  padding: 0;
}
.create-app-dialog .select-app-type-header {
  padding: 16px 20px;
}
.create-app-dialog .select-app-type-title {
  font-size: 16px;
  font-weight: 400;
  color: #10131f;
}
.create-app-dialog .select-app-type-close-btn {
  width: 32px;
  height: 32px;
}
.create-app-dialog .select-app-type-list {
  padding: 0 12px 12px;
}
.create-app-dialog .dialog-wrapper {
  cursor: pointer;
}
.create-app-dialog .dialog-wrapper .each-create {
  border: none;
  background-color: #f7f7f8;
  margin: 8px 6px;
  padding: 12px;
  border-radius: 8px;
}
.create-app-dialog .dialog-wrapper .each-create .dialog-icon {
  background-color: var(--color);
  height: 40px;
  width: 40px;
  min-width: 40px;
  border-radius: 8px;
  align-items: center;
  justify-content: center;
  display: flex;
}
.create-app-dialog .dialog-wrapper .each-create .dialog-icon svg {
  width: 20px;
  color: var(--color-contrast-text);
}
.create-app-dialog .dialog-wrapper .each-create .dialog-icon svg path {
  stroke: var(--color-contrast-text);
}
.create-app-dialog .dialog-wrapper .each-create .dialog-text .dialog-header {
  font-size: 15px;
  font-weight: 600;
  color: var(--color);
}
.create-app-dialog .dialog-wrapper .each-create .dialog-text .dialog-label {
  font-size: 13px;
  font-weight: 400;
  color: #718899;
}
.create-app-dialog .dialog-wrapper .each-create:hover {
  background-color: #ededf0;
}

.filtr-date-pkr .MuiOutlinedInput-root {
  background-color: #fff;
}
.filtr-date-pkr .MuiStack-root {
  padding: 0px;
  width: 100%;
}
.filtr-date-pkr.analyticsPicker .clear-date {
  top: 26px;
}
@media screen and (max-width: 1024px) {
  .filtr-date-pkr.analyticsPicker .clear-date {
    top: 8px;
  }
}

.dashboard-application {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 0px 24px;
}
.dashboard-application .reset-search-btn {
  display: flex;
  align-items: center;
  gap: 10px;
  position: relative;
  top: 17px;
}
@media only screen and (min-width: 481px) and (max-width: 768px) {
  .dashboard-application .reset-search-btn {
    top: 0;
  }
}
@media only screen and (min-width: 320px) and (max-width: 480px) {
  .dashboard-application .reset-search-btn {
    top: 0;
  }
}

.dashboard-filters-panel {
  max-width: 1300px;
  margin: 20px auto 8px;
  padding: 18px;
  background: #ffffff;
  border: 1px solid #dfe3ef;
  border-radius: 14px;
  box-shadow: 0 6px 20px rgba(24, 39, 75, 0.05);
}

.dashboard-filters-panel .reset-search-btn {
  width: 100%;
  gap: 12px;
}

.dashboard-filters-panel .filtr-search {
  width: 100%;
}

.dashboard-filters-panel .filtr-search .MuiFormControl-root {
  width: 100%;
}

.dashboard-reset-stack .btn-txt {
  height: 40px;
  border-radius: 10px;
  border-color: #cfd6e6;
  color: #2a3555;
  font-weight: 600;
}

.dashboard-queue-heading {
  max-width: 100% !important;
  padding: 0 0px;
  border-radius: 8px;
  flex-shrink: 0;
}

.dashboard-queue-heading .queue-heading-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.dashboard-queue-heading .queue-heading-icon {
  width: 28px;
  height: 28px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
}
.dashboard-queue-heading .queue-heading-icon svg {
  width: 20px;
  height: 20px;
}

.dashboard-queue-heading .queue-heading-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.dashboard-queue-heading .queue-title-line {
  display: flex;
  align-items: baseline;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
}

.dashboard-queue-heading .queue-title {
  flex-shrink: 0;
  font-size: 16px;
  font-weight: 600;
  color: #6E6E77;
  font-family: var(--font-family) !important;
  line-height: 1.3;
}

.dashboard-queue-heading .queue-subtitle {
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
  font-size: 14px;
  font-weight: 400;
  color: #3D3D42;
  font-family: var(--font-family) !important;
  line-height: 1.4;
}

.dashboard-kpi-grid {
  max-width: 100% !important;
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 16px;
  padding: 0px 10px;
  flex-shrink: 0;
  transform: translateZ(0);
  will-change: transform;
}

.kpi-card {
  background: #ffffff;
  border: 1px solid #d7d7da;
  border-radius: 8px;
  height: 69px;
  padding: 0;
  display: flex;
  align-items: stretch;
  gap: 8px;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}
.kpi-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-1px);
}

.kpi-card.kpi-card-enter {
  opacity: 0;
  transform: translateY(26px);
  animation: dashboardKpiCardRiseUp 0.55s cubic-bezier(0.22, 0.9, 0.32, 1) forwards;
}
.kpi-card.kpi-card-enter:nth-child(1) {
  animation-delay: 0s;
}
.kpi-card.kpi-card-enter:nth-child(2) {
  animation-delay: 0.1s;
}
.kpi-card.kpi-card-enter:nth-child(3) {
  animation-delay: 0.2s;
}
.kpi-card.kpi-card-enter:nth-child(4) {
  animation-delay: 0.3s;
}
.kpi-card.kpi-card-enter:nth-child(5) {
  animation-delay: 0.4s;
}
.kpi-card.kpi-card-enter:nth-child(6) {
  animation-delay: 0.5s;
}

@keyframes dashboardKpiCardRiseUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@media screen and (max-width: 1024px) {
  .kpi-card.kpi-card-enter {
    transform: translateX(-18px);
    animation-name: dashboardKpiCardCascadeIn;
    animation-duration: 0.48s;
    animation-timing-function: cubic-bezier(0.16, 0.84, 0.44, 1);
  }
  .kpi-card.kpi-card-enter:nth-child(1) {
    animation-delay: 0s;
  }
  .kpi-card.kpi-card-enter:nth-child(2) {
    animation-delay: 0.07s;
  }
  .kpi-card.kpi-card-enter:nth-child(3) {
    animation-delay: 0.14s;
  }
  .kpi-card.kpi-card-enter:nth-child(4) {
    animation-delay: 0.21s;
  }
  .kpi-card.kpi-card-enter:nth-child(5) {
    animation-delay: 0.28s;
  }
  .kpi-card.kpi-card-enter:nth-child(6) {
    animation-delay: 0.35s;
  }
  @keyframes dashboardKpiCardCascadeIn {
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }
}
@media (prefers-reduced-motion: reduce) {
  .kpi-card.kpi-card-enter {
    animation: none;
    opacity: 1;
    transform: none;
  }
}
.kpi-card-left {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 7px;
  width: 32px;
  height: 67px;
  padding: 6px 12px;
  background: #f2f2f3;
  border-radius: 4px 0 0 8px;
}

.kpi-card-left .kpi-count {
  font-size: 24px;
  line-height: 28px;
  font-weight: 700;
  color: #3d3d42;
  font-family: var(--font-family) !important;
}

.kpi-card-right {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 11px;
  justify-content: center;
  padding: 12px 8px 12px 0;
  flex: 1;
  min-width: 0;
}

.kpi-icon {
  width: 20px;
  height: 20px;
  border-radius: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}
.kpi-icon svg {
  width: 100%;
  height: 100%;
}

.kpi-label {
  font-size: 12px !important;
  line-height: 14px;
  font-weight: 500;
  font-family: var(--font-family) !important;
  white-space: nowrap;
  text-align: left;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.kpi-card-right .kpi-amount {
  font-size: clamp(14px, 1.05vw, 16px);
  line-height: 19px;
  color: #3d3d42;
  font-weight: 400;
  font-family: var(--font-family) !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.kpi-danger .kpi-icon {
  color: #f00214;
}
.kpi-danger .kpi-label {
  color: #f00214;
}

.kpi-card.kpi-danger {
  border-left: 4px solid #f00214;
}

.kpi-success .kpi-icon {
  color: #12b981;
}
.kpi-success .kpi-label {
  color: #12b981;
}

.kpi-card.kpi-success {
  border-left: 4px solid #12b981;
}

.kpi-warning .kpi-icon {
  color: #6E6E77;
}
.kpi-warning .kpi-label {
  color: #6E6E77;
}

.kpi-card.kpi-warning {
  border-left: 4px solid #6E6E77;
}

.kpi-info .kpi-icon {
  color: #4F46E5;
}
.kpi-info .kpi-label {
  color: #4F46E5;
}

.kpi-card.kpi-info {
  border-left: 4px solid #4F46E5;
}

.kpi-neutral .kpi-icon {
  color: #18181b;
}
.kpi-neutral .kpi-label {
  color: #18181b;
}

.kpi-card.kpi-neutral {
  border-left: 4px solid #18181b;
}

.kpi-request-docs .kpi-icon {
  color: #CC4F00;
}
.kpi-request-docs .kpi-label {
  color: #CC4F00;
}

.kpi-card.kpi-request-docs {
  border-left: 4px solid #CC4F00;
}

.kpi-docs-out .kpi-icon {
  color: #2E75B6;
}
.kpi-docs-out .kpi-label {
  color: #2E75B6;
}

.kpi-card.kpi-docs-out {
  border-left: 4px solid #2E75B6;
}

.kpi-card.kpi-teal {
  border-left: 4px solid #08704E;
}

.kpi-teal .kpi-icon {
  color: #08704E;
}
.kpi-teal .kpi-label {
  color: #08704E;
}

.kpi-card.kpi-danger.active {
  border: 1.5px solid #f00214;
  border-left: 4px solid #f00214;
  box-shadow: 0px 2px 12px 8px rgba(239, 121, 131, 0.0784313725);
}

.kpi-card.kpi-success.active {
  border: 1.5px solid #12b981;
  border-left: 4px solid #12b981;
  box-shadow: 0px 2px 12px 8px rgba(18, 185, 129, 0.08);
}

.kpi-card.kpi-warning.active {
  border: 1.5px solid #6E6E77;
  border-left: 4px solid #6E6E77;
  box-shadow: 0px 2px 12px 8px rgba(61, 61, 66, 0.1215686275);
}

.kpi-card.kpi-info.active {
  border: 1.5px solid #4F46E5;
  border-left: 4px solid #4F46E5;
  box-shadow: 0px 2px 12px 8px rgba(79, 70, 229, 0.0784313725);
}

.kpi-card.kpi-neutral.active {
  border: 1.5px solid #18181b;
  border-left: 4px solid #18181b;
  box-shadow: 0px 2px 12px 8px rgba(24, 24, 27, 0.08);
}

.kpi-card.kpi-request-docs.active {
  border: 1.5px solid #CC4F00;
  border-left: 4px solid #CC4F00;
  box-shadow: 0px 2px 12px 8px rgba(153, 59, 0, 0.0784313725);
}

.kpi-card.kpi-docs-out.active {
  border: 1.5px solid #2E75B6;
  border-left: 4px solid #2E75B6;
  box-shadow: 0px 2px 12px 8px rgba(46, 117, 182, 0.0784313725);
}

.kpi-card.kpi-teal.active {
  border: 1.5px solid #08704E;
  border-left: 4px solid #08704E;
  box-shadow: 0px 2px 12px 8px rgba(13, 148, 104, 0.0784313725);
}

.kpi-card.search-disabled {
  opacity: 0.35;
  cursor: not-allowed;
  pointer-events: none;
}
.kpi-card.search-disabled:hover {
  box-shadow: none;
  transform: none;
}

.dashboard-queue-scroll-wrap {
  flex: 1 1 0;
  min-height: 0;
  position: relative;
  display: flex;
  flex-direction: row;
  overflow: visible;
}

.dashboard-action-queue-list {
  max-width: 100% !important;
  padding: 10px 10px 8px 10px;
  display: flex;
  flex-direction: column;
  flex: 1 1 0;
  min-height: 0;
  overflow-y: auto;
  overflow-x: visible;
  overscroll-behavior: contain;
  scrollbar-width: none;
}
.dashboard-action-queue-list::-webkit-scrollbar {
  display: none;
}

.dashboard-queue-scrollbar-track {
  position: absolute;
  top: 6px;
  bottom: 0;
  right: -18px;
  width: 8px;
  background: #d0d0d4;
  border-radius: 999px;
}

.dashboard-queue-scrollbar-thumb {
  position: absolute;
  left: 0;
  width: 100%;
  border-radius: 999px;
  background: #8e8e9a;
  cursor: pointer;
}
.dashboard-queue-scrollbar-thumb:hover {
  background: #6e6e77;
}

.action-queue-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 8px;
  padding: 16px 10px 8px 10px;
}

@media screen and (min-width: 601px) and (max-width: 1024px) {
  .action-queue-card {
    flex-wrap: wrap;
    row-gap: 8px;
  }
  .dashboard-queue-heading .queue-heading-row {
    flex: 1 1 100%;
    min-width: 0;
  }
  .action-queue-card .queue-sort-trigger {
    margin-left: auto;
  }
}
.action-queue-card-item {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px 12px 24px;
  gap: 10px;
  position: relative;
  isolation: isolate;
  background: #ffffff;
  border-radius: 8px;
  transition: box-shadow 0.2s ease, border-color 0.2s ease, background 0.2s ease;
}
.action-queue-card-item:active {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
}

.action-queue-card-item.queue-card-enter {
  opacity: 0;
  transform: translateY(26px);
  animation: dashboardQueueCardRiseUp 0.55s cubic-bezier(0.22, 0.9, 0.32, 1) forwards;
}
.action-queue-card-item.queue-card-enter:nth-child(1) {
  animation-delay: 0s;
}
.action-queue-card-item.queue-card-enter:nth-child(2) {
  animation-delay: 0.1s;
}
.action-queue-card-item.queue-card-enter:nth-child(3) {
  animation-delay: 0.2s;
}
.action-queue-card-item.queue-card-enter:nth-child(4) {
  animation-delay: 0.3s;
}
.action-queue-card-item.queue-card-enter:nth-child(5) {
  animation-delay: 0.4s;
}
.action-queue-card-item.queue-card-enter:nth-child(6) {
  animation-delay: 0.5s;
}
.action-queue-card-item.queue-card-enter:nth-child(7) {
  animation-delay: 0.6s;
}
.action-queue-card-item.queue-card-enter:nth-child(8) {
  animation-delay: 0.7s;
}
.action-queue-card-item.queue-card-enter:nth-child(n+9) {
  animation-delay: 0.7s;
}

@keyframes dashboardQueueCardRiseUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@media (prefers-reduced-motion: reduce) {
  .action-queue-card-item.queue-card-enter {
    animation: none;
    opacity: 1;
    transform: none;
  }
}
.dashboard-action-queue-list.kpi-danger .action-queue-card-item:hover {
  box-shadow: 0 0 10px 2px #b8bec7;
  border-color: #d8dde8;
  cursor: pointer;
}

.dashboard-action-queue-list.kpi-request-docs .action-queue-card-item:hover {
  box-shadow: 0 0 10px 2px #b8bec7;
  border-color: #d8dde8;
  cursor: pointer;
}

.dashboard-action-queue-list.kpi-docs-out .action-queue-card-item:hover {
  box-shadow: 0 0 10px 2px #b8bec7;
  border-color: #d8dde8;
  cursor: pointer;
}

.dashboard-action-queue-list.kpi-warning .action-queue-card-item:hover {
  box-shadow: 0 0 10px 2px #b8bec7;
  border-color: #d8dde8;
  cursor: pointer;
}

.dashboard-action-queue-list.kpi-info .action-queue-card-item:hover {
  box-shadow: 0 0 10px 2px #b8bec7;
  border-color: #d8dde8;
  cursor: pointer;
}

.dashboard-action-queue-list.kpi-teal .action-queue-card-item:hover {
  box-shadow: 0 0 10px 2px #b8bec7;
  border-color: #d8dde8;
  cursor: pointer;
}

.action-queue-card-item.action-queue-card-action-needed {
  flex-direction: column;
  align-items: stretch;
  padding: 12px 16px;
  gap: 0;
}

.action-needed-top-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}

.action-needed-title-meta-col {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
}

.action-needed-company {
  font-size: 20px !important;
  font-weight: 700 !important;
  color: #3D3D42 !important;
  font-family: var(--font-family) !important;
  line-height: normal;
  min-width: 0;
}

.action-needed-top-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}

.action-needed-meta-row {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 18px;
  margin-bottom: 12px;
  margin-top: 5px;
  font-family: var(--font-family) !important;
  font-size: 14px;
}
.action-needed-meta-row .action-needed-meta-item {
  font-size: 14px;
  font-family: var(--font-family) !important;
  color: #6E6E77;
}
.action-needed-meta-row .action-needed-meta-item strong {
  font-weight: 600;
  color: #111827;
}

.action-needed-pills-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 10px;
}

.action-needed-reasons-divider.MuiDivider-root {
  border-color: #D7D7DA;
  margin: 0 -16px;
}

.action-needed-pill {
  display: inline-flex;
  align-items: center;
  border: 1px solid #A2A2A9;
  border-radius: 4px;
  padding: 4px 8px;
  gap: 8px;
  font-size: 12px;
  color: #374151;
  font-family: var(--font-family) !important;
  white-space: nowrap;
}
.action-needed-pill.action-needed-pill-blue {
  background: #EFF6FF;
  border-color: #BFDBFE;
  color: #2E75B6;
}
.action-needed-pill.action-needed-pill-docs-sent {
  border: none;
  background: #F2F2F3;
  border-radius: 4px;
}
.action-needed-pill.action-needed-pill-in-queue {
  background: #FFF8E9;
  border-color: #C8BA9D;
  gap: 4px;
}

.action-needed-pill-combined {
  gap: 0;
}

.action-needed-pill-divider {
  color: #bdbdc2;
  font-weight: 300;
  margin: 0 10px;
  line-height: 1;
  user-select: none;
}

.action-needed-pill-key {
  font-weight: 400;
  color: #6E6E77;
  margin-right: 2px;
}

.action-needed-pill-value {
  font-weight: 500;
  color: #3D3D42;
}

.action-needed-pill-value-primary {
  color: var(--color);
}

.action-needed-pill-blue .action-needed-pill-key {
  font-weight: 600;
  color: #2E75B6;
}
.action-needed-pill-blue .action-needed-pill-value {
  font-weight: 600;
  color: #2E75B6;
}

.action-needed-pill-in-queue .action-needed-pill-key {
  color: #993B00;
}
.action-needed-pill-in-queue .action-needed-pill-value {
  color: #993B00;
}

.action-needed-reasons {
  background: #FFFFFF;
  border-radius: 8px;
  padding: 12px 0 8px;
}

.action-needed-reasons-heading {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
}

.action-needed-reasons-title {
  font-size: 14px !important;
  font-weight: 600 !important;
  color: #ED0012 !important;
  font-family: var(--font-family) !important;
  line-height: 16px;
}

.action-needed-reasons-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0;
  border: 1px solid #D7D7DA;
  border-radius: 8px;
  overflow: hidden;
}
.action-needed-reasons-grid.action-needed-reasons-grid--single {
  grid-template-columns: 1fr;
  width: 50%;
}
.action-needed-reasons-grid.action-needed-reasons-grid--single .action-needed-reason-item {
  grid-column: auto !important;
  border-right: none !important;
}

.action-needed-reason-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  font-size: 14px;
  color: #3D3D42;
  font-family: var(--font-family) !important;
  font-weight: 400;
  box-sizing: border-box;
  background: #F7F7F8;
  padding: 8px;
  min-height: 40px;
  border-bottom: 1px solid #D7D7DA;
}
.action-needed-reason-item:hover {
  background-color: #FFFFFF;
}
.action-needed-reason-item:nth-child(odd) {
  border-right: 1px solid #D7D7DA;
}
.action-needed-reason-item:last-child {
  border-bottom: none;
}
.action-needed-reason-item:nth-last-child(2):nth-child(odd) {
  border-bottom: none;
}

.action-needed-reason-item--no-subtitle {
  align-items: center;
}

.action-needed-reason-item--filler {
  gap: 0;
}
.action-needed-reason-item--filler:hover {
  background-color: #F7F7F8;
}

.action-needed-reason-status {
  display: flex;
  flex-shrink: 0;
  color: #BDBDC2;
}
.action-needed-reason-status svg {
  width: 18px;
  height: 18px;
}
.action-needed-reason-status.action-needed-reason-status--done {
  color: #0D9468;
}

.action-needed-reason-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  flex: 1;
}

.action-needed-reason-title {
  font-size: 14px !important;
  font-weight: 600 !important;
  color: #000000 !important;
  font-family: var(--font-family) !important;
  line-height: 16px !important;
}

.action-needed-reason-doc-chip-gap {
  font-size: 0;
  margin-right: 10px;
  vertical-align: top;
}

.action-needed-reason-doc-chip {
  display: inline-block;
  padding: 2px 6px;
  border-radius: 4px;
  background-color: #E4E4E7;
  color: #3F3F46;
  font-family: var(--font-family);
  font-size: 12px;
  font-weight: 400;
  line-height: 12px;
  white-space: nowrap;
  vertical-align: top;
}

.action-needed-reason-subtitle {
  font-size: 12px !important;
  font-weight: 400 !important;
  color: #6E6E77 !important;
  font-family: var(--font-family) !important;
  line-height: 14px !important;
}

.action-needed-reason-action {
  flex-shrink: 0;
  color: #2E75B6 !important;
  font-size: 12px !important;
  font-weight: 400 !important;
  line-height: 14px !important;
  text-transform: none !important;
  min-width: unset !important;
  white-space: nowrap;
  border: 1px solid #2E75B6;
  min-height: 26px !important;
  height: 26px !important;
  box-shadow: none;
  border-radius: 6px !important;
  padding: 0 10px !important;
}
.action-needed-reason-action .MuiButton-startIcon,
.action-needed-reason-action .MuiButton-endIcon {
  margin: 0;
}
.action-needed-reason-action .MuiButton-startIcon {
  margin-right: 4px;
}
.action-needed-reason-action .MuiButton-endIcon {
  margin-left: 4px;
}
.action-needed-reason-action:hover {
  background-color: rgba(46, 117, 182, 0.08) !important;
}
.action-needed-reason-action.Mui-disabled {
  color: rgba(0, 0, 0, 0.26) !important;
}
.action-needed-reason-action.Mui-disabled:hover {
  background-color: transparent !important;
}

@media screen and (max-width: 768px) {
  .action-queue-card-item.action-queue-card-action-needed {
    padding: 14px 14px;
  }
  .action-needed-top-row {
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 10px;
  }
  .action-needed-company {
    font-size: 16px !important;
  }
  .action-needed-title-meta-col {
    flex: 1 1 100%;
  }
  /* 601px–768px: actions stay in the top row, pushed right */
}
@media screen and (max-width: 768px) and (min-width: 601px) {
  .action-needed-top-actions {
    flex: 1 1 auto;
    justify-content: flex-end;
    flex-wrap: nowrap;
    gap: 6px;
    align-items: center;
  }
}
@media screen and (max-width: 768px) {
  .action-needed-meta-row {
    gap: 4px 16px;
    margin-bottom: 10px;
  }
  .action-needed-reasons-grid {
    grid-template-columns: 1fr;
  }
  .action-needed-reasons-grid.action-needed-reasons-grid--single {
    width: 100%;
  }
  .action-needed-reason-item:nth-child(odd) {
    border-right: none;
  }
  .action-needed-reason-item:nth-last-child(2) {
    border-bottom: 1px solid #D7D7DA;
  }
  .action-needed-reason-item:last-child {
    border-bottom: none;
  }
  .action-needed-reason-item--filler {
    display: none;
  }
  .action-needed-reason-item:has(+ .action-needed-reason-item--filler) {
    border-bottom: none;
  }
}
@media screen and (max-width: 480px) {
  .action-needed-pill {
    font-size: 12px;
    padding: 3px 8px;
  }
  .action-needed-meta-row .action-needed-meta-item {
    font-size: 13px;
  }
}
.action-queue-empty-state {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px 16px;
  background: #ffffff;
  border: 1px solid #f2f2f3;
  border-radius: 8px;
}

.action-queue-empty-icon-wrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.action-queue-empty-icon {
  font-size: 44px !important;
  color: #6e6e77;
}

.action-queue-empty-text {
  color: #3D3D42;
  font-family: var(--font-family) !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  line-height: normal !important;
  text-align: center;
  padding-top: 20px;
}

.action-queue-empty-subtext {
  color: #6E6E77;
  font-family: var(--font-family) !important;
  font-size: 12px !important;
  font-weight: 400 !important;
  line-height: normal !important;
  text-align: center;
  padding-top: 8px;
}

.dashboard-accordian {
  max-width: 1300px;
  margin: 0 auto;
}

.action-queue-main {
  min-width: 0;
  flex: 1;
}
.action-queue-main .contract-id {
  font-weight: 600;
  color: #6E6E77;
  margin-left: 4px;
}

.action-queue-header {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 15px;
}
.action-queue-header .company {
  font-size: 16px;
  line-height: normal;
  font-weight: 500;
  color: #000000;
  font-family: var(--font-family) !important;
}

.status-pill {
  border: 1px solid #bdbdc2;
  background: #ffffff;
  border-radius: 24px;
  font-size: 12px !important;
  line-height: normal;
  color: #3d3d42;
  padding: 0 8px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  font-family: var(--font-family) !important;
  font-weight: 400;
}

.status-pill.soft {
  background: #f9f9f9;
  border-color: #d7d7da;
  border-radius: 100px;
}

.status-pill.time {
  border: none;
  color: #6e6e77;
  padding: 0;
  border-radius: 0;
  background: transparent;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  line-height: normal;
  font-family: var(--font-family) !important;
  font-weight: 400;
  white-space: nowrap;
}
.status-pill.time svg {
  width: 12px;
  height: 12px;
}

.equipment-line {
  margin: 0 0 12px;
  color: #6E6E77;
  font-size: 14px;
  line-height: 20px;
  font-family: var(--font-family) !important;
}

.action-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0 8px;
  border-radius: 4px;
  background: rgba(249, 154, 162, 0.2);
  color: #f00214;
  font-size: 12px;
  line-height: normal;
  font-weight: 400;
}
.action-pill .MuiTypography-root {
  color: #f00214;
  font-size: 12px;
  line-height: normal;
  font-family: var(--font-family) !important;
  font-weight: 400;
}
.action-pill .queue-arrow-sm,
.action-pill .queue-arrow-lg {
  width: 12px;
  height: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.action-pill .queue-arrow-sm svg,
.action-pill .queue-arrow-lg svg {
  display: block;
  width: 100%;
  height: 100%;
}
.action-pill.success {
  background: rgba(18, 185, 129, 0.2);
  color: #12b981;
}
.action-pill.success .MuiTypography-root {
  color: #12b981;
}
.action-pill.warning {
  background: rgba(248, 184, 75, 0.2);
  color: #f8b84b;
}
.action-pill.warning .MuiTypography-root {
  color: #f8b84b;
}
.action-pill.info {
  background: rgba(0, 102, 244, 0.2);
  color: #0066f4;
}
.action-pill.info .MuiTypography-root {
  color: #0066f4;
}
.action-pill.neutral {
  background: rgba(24, 24, 27, 0.08);
  color: #18181b;
}
.action-pill.neutral.clickable {
  cursor: pointer;
}
.action-pill.neutral .MuiTypography-root {
  color: #18181b;
}
.action-pill.orange {
  background: rgba(249, 115, 22, 0.15);
  color: #f97316;
}
.action-pill.orange .MuiTypography-root {
  color: #f97316;
}
.action-pill.teal {
  background: rgba(20, 184, 166, 0.15);
  color: #14b8a6;
}
.action-pill.teal .MuiTypography-root {
  color: #14b8a6;
}

.action-queue-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  padding-left: 24px;
  justify-content: flex-end;
}

.action-queue-actions .queue-icon-btn.MuiButtonBase-root,
.action-needed-top-actions .queue-icon-btn.MuiButtonBase-root {
  width: 32px;
  height: 32px;
  border-radius: 6px;
  background: #ffffff;
  color: #18181b;
  border: 1px solid #D7D7DA;
}
.action-queue-actions .queue-icon-btn.MuiButtonBase-root svg,
.action-needed-top-actions .queue-icon-btn.MuiButtonBase-root svg {
  width: 16px;
  height: 16px;
}
.action-queue-actions .queue-icon-btn.MuiButtonBase-root:hover,
.action-needed-top-actions .queue-icon-btn.MuiButtonBase-root:hover {
  background: #f9fafc;
}
.action-queue-actions .action-file-upload-btn.MuiButtonBase-root,
.action-needed-top-actions .action-file-upload-btn.MuiButtonBase-root {
  text-transform: none;
  min-width: unset;
  min-height: 32px !important;
  height: 32px !important;
  font-family: var(--font-family) !important;
  box-shadow: none;
  border-radius: 6px !important;
  padding: 8px 16px !important;
  font-weight: 400 !important;
  font-size: 12px !important;
}
.action-queue-actions .action-file-upload-btn.MuiButtonBase-root .MuiButton-startIcon > *,
.action-needed-top-actions .action-file-upload-btn.MuiButtonBase-root .MuiButton-startIcon > * {
  width: 16px;
  height: 16px;
  font-size: 16px;
}
.action-queue-actions .action-file-upload-btn.MuiButtonBase-root:hover,
.action-needed-top-actions .action-file-upload-btn.MuiButtonBase-root:hover {
  border: 1px solid #D7D7DA !important;
}
.action-queue-actions .action-open-btn.MuiButtonBase-root,
.action-needed-top-actions .action-open-btn.MuiButtonBase-root {
  border-radius: 8px;
  text-transform: none;
  min-width: unset;
  min-height: 32px !important;
  height: 32px !important;
  padding: 8px 18px;
  font-weight: 400;
  font-size: 13px;
  line-height: normal;
  font-family: var(--font-family) !important;
  box-shadow: none;
}
.action-queue-actions .action-open-btn.MuiButtonBase-root .MuiButton-startIcon > *,
.action-needed-top-actions .action-open-btn.MuiButtonBase-root .MuiButton-startIcon > * {
  width: 16px;
  height: 16px;
  font-size: 16px;
}
.action-queue-actions .action-open-btn.MuiButtonBase-root:hover,
.action-needed-top-actions .action-open-btn.MuiButtonBase-root:hover {
  opacity: 0.95;
}
.action-queue-actions .action-needed-edit-btn-outlined.MuiButtonBase-root,
.action-needed-top-actions .action-needed-edit-btn-outlined.MuiButtonBase-root {
  background: #ffffff !important;
  color: var(--color) !important;
  border: 1px solid var(--color) !important;
  border-radius: 6px !important;
  padding: 8px 24px !important;
  font-weight: 400 !important;
  font-size: 12px !important;
}
.action-queue-actions .action-needed-edit-btn-outlined.MuiButtonBase-root:hover,
.action-needed-top-actions .action-needed-edit-btn-outlined.MuiButtonBase-root:hover {
  background: #F5F6F8 !important;
  opacity: 1;
}

.queue-contact-tooltip.MuiPaper-root {
  background: #6E6E77;
  color: #ffffff;
  border-radius: 4px;
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.35);
  padding: 10px 12px;
  overflow: visible;
  width: 277px;
}
.queue-contact-tooltip.MuiPaper-root::after {
  content: "";
  position: absolute;
  left: 50%;
  bottom: -6px;
  width: 12px;
  height: 12px;
  background: #6E6E77;
  transform: translateX(-50%) rotate(45deg);
}

.queue-contact-tooltip-content {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.queue-contact-tooltip-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 5px;
}

.queue-contact-tooltip-text {
  flex: 1;
  min-width: 0;
  font-size: 14px;
  line-height: 16px;
  color: #ffffff;
  font-family: var(--font-family) !important;
  overflow-wrap: anywhere;
  word-break: break-all;
}

.dashboard-icon-tooltip.MuiTooltip-tooltip {
  background: #6E6E77 !important;
  color: #ffffff !important;
  border-radius: 4px !important;
  padding: 8px !important;
}

.MuiTooltip-popper[data-popper-placement*=top] .dashboard-icon-tooltip.MuiTooltip-tooltip {
  margin-bottom: 4px !important;
}

.MuiTooltip-popper[data-popper-placement*=bottom] .dashboard-icon-tooltip.MuiTooltip-tooltip {
  margin-top: 4px !important;
}

.dashboard-icon-tooltip-arrow.MuiTooltip-arrow {
  color: #6E6E77 !important;
  font-size: 15px !important;
}

.queue-contact-copy-btn.MuiButtonBase-root {
  width: 24px;
  height: 24px;
  color: #ffffff;
  padding: 0;
  border-radius: 4px;
  flex-shrink: 0;
}
.queue-contact-copy-btn.MuiButtonBase-root:hover {
  background: rgba(255, 255, 255, 0.16);
}

@media screen and (max-width: 1024px) {
  .dashboard-kpi-grid {
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    gap: 12px;
    padding-bottom: 8px;
    scrollbar-width: none;
    padding: 0px 10px;
  }
  .dashboard-kpi-grid::-webkit-scrollbar {
    display: none;
  }
  .kpi-card {
    flex-shrink: 0;
    width: 180px;
    height: 75px;
  }
}
.create-app-container .stepper-wrapper {
  background-color: #EAF3F5;
  padding: 16px;
}
.create-app-container .stepper-wrapper .arrow-icon-btn {
  border: 1px solid #C2C7D0;
  border-radius: 4px;
  padding: 16px;
}
.create-app-container .stepper-wrapper .stepper-wrapper-arrows {
  display: flex;
  align-items: center;
  max-width: 100%;
  margin: 0px auto;
}
.create-app-container .stepper-wrapper .stepper-wrapper-arrows .arrow-icon-btn {
  padding: 14px 16px;
  display: flex;
  align-items: center;
}
.create-app-container .stepper-wrapper p {
  padding-top: 6px;
  font-size: 12px;
  font-weight: 600;
}
@media (max-width: 576px) {
  .create-app-container .stepper-wrapper .stepper-wrapper-arrows {
    max-width: 100%;
  }
  .create-app-container .stepper-wrapper .stepper-wrapper-arrows .arrow-icon-btn {
    display: none;
  }
  .create-app-container .stepper-wrapper .stepper-container {
    max-width: 100%;
  }
  .create-app-container .stepper-wrapper .stepper-container .MuiStepper-root .MuiStep-root .MuiStepLabel-root .MuiStepLabel-labelContainer {
    display: none;
  }
}
@media (max-width: 900px) {
  .create-app-container .stepper-wrapper .stepper-wrapper-arrows {
    max-width: 100%;
  }
}
.create-app-container .footer-wrapper {
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 999;
  background-color: #F3F4F6;
  border-top: 1px solid #c2c7d0;
}
.create-app-container .footer-wrapper .footer-content {
  padding: 8px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.create-app-container .footer-wrapper .tc-pp-container {
  display: flex;
  flex-direction: row;
}
.create-app-container .footer-wrapper .tc-pp-container .hr-divider {
  padding: 0 10px;
}
.create-app-container .footer-wrapper .tc-pp-container p {
  font-size: 14px;
  color: gray;
  text-decoration: underline;
}
@media screen and (min-width: 1200px) {
  .create-app-container .stepper-wrapper {
    padding: 8px 16px;
  }
  .create-app-container .stepper-wrapper p {
    padding-top: 0px;
  }
}

.bg-white {
  background-color: #ffffff !important;
}

.dashboard-accordian {
  padding: 8px 24px 24px;
}
.dashboard-accordian .MuiPaper-root.MuiAccordion-root {
  box-shadow: none;
  border: 1px solid #d7deec;
  margin-bottom: 14px;
  border-radius: 12px;
  overflow: hidden;
}
.dashboard-accordian .MuiPaper-root.MuiAccordion-root.Mui-expanded {
  border-style: none;
}
.dashboard-accordian .MuiPaper-root.MuiAccordion-root .MuiAccordionSummary-root {
  min-height: 60px;
  background: #ffffff;
}
.dashboard-accordian .MuiPaper-root.MuiAccordion-root .MuiAccordionSummary-root.Mui-expanded {
  border: 1px solid #d7deec;
  border-radius: 12px;
  margin: 0px;
}
.dashboard-accordian .MuiPaper-root.MuiAccordion-root .MuiAccordionSummary-root .MuiAccordionSummary-content {
  justify-content: space-between;
  align-items: center;
  margin-right: 10px;
}
.dashboard-accordian .MuiPaper-root.MuiAccordion-root .MuiAccordionSummary-root .MuiAccordionSummary-content.Mui-expanded {
  margin: 0px 10px 0px 0px;
}
.dashboard-accordian .MuiPaper-root.MuiAccordion-root .MuiAccordionSummary-root .MuiAccordionSummary-content .warning {
  font-size: 17px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 5px;
}
.dashboard-accordian .MuiPaper-root.MuiAccordion-root .MuiAccordionSummary-root .MuiAccordionSummary-content .warning .MuiButtonBase-root {
  font-size: 12px;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  color: #fff;
}
.dashboard-accordian .MuiPaper-root.MuiAccordion-root .MuiAccordionSummary-root .MuiAccordionSummary-content .warning-amount {
  font-size: 26px;
  font-weight: 600;
}
.dashboard-accordian .MuiPaper-root.MuiAccordion-root .MuiAccordionSummary-root .MuiAccordionSummary-content .sucess {
  color: #4caf50;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 5px;
}
.dashboard-accordian .MuiPaper-root.MuiAccordion-root .MuiAccordionSummary-root .MuiAccordionSummary-content .sucess .MuiButtonBase-root {
  font-size: 12px;
  background: #4caf50;
  border-radius: 50%;
  width: 17px;
  height: 17px;
  color: #fff;
}
.dashboard-accordian .MuiPaper-root.MuiAccordion-root .MuiAccordionSummary-root .MuiAccordionSummary-content .sucess-amount {
  color: #4caf50;
  font-size: 26px;
}
.dashboard-accordian .MuiPaper-root.MuiAccordion-root .MuiAccordionSummary-root .MuiAccordionSummary-content .error {
  color: #ee5b3a;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 5px;
}
.dashboard-accordian .MuiPaper-root.MuiAccordion-root .MuiAccordionSummary-root .MuiAccordionSummary-content .error .MuiButtonBase-root {
  font-size: 12px;
  background: #ee5b3a;
  border-radius: 50%;
  width: 17px;
  height: 17px;
  color: #fff;
}
.dashboard-accordian .MuiPaper-root.MuiAccordion-root .MuiAccordionSummary-root .MuiAccordionSummary-content .error-amount {
  color: #ee5b3a;
  font-size: 26px;
}
.dashboard-accordian .MuiPaper-root.MuiAccordion-root .MuiAccordionSummary-root .MuiAccordionSummary-expandIconWrapper .collapsIconWrapper {
  font-size: 25px;
}
.dashboard-accordian .MuiPaper-root.MuiAccordion-root .MuiAccordionSummary-root .MuiAccordionSummary-expandIconWrapper .expandIconWrapper {
  font-size: 25px;
}
.dashboard-accordian .MuiPaper-root.MuiAccordion-root .MuiAccordionDetails-root {
  padding: 0px;
}
.dashboard-accordian .MuiPaper-root.MuiAccordion-root .MuiAccordionDetails-root .table-component {
  box-shadow: none;
  border-radius: 0px;
}
.dashboard-accordian .MuiPaper-root.MuiAccordion-root .MuiAccordionDetails-root .table-component thead {
  background-color: #e4e9f3;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
}
.dashboard-accordian .MuiPaper-root.MuiAccordion-root .MuiAccordionDetails-root .table-component thead tr th {
  padding: 14px;
  font-weight: 600;
  color: #2f3750;
  white-space: nowrap;
}
.dashboard-accordian .MuiPaper-root.MuiAccordion-root .MuiAccordionDetails-root .table-component thead tr th .MuiButtonBase-root {
  padding: 0px 8px;
}
.dashboard-accordian .MuiPaper-root.MuiAccordion-root .MuiAccordionDetails-root .table-component thead tr th:last-child {
  text-align: center;
  width: 100%;
}
@media screen and (min-width: 1024px) {
  .dashboard-accordian .MuiPaper-root.MuiAccordion-root .MuiAccordionDetails-root .table-component thead tr th:last-child {
    text-align: start;
    padding-left: 3.8rem;
  }
}
.dashboard-accordian .MuiPaper-root.MuiAccordion-root .MuiAccordionDetails-root .table-component tbody tr {
  border-bottom: 1px solid #edf1f7;
}
.dashboard-accordian .MuiPaper-root.MuiAccordion-root .MuiAccordionDetails-root .table-component tbody tr td {
  padding: 10px 14px;
  color: #333c57;
}
.dashboard-accordian .MuiPaper-root.MuiAccordion-root .MuiAccordionDetails-root .table-component tbody tr .txt-elipsis {
  max-width: 60px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.dashboard-accordian .MuiPaper-root.MuiAccordion-root .MuiAccordionDetails-root .document-table-component table .MuiTableCell-root:last-child .MuiStack-root .MuiGrid-root {
  flex-wrap: nowrap;
}
@media screen and (max-width: 430px) {
  .dashboard-accordian .MuiPaper-root.MuiAccordion-root .MuiAccordionDetails-root .document-table-component table .MuiTableCell-root:last-child .MuiStack-root .MuiGrid-root .MuiGrid-item {
    min-width: 60px;
  }
}
.dashboard-accordian .MuiPaper-root.MuiAccordion-root .MuiAccordionDetails-root .document-table-component table tr th:last-child {
  text-align: center;
}
.confirmScreen {
  height: 100dvh;
  background: #f1f2f5;
}
.confirmScreen .deeplink-content {
  text-align: center;
  background: white;
  border-radius: 10px;
  padding: 8% 15%;
  margin: 9%;
}
.confirmScreen .deeplink-content svg {
  width: 150px;
  height: 150px;
  margin-bottom: 16px;
}
.confirmScreen .deeplink-content .MuiTypography-root {
  line-height: 35px;
}

.MuiAccordionDetails-root .table-component tbody tr .action-col .actions-data .MuiGrid-item {
  width: 90px;
}
.MuiAccordionDetails-root .table-component tbody tr .action-col .actions-data .MuiGrid-item .actions-label {
  width: 90px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.MuiButtonBase-root .MuiTypography-root {
  white-space: nowrap;
}

@media screen and (max-width: 600px) {
  .dashboard-kpi-grid {
    padding: 0 12px 8px;
    gap: 10px;
  }
  .kpi-card {
    width: 170px;
    margin-top: 5px;
  }
  .dashboard-welcome-title {
    font-size: 24px;
    line-height: 32px;
  }
  .dashboard-welcome-subtitle {
    font-size: 14px;
    line-height: 20px;
  }
  .dashboard-welcome-subtitle .attention-count {
    font-size: 14px;
  }
  .dashboard-action-queue-list {
    padding: 12px 12px 0;
  }
  .action-queue-empty-state {
    flex: 1;
    min-height: 0;
    padding: 24px 12px;
  }
  .action-queue-empty-icon-wrap svg {
    width: 90px;
    height: auto;
  }
  .action-queue-empty-text {
    font-size: 16px !important;
    line-height: normal !important;
  }
  .action-queue-card {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
  .revamp-header-tabs {
    display: none;
  }
  .revamp-user-info {
    display: none;
  }
  .dashboard-filters-panel {
    margin: 12px auto 0;
    padding: 14px;
  }
  .dashboard-queue-heading {
    display: none;
  }
  .version-wrapper-dashboard {
    display: none;
  }
  .tc-pp-container {
    justify-content: center;
  }
  .MuiDialog-root.create-app-dialog .MuiDialog-container {
    right: -3px;
    top: 82px;
  }
  .MuiStack-root.dashboard-heading {
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: flex-start;
    gap: 8px;
    padding: 12px 12px 8px;
  }
  .MuiStack-root.dashboard-heading > .MuiBox-root:first-child {
    flex: 1;
    min-width: 0;
    width: auto;
  }
  .dashboard-welcome-title {
    font-size: 18px !important;
    font-weight: 700 !important;
    line-height: 28px !important;
  }
  .dashboard-welcome-subtitle {
    font-size: 12px !important;
    color: #6B7280 !important;
    margin-top: 2px;
  }
  .dashboard-heading .header-btns {
    justify-content: flex-end;
    min-width: 0;
    flex-shrink: 0;
    display: flex !important;
    gap: 6px;
    padding-top: 2px;
  }
  .dashboard-heading .header-btns .MuiButtonBase-root {
    min-height: 32px !important;
    padding: 5px 12px !important;
  }
  .dashboard-heading .header-btns .MuiIconButton-root {
    width: 34px !important;
    height: 34px !important;
    padding: 6px !important;
  }
  .dashboard-header-search {
    flex: 1 1 auto;
    min-width: 80px;
    width: auto;
  }
  .action-queue-actions {
    width: 100%;
    padding-left: 0;
    justify-content: flex-start;
  }
  /* ── Queue card mobile reflow ─────────────────────────────────────────────
     Use display:contents on the top-row to dissolve it, then order the card
     sections: name → meta → pills → reasons → actions (bottom).
  ── */
  .action-queue-card-item.action-queue-card-action-needed {
    display: flex;
    flex-direction: column;
  }
  /* Dissolve the wrapper so company-name and top-actions become
     direct flex children of the card and can be individually ordered. */
  .action-needed-top-row {
    display: contents;
  }
  /* Also dissolve the title+metadata column (added so the two center against the actions'
     combined height on desktop) — otherwise .action-needed-company/.action-needed-meta-row
     stay nested one level deeper than .action-needed-top-actions/pills/reasons, and their
     order:1/2 below has no effect since they're no longer siblings of order:3/4/5. */
  .action-needed-title-meta-col {
    display: contents;
  }
  .action-needed-company {
    order: 1;
    margin-bottom: 6px;
    font-size: 18px !important;
    font-weight: 700 !important;
  }
  .action-needed-meta-row {
    order: 2;
    margin-bottom: 10px;
  }
  .action-needed-pills-row {
    order: 3;
    margin-bottom: 10px;
  }
  .action-needed-reasons-divider {
    order: 4;
  }
  .action-needed-reasons {
    order: 4;
  }
  /* Actions row moves to the bottom with a hairline divider above, right-aligned */
  .action-needed-top-actions {
    order: 5;
    border-top: 1px solid #EAECF0;
    padding-top: 12px;
    margin-top: 8px;
    gap: 8px;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    display: flex;
  }
  /* Edit button stays compact — does not stretch */
  .action-open-btn.MuiButtonBase-root {
    flex: 0 0 auto;
  }
  /* version-wrapper-dashboard is hidden on mobile, so reclaim its height — the marketing
     banner's own height (if present) is still reserved on top, same as everywhere else */
  .dashboard-main {
    height: calc(100dvh - 60px - var(--marketing-banner-height, 0px));
  }
}
@media screen and (max-width: 460px) {
  .MuiStack-root.dashboard-heading {
    border-radius: 0;
  }
  .MuiDialog-root.create-app-dialog .MuiDialog-container {
    right: 2%;
    top: 13%;
  }
  .MuiStack-root.dashboard-heading {
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
  }
  .header-btns {
    min-width: 0;
    display: flex;
    justify-content: flex-end;
  }
  .header-btns button:not(:last-child) {
    margin-right: 8px;
  }
  .header-btns button p {
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .dashboard-header-search {
    order: -1;
  }
  .create-app-container .MuiBox-root.create-app-comp-wrapper {
    height: calc(100dvh - 360px);
    margin-right: 5px;
  }
  .create-app-container .MuiBox-root.create-app-comp-wrapper .accordion-styles {
    padding: 10px 16px;
  }
}
@media screen and (max-width: 460px) and (max-width: 460px) {
  .create-app-container .MuiBox-root.create-app-comp-wrapper {
    height: auto;
  }
}
@media screen and (max-width: 460px) {
  .create-app-container .MuiStack-root.create-app-heading {
    padding: 16px;
  }
  .create-app-container .stepper-wrapper .MuiBox-root {
    padding-bottom: 6px;
  }
  .create-app-container .footer-wrapper .footer-content {
    padding: 14px;
  }
}
@media screen and (max-width: 540px) {
  .dashboard-accordian {
    padding: 8px 12px 16px;
  }
  .dashboard-accordian .MuiPaper-root.MuiAccordion-root .MuiAccordionSummary-root .MuiAccordionSummary-content {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }
  .dashboard-accordian .MuiPaper-root.MuiAccordion-root .MuiAccordionSummary-root .MuiAccordionSummary-content .warning-amount {
    max-width: 320px;
    word-wrap: break-word;
  }
  .confirmScreen .deeplink-content {
    padding: 8%;
    margin: 22px;
  }
  .confirmScreen .deeplink-content svg {
    width: 100px;
    height: 100px;
  }
}
@media screen and (max-width: 1024px) {
  .create-app-container .stepper-wrapper p {
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/dashboard.scss","webpack://./src/assets/scss/variable.scss","webpack://./src/assets/scss/mixins.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;EACI,aAAA;EAKA,+BAAA;EAMA,8BAAA;ADPJ;;ACLA;EACI,aAAA;EAKA,+BAAA;EAMA,8BAAA;ADDJ;;AARA;EAOE,kEAAA;EACA,gBAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,+BCsBW;EDrBX,kBAAA;EACA,mBAAA;AAKF;AAFA;EAlBA;IAmBE,eAAA;IACA,gBAAA;EAKA;AACF;;AAFA;EACE,mBAAA;AAKF;;AAKA;EACE,eAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,WAAA;EACA,sBAAA;EACA,mBAAA;EACA,gCAAA;AAFF;;AAOA;EACE,sBAAA;EACA,sCAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,0BAAA;EACA,kBAAA;AAJF;;AAOA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;EACA,OAAA;AAJF;;AAOA;EACE,oBAAA;EACA,mBAAA;EACA,MAAA;EACA,cAAA;AAJF;;AAOA;EACE,cAAA;EAEA,0BAAA;AALF;;AAQA;EACE,cAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,cAAA;AALF;;AAQA;EACE,WAAA;EACA,YAAA;EACA,oDAAA;EACA,UAAA;EACA,wBAAA;AALF;;AAQA;EACE,UAAA;EACA,0BAAA;AALF;;AAQA;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,oBAAA;EACA,qBAAA;EACA,aAAA;EACA,4BAAA;EACA,gBAAA;AALF;;AAQA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;AALF;;AAQA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;AALF;;AAQA;EACE,WAAA;EACA,oBAAA;EACA,mBAAA;EACA,UAAA;AALF;;AAWA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,yBAAA;EACA,oBAAA;EACA,0BAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;AARF;;AAcE;EACE,cAAA;AAXJ;;AAeA;EACE,0BAAA;EACA,gBAAA;EACA,yBAAA;EACA,iBAAA;AAZF;;AAoBA;EACE,eAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gCAAA;EACA,WAAA;EACA,sBAAA;AAjBF;;AAwBA;EACE,0BAAA;EACA,gBAAA;EACA,yBAAA;EACA,iBAAA;AArBF;;AAwBA;EACE,yBAAA;EACA,cAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;AArBF;AAuBE;EACE,+BAAA;AArBJ;;AAyBA;EACE;IACE,kEAAA;EAtBF;EAyBA;IACE,iBAAA;IACA,SAAA;IACA,mBAAA;EAvBF;EA0BA;IACE,mBAAA;IACA,QAAA;EAxBF;EA2BA;IACE,YAAA;IACA,cAAA;EAzBF;EA4BA;IACE,eAAA;IACA,iBAAA;IACA,yBAAA;IACA,iBAAA;IACA,cAAA;IACA,iBAAA;EA1BF;EA6BA;IACE,8BAAA;EA3BF;EA8BA;IACE,UAAA;IACA,WAAA;EA5BF;EA+BA;IACE,WAAA;EA7BF;AACF;AAgCA;EACE,kBAAA;EAKA,YAAA;EACA,sCAAA;EACA,6BAAA;AAlCF;AAoCE;EACE,WAAA;EACA,aAAA;EACA,mBAAA;AAlCJ;AAoCI;EACE,WAAA;EACA,aAAA;EACA,mBAAA;AAlCN;AAqCM;EACE,WAAA;EACA,eAAA;EACA,0BAAA;EACA,eAAA;AAnCR;AAuCI;EACE,WAAA;AArCN;AAuCM;EACE,WAAA;EACA,eAAA;EACA,0BAAA;EACA,eAAA;AArCR;AAyCI;EACE,eAAA;AAvCN;;AA6CE;EACE,8BAAA;EACA,cAAA;EACA,gBAAA;EACA,gCAAA;EACA,0BAAA;EAKA,OAAA;EACA,QAAA;EACA,WAAA;EACA,iBAAA;EACA,kEAAA;AA9CJ;AAkDE;EACE,gBAAA;AAhDJ;AAkDI;EEzSF,aAAA;EACA,mBAAA;EAOI,8BAAA;EFmSA,mBAAA;EACA,WAAA;AA9CN;AAgDM;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;AA9CR;AAgDQ;EAEE,eAAA;AA/CV;AAkDQ;EACE,WAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;AAhDV;AAkDU;EANF;IAOI,gBAAA;IACA,gBAAA;EA/CV;AACF;AAkDQ;EACE;IACE,iBAAA;EAhDV;AACF;AAoDM;EAlCF;IAoCI,mBAAA;IACA,YAAA;EAlDN;AACF;AAsDM;EACE,iBAAA;AApDR;AAsDQ;EAHF;IAII,iBAAA;IACA,eAAA;EAnDR;AACF;AAwDU;EACE,sBAAA;EACA,YAAA;AAtDZ;AAwDY;EACE,YAAA;AAtDd;AAyDY;EACE,kBAAA;AAvDd;AA0DY;EAZF;IAaI,WAAA;EAvDZ;EAyDY;IACE,iBAAA;IACA,6BAAA;EAvDd;AACF;AA0DY;EAKE,+BCrXD;ADyTb;AAwDc;EACE,aAAA;AAtDhB;;AAkEA;EAME,+FAAA;AApEF;;AAyEA;EA2CE;qFAAA;AA/GF;AAuEE;EACE,4BAAA;AArEJ;AA2EE;EACE,4BAAA;AAzEJ;AAoFE;EACE,2CAAA;AAlFJ;AAwFE;EACE,iEAAA;AAtFJ;AAyFE;EACE;IACE,2CAAA;EAvFJ;EA0FE;IACE,iEAAA;EAxFJ;AACF;AA6FE;EACE;IACE,0DAAA;EA3FJ;AACF;;AA+FA;EACE,sBAAA;EACA,WAAA;EAKA,sCAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AAhGF;AAuGE;EApBF;IAqBI,aAAA;EApGF;AACF;;AAuGA;EACE,aAAA;EACA,mBAAA;EAoBA,cAAA;EACA,SAAA;EACA,YAAA;AAvHF;;AA0HA;EACE,wBAAA;AAvHF;;AA0HA;EAGE,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,4BAAA;AAzHF;;AA4HA;EACE,aAAA;EACA,mBAAA;AAzHF;;AAgIE;EACE,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,+BC9gBS;ED+gBT,YAAA;EACA,QAAA;EACA,gBAAA;AA7HJ;AAgIE;EACE,8BAAA;AA9HJ;AAiIE;EACE,YAAA;AA/HJ;AAkIE;EACE,wBCljBa;EDmjBb,iCAAA;AAhIJ;AAkII;EACE,mCAAA;AAhIN;;AAqIA;EAGE,eAAA;AApIF;;AAuIA;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AApIF;;AA4IA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;AAzIF;;AAiJA;EACE,eAAA;AA9IF;AAmJE;EACE,6BAAA;EACA,0CAAA;AAjJJ;AAuJE;EACE,uBAAA;EACA,gBAAA;AArJJ;;AAyJA;EACE;IACE,+BAAA;IACA,WAAA;IACA,YAAA;IACA,cAAA;EAtJF;EAyJA;IACE,SAAA;EAvJF;EA0JA;IACE,YAAA;IACA,gBAAA;IACA,YAAA;EAxJF;EA2JA;IACE,QAAA;EAzJF;EA4JA;IACE,aAAA;EA1JF;EA6JA;IACE,gBAAA;EA3JF;AACF;AA+JA;EACE;IACE,QAAA;EA7JF;EAgKA;IACE,YAAA;IACA,gBAAA;IACA,YAAA;EA9JF;EAkKE;IACE,eAAA;IACA,gBAAA;IACA,QAAA;EAhKJ;EAoKA;IACE,eAAA;EAlKF;EAqKA;IACE,QAAA;EAnKF;EAsKA;IACE,gBAAA;IACA,QAAA;IACA,eAAA;EApKF;AACF;AA0KA;EACE;IACE,QAAA;EAxKF;EA2KA;IACE,YAAA;IACA,eAAA;IACA,YAAA;EAzKF;EA6KE;IACE,eAAA;IACA,gBAAA;IACA,QAAA;EA3KJ;EA+KA;IACE,eAAA;EA7KF;EAgLA;IACE,QAAA;EA9KF;EAiLA;IACE,gBAAA;IACA,QAAA;IACA,eAAA;EA/KF;AACF;AAmLA;EACE;IACE,QAAA;EAjLF;EAoLA;IACE,YAAA;IACA,eAAA;IACA,YAAA;EAlLF;EAsLA;IACE,aAAA;EApLF;EAwLE;IACE,YAAA;IACA,MAAA;IACA,eAAA;EAtLJ;EA0LA;IACE,eAAA;EAxLF;EA2LA;IACE,QAAA;EAzLF;EA4LA;IACE,aAAA;EA1LF;EA6LA;IACE,gBAAA;IACA,QAAA;IACA,eAAA;EA3LF;AACF;AA+LE;EACE,gBAAA;EACA,kBAAA;EACA,kCAAA;EACA,cAAA;EACA,+BClvBS;EDmvBT,oBAAA;EACA,YAAA;EACA,QAAA;EACA,eAAA;AA7LJ;AA+LI;EACE,mBAAA;AA7LN;;AAkMA;EACE,WAAA;EACA,YAAA;AA/LF;AAiME;EACE,WAAA;EACA,YAAA;AA/LJ;;AAmMA;EACE,UAAA;EACA,WAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AAhMF;AAkME;EACE,UAAA;EACA,WAAA;EACA,cAAA;AAhMJ;;AAqME;EACE,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,8CAAA;AAlMJ;AAqME;EACE,eAAA;EACA,cAAA;AAnMJ;AAsME;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;AApMJ;;AAwMA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AArMF;AAuME;EACE,iCAAA;AArMJ;;AAsNE;EAGE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;AArNJ;;AAyNA;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;AAtNF;AAwNE;EACE,eAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAtNJ;AAyNE;EACE,eAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAvNJ;;AA2NA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAxNF;AA0NE;EACE,WAAA;EACA,YAAA;AAxNJ;;AA4NA;EACE,WAAA;EACA,YAAA;EACA,UAAA;AAzNF;;AA4NA;EACE,eAAA;EACA,QAAA;EACA,kCAAA;EACA,aAAA;AAzNF;;AA4NA;EACE,eAAA;EACA,SAAA;EAMA,oDAAA;EACA,YAAA;EACA,gBAAA;EACA,QAAA;EACA,UAAA;EACA,kBAAA;EACA,aAAA;EACA,wBCx6Be;EDy6Bf,gDAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;AA9NF;;AAoOA;EACE,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,kBAAA;EACA,kDAAA;AAjOF;AAmOE;EACE,iCAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,0CAAA;AAjOJ;AAoOE;EACE,iCAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,0CAAA;AAlOJ;AAqOE;EA9BF;IA+BI,aAAA;EAlOF;AACF;;AAqOA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AAlOF;AAoOE;EACE,iCAAA;EACA,eAAA;AAlOJ;AAqOE;EACE,iCAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,0CAAA;AAnOJ;AAsOE;EACE,eAAA;AApOJ;AAsOI;EACE,qCAAA;AApON;;AAyOA;EACE;IACE,SAAA;IACA,YAAA;IACA,UAAA;IACA,WAAA;EAtOF;AACF;AAyOA;EACE,mBAAA;EACA,0BAAA;EACA,4BAAA;EACA,mBAAA;EACA,8BAAA;EAEA,uBAAA;EACA,SAAA;EACA,gBAAA;EACA,SAAA;EACA,cAAA;AAxOF;AA0OE;EACE,0BAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,0CAAA;AAxOJ;AA2OE;EArBF;IAsBI,gBAAA;EAxOF;AACF;;AA2OA;EACE,cAAA;EACA,YAAA;AAxOF;;AA2OA;EACE,yBAAA;AAxOF;;AA2OA;EAEE,yBAAA;EACA,gBAAA;EACA,0CAAA;EACA,0BAAA;EACA,2BAAA;AAzOF;;AA4OA;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,0CAAA;AAzOF;AA2OE;EACE,cAAA;EACA,gBAAA;AAzOJ;;AA6OA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,oBAAA;EACA,mBAAA;EACA,eAAA;AA1OF;;AA6OA;EACE,0BAAA;EACA,cAAA;AA1OF;;AA6OA;EACE,cAAA;EACA,0CAAA;EACA,0BAAA;EACA,2BAAA;EACA,4BAAA;AA1OF;;AA8OE;EACE,8BAAA;EACA,yBAAA;EACA,6BAAA;EACA,gBAAA;EACA,6BAAA;AA3OJ;AA+OE;EACE,yBAAA;EACA,0BAAA;AA7OJ;;AAiPA;EACE,0CAAA;EACA,0BAAA;EACA,2BAAA;EACA,4BAAA;EACA,cAAA;AA9OF;;AAiPA;EACE;IACE,eAAA;IACA,iBAAA;IACA,cAAA;EA9OF;EAiPA;IACE,eAAA;EA/OF;AACF;AAkPA;EACE,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;AAhPF;AAkPE;EACE,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,0CAAA;AAhPJ;;AAoPA;EACE,iBAAA;EACA,mBAAA;EACA,YAAA;AAjPF;;AAoPA;EACE,cAAA;EACA,gBAAA;EACA,gBAAA;AAjPF;AAmPE;EACE,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,0CAAA;AAjPJ;AAmPI;EACE,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAjPN;AAmPM;EACE,cAAA;EACA,UAAA;AAjPR;AAqPI;EACE,cAAA;EACA,iBAAA;AAnPN;AAsPI;EACE,eAAA;EACA,cAAA;AApPN;;AA0PE;EACE,qBAAA;AAvPJ;;AA2PA;EACE,aAAA;AAxPF;;AA2PA;EACE,SAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AAxPF;AA0PE;EACE,cAAA;EACA,gBAAA;AAxPJ;AA2PE;EACE,iBAAA;AAzPJ;AA4PE;EACE,eAAA;AA1PJ;AA6PE;EACE,SAAA;EACA,+CAAA;AA3PJ;;AA+PA;EACE,gBAAA;AA5PF;;AA+PA;EACE,8BAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,cAAA;AA5PF;AAmQE;EACE,mBCzuCa;ADw+BjB;AAoQE;EACE,iBAAA;AAlQJ;AAqQE;EACE,WAAA;EACA,YAAA;AAnQJ;;AA6QA;EACE,wBC7vCe;ED8vCf,iCAAA;EACA,cAAA;AA1QF;AAiRA;EACE,gBAAA;AA/QF;;AAkRA;EACE,mBAAA;AA/QF;;AAkRA;EACE;IACE,kBAAA;IACA,SAAA;EA/QF;EAkRA;IACE,eAAA;EAhRF;EAmRA;IACE,eAAA;IACA,iBAAA;EAjRF;EAoRA;IACE,gBAAA;IACA,eAAA;EAlRF;EAqRA;IACE,0BAAA;EAnRF;EAsRA;IACE,QAAA;IACA,YAAA;EApRF;EAuRA;IACE,cAAA;IACA,gBAAA;IACA,gBAAA;EArRF;EAwRA;IACE,YAAA;IACA,kBAAA;IACA,mBAAA;IACA,gBAAA;EAtRF;EAwRE;IACE,eAAA;EAtRJ;AACF;AA0RA;EACE;IACE,iBAAA;IACA,mBAAA;IACA,mBAAA;EAxRF;EA2RA;IACE,QAAA;IACA,YAAA;IACA,mBAAA;EAzRF;EA6RA;IACE,WAAA;IACA,YAAA;IACA,0BAAA;IACA,2BAAA;IACA,UAAA;IACA,cAAA;EA3RF;EA6RE;IACE,SAAA;EA3RJ;EA8RE;IACE,eAAA;IACA,cAAA;EA5RJ;EAiSA;IACE,WAAA;IACA,YAAA;IACA,0BAAA;IACA,2BAAA;IACA,UAAA;IACA,cAAA;EA/RF;EAiSE;IACE,SAAA;EA/RJ;EAmSA;IACE,QAAA;IACA,mBAAA;EAjSF;EAoSA;IACE,cAAA;IACA,eAAA;EAlSF;EAqSA;IACE,UAAA;EAnSF;EAsSA;IACE,gBAAA;IACA,eAAA;EApSF;EAuSA;IACE,0BAAA;IACA,4BAAA;EArSF;EAwSA;IACE,YAAA;EAtSF;AACF;AA4SM;EACE,8BAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AA1SR;AA4SQ;EACE,yBCp4CD;EDq4CC,YAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AA1SV;AA4SU;EACE,WAAA;EACA,mBC75CK;ADmnCjB;AA+SU;EACE,eAAA;EACA,gBAAA;EACA,mBCr6CK;ADwnCjB;AAgTU;EACE,eAAA;EACA,gBAAA;EACA,cC75CA;AD+mCZ;AAkTQ;EACE,yBC96CK;AD8nCf;AAuTQ;EACE,oBCx7CO;ADmoCjB;AA2TM;EACE,gBAAA;AAzTR;AA8TM;EACE,mBAAA;AA5TR;;AAmUE;EACE,qBAAA;EACA,qBAAA;EACA,WAAA;AAhUJ;AAoUI;EACE,+BAAA;AAlUN;;AAwUE;EACE,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,0CAAA;AArUJ;AAyUI;EACE,yBAAA;EACA,gCAAA;AAvUN;AAyUM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAvUR;AA0UM;EACE,WAAA;AAxUR;AA+UI;EACE,WAAA;AA7UN;AAiVI;EACE,mCAAA;AA/UN;AAkVI;EACE;IACE,UAAA;IACA,4BAAA;EAhVN;EAmVI;IACE,UAAA;IACA,wBAAA;EAjVN;AACF;AAsVE;EACE,0CAAA;EACA,kBAAA;AApVJ;AAuVE;EACE,0BAAA;AArVJ;AAwVE;EACE,cAAA;AAtVJ;AAyVM;EACE,0CAAA;AAvVR;AA0VM;EACE,0CAAA;AAxVR;AA0VQ;EACE,0CAAA;AAxVV;AA+VE;EACE,kBAAA;EACA,gCAAA;AA7VJ;AA+VI;EACE,yCAAA;AA7VN;AAgWI;EACE,+CAAA;AA9VN;AAkWM;EACE,qBAAA;AAhWR;AAsWE;EACE,WAAA;AApWJ;AAsWI;EACE,cAAA;AApWN;AAyWE;EACE,eAAA;EACA,eAAA;AAvWJ;AAyWI;EACE,cAAA;AAvWN;AA4WE;EACE,oBAAA;EACA,mBChlDa;EDilDb,0BCjlDa;EDklDb,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;AA1WJ;AAiXI;EACE,sBAAA;AA/WN;AAmXE;EACE,oBAAA;EACA,8BCpmDa;EDqmDb,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,6CAAA;AAjXJ;AAmXI;EACE,aAAA;EAEA,8CAAA;AAlXN;AAqXI;EACE,sBAAA;AAnXN;AAsXI;EACE,sBAAA;EACA,gBAAA;AApXN;AA0XI;EACE,aAAA;AAxXN;;AA8XE;EACE,mBAAA;EACA,gBAAA;EACA,WAAA;AA3XJ;AA8XE;EACE,UAAA;AA5XJ;AA+XE;EACE,kBAAA;AA7XJ;AAgYE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AA9XJ;AAiYE;EACE,WAAA;EACA,YAAA;AA/XJ;AAkYE;EACE,oBAAA;AAhYJ;AAmYE;EACE,eAAA;AAjYJ;AAmYI;EACE,YAAA;EACA,yBAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;AAjYN;AAmYM;EACE,8BC7qDS;ED8qDT,YAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AAjYR;AAmYQ;EACE,WAAA;EACA,iCAAA;AAjYV;AAmYU;EACE,kCAAA;AAjYZ;AAuYQ;EACE,eAAA;EACA,gBAAA;EACA,mBCpsDO;AD+zCjB;AAwYQ;EACE,eAAA;EACA,gBAAA;EACA,cC5rDE;ADszCZ;AA0YM;EACE,yBAAA;AAxYR;;AA+YE;EACE,sBAAA;AA5YJ;AA+YE;EACE,YAAA;EACA,WAAA;AA7YJ;AAqZI;EACE,SAAA;AAnZN;AAsZI;EACE;IACE,QAAA;EApZN;AACF;;AAyZA;EACE,aAAA;EACA,eAAA;EACA,8BAAA;EACA,iBAAA;AAtZF;AAwZE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,SAAA;AAtZJ;AAwZI;EAPF;IAQI,MAAA;EArZJ;AACF;AAuZI;EAXF;IAYI,MAAA;EApZJ;AACF;;AAwZA;EACE,iBAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,6CAAA;AArZF;;AAwZA;EACE,WAAA;EACA,SAAA;AArZF;;AAwZA;EACE,WAAA;AArZF;;AAwZA;EACE,WAAA;AArZF;;AAwZA;EACE,YAAA;EACA,mBAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;AArZF;;AAwZA;EACE,0BAAA;EAEA,cAAA;EACA,kBAAA;EACA,cAAA;AAtZF;;AAyZA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAtZF;;AAyZA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAtZF;AAwZE;EACE,WAAA;EACA,YAAA;AAtZJ;;AA0ZA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;AAvZF;;AA6ZA;EACE,aAAA;EACA,qBAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;AA1ZF;;AA6ZA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,0CAAA;EACA,gBAAA;AA1ZF;;AA6ZA;EACE,gBAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,0CAAA;EACA,gBAAA;AA1ZF;;AA6ZA;EACE,0BAAA;EAEA,aAAA;EACA,gDAAA;EACA,SAAA;EACA,iBAAA;EACA,cAAA;EACA,wBAAA;EACA,sBAAA;AA3ZF;;AA8ZA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;EACA,oBAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;EACA,uDACE;AA5ZJ;AA+ZE;EACE,yCAAA;EAEA,2BAAA;AA9ZJ;;AA0aA;EACE,UAAA;EACA,2BAAA;EACA,iFAAA;AAvaF;AA0aI;EACE,mBAAA;AAxaN;AAuaI;EACE,qBAAA;AAraN;AAoaI;EACE,qBAAA;AAlaN;AAiaI;EACE,qBAAA;AA/ZN;AA8ZI;EACE,qBAAA;AA5ZN;AA2ZI;EACE,qBAAA;AAzZN;;AA8ZA;EACE;IACE,UAAA;IACA,wBAAA;EA3ZF;AACF;AA8ZA;EACE;IACE,4BAAA;IACA,yCAAA;IACA,yBAAA;IACA,4DAAA;EA5ZF;EA+ZI;IACE,mBAAA;EA7ZN;EA4ZI;IACE,sBAAA;EA1ZN;EAyZI;IACE,sBAAA;EAvZN;EAsZI;IACE,sBAAA;EApZN;EAmZI;IACE,sBAAA;EAjZN;EAgZI;IACE,sBAAA;EA9YN;EAmZA;IACE;MACE,UAAA;MACA,wBAAA;IAjZF;EACF;AACF;AAoZA;EACE;IACE,eAAA;IACA,UAAA;IACA,eAAA;EAlZF;AACF;AAqZA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;EAEA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,0BAAA;AApZF;;AAuZA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,0CAAA;AApZF;;AAuZA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,uBAAA;EACA,wBAAA;EACA,OAAA;EACA,YAAA;AApZF;;AAuZA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;AApZF;AAsZE;EACE,WAAA;EACA,YAAA;AApZJ;;AAwZA;EACE,0BAAA;EACA,iBAAA;EACA,gBAAA;EACA,0CAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;AArZF;;AAwZA;EACE,oCAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,0CAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AArZF;;AAgaE;EACE,cAAA;AA7ZJ;AAgaE;EACE,cAAA;AA9ZJ;;AAuaA;EACE,8BAAA;AApaF;;AAwaE;EACE,cAAA;AAraJ;AAwaE;EACE,cAAA;AAtaJ;;AA0aA;EACE,8BAAA;AAvaF;;AA2aE;EACE,cAAA;AAxaJ;AA2aE;EACE,cAAA;AAzaJ;;AA6aA;EACE,8BAAA;AA1aF;;AA8aE;EACE,cAAA;AA3aJ;AA8aE;EACE,cAAA;AA5aJ;;AAgbA;EACE,8BAAA;AA7aF;;AAibE;EACE,cAAA;AA9aJ;AAibE;EACE,cAAA;AA/aJ;;AAmbA;EACE,8BAAA;AAhbF;;AAobE;EACE,cAAA;AAjbJ;AAobE;EACE,cAAA;AAlbJ;;AAsbA;EACE,8BAAA;AAnbF;;AAubE;EACE,cAAA;AApbJ;AAubE;EACE,cAAA;AArbJ;;AAybA;EACE,8BAAA;AAtbF;;AAybA;EACE,8BAAA;AAtbF;;AAybE;EACE,cAAA;AAtbJ;AAybE;EACE,cAAA;AAvbJ;;AA6bA;EACE,2BAAA;EACA,8BAAA;EACA,8DAAA;AA1bF;;AA6bA;EACE,2BAAA;EACA,8BAAA;EACA,qDAAA;AA1bF;;AA6bA;EACE,2BAAA;EACA,8BAAA;EACA,2DAAA;AA1bF;;AA6bA;EACE,2BAAA;EACA,8BAAA;EACA,4DAAA;AA1bF;;AA6bA;EACE,2BAAA;EACA,8BAAA;EACA,mDAAA;AA1bF;;AA6bA;EACE,2BAAA;EACA,8BAAA;EACA,2DAAA;AA1bF;;AA6bA;EACE,2BAAA;EACA,8BAAA;EACA,6DAAA;AA1bF;;AA6bA;EACE,2BAAA;EACA,8BAAA;EACA,6DAAA;AA1bF;;AA6bA;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;AA1bF;AA4bE;EACE,gBAAA;EACA,eAAA;AA1bJ;;AAkcA;EACE,WAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;AA/bF;;AAkcA;EACE,0BAAA;EAKA,2BAAA;EACA,aAAA;EACA,sBAAA;EAEA,WAAA;EACA,aAAA;EACA,gBAAA;EAMA,mBAAA;EACA,4BAAA;EAKA,qBAAA;AA7cF;AA+cE;EACE,aAAA;AA7cJ;;AAodA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;EACA,oBAAA;AAjdF;;AAodA;EACE,kBAAA;EACA,OAAA;EACA,WAAA;EACA,oBAAA;EACA,mBAAA;EACA,eAAA;AAjdF;AAmdE;EACE,mBAAA;AAjdJ;;AAqdA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EAEA,kBAAA;EACA,2BAAA;AAndF;;AAoeA;EACE;IACE,eAAA;IACA,YAAA;EAjeF;EAoeA;IACE,cAAA;IACA,YAAA;EAleF;EAqeA;IACE,iBAAA;EAneF;AACF;AA6hBA;EACE,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,4BAAA;EACA,SAAA;EAEA,kBAAA;EACA,kBAAA;EAEA,mBAAA;EACA,kBAAA;EAIA,8EACE;AAjiBJ;AAqiBE;EACE,yCACE;EACF,kBAAA;AApiBJ;;AA0iBA;EACE,UAAA;EACA,2BAAA;EACA,mFAAA;AAviBF;AA0iBI;EACE,mBAAA;AAxiBN;AAuiBI;EACE,qBAAA;AAriBN;AAoiBI;EACE,qBAAA;AAliBN;AAiiBI;EACE,qBAAA;AA/hBN;AA8hBI;EACE,qBAAA;AA5hBN;AA2hBI;EACE,qBAAA;AAzhBN;AAwhBI;EACE,qBAAA;AAthBN;AAqhBI;EACE,qBAAA;AAnhBN;AAwhBE;EACE,qBAAA;AAthBJ;;AA0hBA;EACE;IACE,UAAA;IACA,wBAAA;EAvhBF;AACF;AA0hBA;EACE;IACE,eAAA;IACA,UAAA;IACA,eAAA;EAxhBF;AACF;AA8hBE;EASE,gCAAA;EACA,qBAAA;EACA,eAAA;AApiBJ;;AAyhBE;EASE,gCAAA;EACA,qBAAA;EACA,eAAA;AA9hBJ;;AAmhBE;EASE,gCAAA;EACA,qBAAA;EACA,eAAA;AAxhBJ;;AA6gBE;EASE,gCAAA;EACA,qBAAA;EACA,eAAA;AAlhBJ;;AAugBE;EASE,gCAAA;EACA,qBAAA;EACA,eAAA;AA5gBJ;;AAigBE;EASE,gCAAA;EACA,qBAAA;EACA,eAAA;AAtgBJ;;AAkhBA;EACE,sBAAA;EACA,oBAAA;EACA,kBAAA;EACA,MAAA;AA/gBF;;AAkhBA;EACE,aAAA;EACA,8BAAA;EAGA,mBAAA;EAEA,SAAA;AAlhBF;;AAuhBA;EACE,aAAA;EACA,sBAAA;EACA,OAAA;EACA,YAAA;AAphBF;;AAuhBA;EACE,0BAAA;EACA,2BAAA;EACA,yBAAA;EACA,0CAAA;EACA,mBAAA;EACA,YAAA;AAphBF;;AAuhBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;AAphBF;;AA2hBA;EACE,aAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,0CAAA;EACA,eAAA;AAxhBF;AA0hBE;EACE,eAAA;EACA,0CAAA;EACA,cAAA;AAxhBJ;AA0hBI;EACE,gBAAA;EACA,cAAA;AAxhBN;;AA6hBA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,mBAAA;AA1hBF;;AA+hBA;EACE,qBAAA;EACA,eAAA;AA5hBF;;AA+hBA;EACE,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;EACA,0CAAA;EACA,mBAAA;AA5hBF;AA8hBE;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AA5hBJ;AAiiBE;EACE,YAAA;EACA,mBAAA;EACA,kBAAA;AA/hBJ;AAoiBE;EACE,mBAAA;EACA,qBAAA;EACA,QAAA;AAliBJ;;AAuiBA;EACE,MAAA;AApiBF;;AAuiBA;EACE,cAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;EACA,iBAAA;AApiBF;;AAwiBA;EACE,gBAAA;EACA,cAAA;EACA,iBAAA;AAriBF;;AAwiBA;EACE,gBAAA;EACA,cAAA;AAriBF;;AAyiBA;EACE,mBC/kFe;ADyiEjB;;AA2iBE;EACE,gBAAA;EACA,cAAA;AAxiBJ;AA2iBE;EACE,gBAAA;EACA,cAAA;AAziBJ;;AAgjBE;EACE,cAAA;AA7iBJ;AAgjBE;EACE,cAAA;AA9iBJ;;AAkjBA;EACE,mBAAA;EACA,kBAAA;EACA,mBAAA;AA/iBF;;AAkjBA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;AA/iBF;;AAkjBA;EACE,0BAAA;EACA,2BAAA;EACA,yBAAA;EACA,0CAAA;EACA,iBAAA;AA/iBF;;AAojBA;EACE,aAAA;EACA,8BAAA;EAIA,MAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AApjBF;AAwjBE;EACE,0BAAA;EACA,UAAA;AAtjBJ;AAwjBI;EACE,4BAAA;EACA,6BAAA;AAtjBN;;AA2jBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;EACA,0CAAA;EACA,gBAAA;EAIA,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,gCAAA;AA3jBF;AA8jBE;EACE,yBAAA;AA5jBJ;AAikBE;EACE,+BAAA;AA/jBJ;AAokBE;EACE,mBAAA;AAlkBJ;AAqkBE;EACE,mBAAA;AAnkBJ;;AA4kBA;EACE,mBAAA;AAzkBF;;AAilBA;EACE,MAAA;AA9kBF;AAklBE;EACE,yBAAA;AAhlBJ;;AAolBA;EACE,aAAA;EACA,cAAA;EACA,cAAA;AAjlBF;AAmlBE;EACE,WAAA;EACA,YAAA;AAjlBJ;AAolBE;EACE,cAAA;AAllBJ;;AAslBA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;EACA,OAAA;AAnlBF;;AAslBA;EACE,0BAAA;EACA,2BAAA;EACA,yBAAA;EACA,0CAAA;EACA,4BAAA;AAnlBF;;AA6lBA;EACE,YAAA;EACA,kBAAA;EACA,mBAAA;AA1lBF;;AA+lBA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,+BCzvFW;ED0vFX,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;AA5lBF;;AA+lBA;EACE,0BAAA;EACA,2BAAA;EACA,yBAAA;EACA,0CAAA;EACA,4BAAA;AA5lBF;;AA+lBA;EACE,cAAA;EAGA,yBAAA;EACA,0BAAA;EACA,2BAAA;EACA,4BAAA;EACA,+BAAA;EACA,2BAAA;EACA,mBAAA;EACA,yBAAA;EACA,2BAAA;EACA,uBAAA;EACA,gBAAA;EACA,6BAAA;EACA,0BAAA;AA9lBF;AAgmBE;;EAEE,SAAA;AA9lBJ;AAimBE;EACE,iBAAA;AA/lBJ;AAkmBE;EACE,gBAAA;AAhmBJ;AAmmBE;EACE,qDAAA;AAjmBJ;AAumBE;EACE,qCAAA;AArmBJ;AAumBI;EACE,wCAAA;AArmBN;;AA6mBA;EACE;IACE,kBAAA;EA1mBF;EA6mBA;IACE,eAAA;IACA,QAAA;IACA,mBAAA;EA3mBF;EA8mBA;IACE,0BAAA;EA5mBF;EAmnBA;IACE,cAAA;EAjnBF;EAonBA,2DAAA;AAlnBF;AAmnBE;EACE;IACE,cAAA;IACA,yBAAA;IACA,iBAAA;IACA,QAAA;IACA,mBAAA;EAjnBJ;AACF;AAklBA;EAkCE;IACE,aAAA;IACA,mBAAA;EAjnBF;EAonBA;IACE,0BAAA;EAlnBF;EAonBE;IACE,WAAA;EAlnBJ;EAwnBA;IACE,kBAAA;EAtnBF;EA4nBA;IACE,gCAAA;EA1nBF;EA6nBA;IACE,mBAAA;EA3nBF;EAioBA;IACE,aAAA;EA/nBF;EAkoBA;IACE,mBAAA;EAhoBF;AACF;AAmoBA;EACE;IACE,eAAA;IACA,gBAAA;EAjoBF;EAooBA;IACE,eAAA;EAloBF;AACF;AAwoBA;EACE,OAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EAEA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AAvoBF;;AA0oBA;EAIE,oBAAA;EACA,mBAAA;EACA,uBAAA;AA1oBF;;AA6oBA;EACE,0BAAA;EACA,cAAA;AA1oBF;;AA+oBA;EACE,cAAA;EACA,0CAAA;EACA,0BAAA;EACA,2BAAA;EACA,8BAAA;EACA,kBAAA;EACA,iBAAA;AA5oBF;;AAipBA;EACE,cAAA;EACA,0CAAA;EACA,0BAAA;EACA,2BAAA;EACA,8BAAA;EACA,kBAAA;EACA,gBAAA;AA9oBF;;AAipBA;EACE,iBAAA;EACA,cAAA;AA9oBF;;AAipBA;EACE,YAAA;EACA,OAAA;AA9oBF;AAgpBE;EACE,gBAAA;EACA,cAAA;EACA,gBAAA;AA9oBJ;;AAkpBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,mBAAA;AA/oBF;AAipBE;EACE,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,0CAAA;AA/oBJ;;AAmpBA;EACE,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,0BAAA;EACA,mBAAA;EACA,cAAA;EACA,cAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,0CAAA;EACA,gBAAA;AAhpBF;;AAmpBA;EACE,mBAAA;EACA,qBAAA;EACA,oBAAA;AAhpBF;;AAmpBA;EACE,YAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,mBAAA;EACA,0CAAA;EACA,gBAAA;EACA,mBAAA;AAhpBF;AAkpBE;EACE,WAAA;EACA,YAAA;AAhpBJ;;AAopBA;EACE,gBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,0CAAA;AAjpBF;;AAopBA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EAEA,kBAAA;EACA,oCAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;AAlpBF;AAopBE;EACE,cAAA;EACA,eAAA;EACA,mBAAA;EACA,0CAAA;EACA,gBAAA;AAlpBJ;AAqpBE;;EAEE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AAnpBJ;AAqpBI;;EACE,cAAA;EACA,WAAA;EACA,YAAA;AAlpBN;AAspBE;EACE,mCAAA;EACA,cAAA;AAppBJ;AAspBI;EACE,cAAA;AAppBN;AAwpBE;EACE,mCAAA;EACA,cAAA;AAtpBJ;AAwpBI;EACE,cAAA;AAtpBN;AA0pBE;EACE,kCAAA;EACA,cAAA;AAxpBJ;AA0pBI;EACE,cAAA;AAxpBN;AA4pBE;EACE,kCAAA;EACA,cAAA;AA1pBJ;AA4pBI;EACE,eAAA;AA1pBN;AA6pBI;EACE,cAAA;AA3pBN;AA+pBE;EACE,oCAAA;EACA,cAAA;AA7pBJ;AA+pBI;EACE,cAAA;AA7pBN;AAiqBE;EACE,oCAAA;EACA,cAAA;AA/pBJ;AAiqBI;EACE,cAAA;AA/pBN;;AAoqBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,yBAAA;AAjqBF;;AAuqBE;;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EAEA,mBAAA;EACA,cAAA;EACA,yBAAA;AApqBJ;AAsqBI;;EACE,WAAA;EACA,YAAA;AAnqBN;AAsqBI;;EACE,mBAAA;AAnqBN;AAsqBE;;EACE,oBAAA;EACA,gBAAA;EACA,2BAAA;EACA,uBAAA;EACA,0CAAA;EACA,gBAAA;EACA,6BAAA;EACA,4BAAA;EACA,2BAAA;EACA,0BAAA;AAnqBJ;AAwqBI;;EACE,WAAA;EACA,YAAA;EACA,eAAA;AArqBN;AAwqBI;;EAEE,oCAAA;AAtqBN;AA0qBE;;EACE,kBAAA;EACA,oBAAA;EACA,gBAAA;EACA,2BAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,0CAAA;EACA,gBAAA;AAvqBJ;AA4qBI;;EACE,WAAA;EACA,YAAA;EACA,eAAA;AAzqBN;AA4qBI;;EACE,aAAA;AAzqBN;AAgrBE;;EACE,8BAAA;EACA,8BAAA;EACA,yCAAA;EACA,6BAAA;EACA,4BAAA;EACA,2BAAA;EACA,0BAAA;AA7qBJ;AA+qBI;;EACE,8BAAA;EACA,UAAA;AA5qBN;;AAkrBA;EACE,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,0CAAA;EACA,kBAAA;EACA,iBAAA;EACA,YAAA;AA/qBF;AAirBE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yCAAA;AA/qBJ;;AAmrBA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAhrBF;;AAmrBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;AAhrBF;;AAmrBA;EACE,OAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,0CAAA;EACA,uBAAA;EACA,qBAAA;AAhrBF;;AAurBA;EACE,8BAAA;EACA,yBAAA;EACA,6BAAA;EAEA,uBAAA;AArrBF;;AA2rBA;EACE,6BAAA;AAxrBF;;AA0rBA;EACE,0BAAA;AAvrBF;;AA0rBA;EACE,yBAAA;EACA,0BAAA;AAvrBF;;AA0rBA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;EACA,cAAA;AAvrBF;AAyrBE;EACE,qCAAA;AAvrBJ;;AA2rBA;EACE;IACE,aAAA;IACA,iBAAA;IACA,gBAAA;IACA,iCAAA;IACA,SAAA;IACA,mBAAA;IACA,qBAAA;IACA,iBAAA;EAxrBF;EA0rBE;IACE,aAAA;EAxrBJ;EA4rBA;IACE,cAAA;IACA,YAAA;IACA,YAAA;EA1rBF;AACF;AA8rBE;EACE,yBCp2GW;EDq2GX,aAAA;AA5rBJ;AA8rBI;EACE,yBAAA;EACA,kBAAA;EACA,aAAA;AA5rBN;AA+rBI;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AA7rBN;AA+rBM;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;AA7rBR;AAisBI;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;AA/rBN;AAksBI;EACE;IACE,eAAA;EAhsBN;EAksBM;IACE,aAAA;EAhsBR;EAosBI;IACE,eAAA;EAlsBN;EAusBY;IACE,aAAA;EArsBd;AACF;AA4sBI;EACE;IACE,eAAA;EA1sBN;AACF;AA8sBE;EACE,eAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,yBC35Ge;ED45Gf,6BAAA;AA5sBJ;AA8sBI;EACE,iBAAA;EEx5GJ,aAAA;EACA,mBAAA;EAOI,8BAAA;AFusFN;AA8sBI;EACE,aAAA;EACA,mBAAA;AA5sBN;AA8sBM;EACE,eAAA;AA5sBR;AA+sBM;EACE,eAAA;EACA,WAAA;EACA,0BAAA;AA7sBR;AAktBE;EACE;IACE,iBAAA;EAhtBJ;EAktBI;IACE,gBAAA;EAhtBN;AACF;;AAqtBA;EACE,oCAAA;AAltBF;;AAqtBA;EACE,sBAAA;AAltBF;AAqtBI;EACE,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AAntBN;AAqtBM;EACE,kBAAA;AAntBR;AAstBM;EACE,gBAAA;EACA,mBAAA;AAptBR;AAstBQ;EACE,yBAAA;EACA,mBAAA;EACA,WAAA;AAptBV;AAutBQ;EACE,8BAAA;EACA,mBAAA;EACA,kBAAA;AArtBV;AAutBU;EAGE,wBAAA;AAvtBZ;AA0tBU;EAEE,eAAA;EACA,gBAAA;EAEA,aAAA;EACA,mBAAA;EACA,QAAA;AA1tBZ;AA4tBY;EACE,eAAA;EAEA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AA3tBd;AA+tBU;EAEE,eAAA;EACA,gBAAA;AA9tBZ;AAiuBU;EACE,cAAA;EACA,eAAA;EAEA,aAAA;EACA,mBAAA;EACA,QAAA;AAhuBZ;AAkuBY;EACE,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AAhuBd;AAouBU;EACE,cAAA;EACA,eAAA;AAluBZ;AAquBU;EACE,cAAA;EACA,eCzgHF;ED0gHE,aAAA;EACA,mBAAA;EACA,QAAA;AAnuBZ;AAquBY;EACE,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AAnuBd;AAuuBU;EACE,cAAA;EACA,eAAA;AAruBZ;AA0uBU;EACE,eAAA;AAxuBZ;AA2uBU;EACE,eAAA;AAzuBZ;AA+uBM;EACE,YAAA;AA7uBR;AA+uBQ;EACE,gBAAA;EACA,kBAAA;AA7uBV;AA+uBU;EACE,yBAAA;EACA,2BAAA;EACA,4BAAA;AA7uBZ;AAgvBc;EACE,aAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AA9uBhB;AAgvBgB;EACE,gBAAA;AA9uBlB;AAivBgB;EACE,kBAAA;EACA,WAAA;AA/uBlB;AAivBkB;EAJF;IAKI,iBAAA;IACA,oBAAA;EA9uBlB;AACF;AAqvBY;EACE,gCAAA;AAnvBd;AAqvBc;EACE,kBAAA;EACA,cAAA;AAnvBhB;AAsvBc;EACE,eAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;AApvBhB;AAiwBkB;EACE,iBAAA;AA/vBpB;AAkwBsB;EADF;IAEI,eAAA;EA/vBtB;AACF;AAwwBgB;EACE,kBAAA;AAtwBlB;AAqxBA;EACE,cAAA;EACA,mBAAA;AAnxBF;AAqxBE;EACE,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,UAAA;AAnxBJ;AAqxBI;EACE,YAAA;EACA,aAAA;EACA,mBAAA;AAnxBN;AAsxBI;EACE,iBAAA;AApxBN;;AAmyBY;EACE,WAAA;AAhyBd;AAkyBc;EACE,WAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;AAhyBhB;;AA6yBE;EACE,mBAAA;AA1yBJ;;AA8yBA;EACE;IACE,mBAAA;IACA,SAAA;EA3yBF;EA8yBA;IACE,YAAA;IAGA,eAAA;EA9yBF;EAizBA;IACE,eAAA;IACA,iBAAA;EA/yBF;EAkzBA;IACE,eAAA;IACA,iBAAA;EAhzBF;EAmzBA;IACE,eAAA;EAjzBF;EAozBA;IACE,oBAAA;EAlzBF;EAqzBA;IACE,OAAA;IACA,aAAA;IACA,kBAAA;EAnzBF;EAszBA;IACE,WAAA;IACA,YAAA;EApzBF;EAuzBA;IACE,0BAAA;IACA,8BAAA;EArzBF;EAwzBA;IACE,sBAAA;IACA,uBAAA;IACA,SAAA;EAtzBF;EAyzBA;IACE,aAAA;EAvzBF;EA0zBA;IACE,aAAA;EAxzBF;EA2zBA;IACE,mBAAA;IACA,aAAA;EAzzBF;EA4zBA;IACE,aAAA;EA1zBF;EA6zBA;IACE,aAAA;EA3zBF;EA8zBA;IACE,uBAAA;EA5zBF;EAg0BE;IACE,WAAA;IACA,SAAA;EA9zBJ;EAk0BA;IACE,mBAAA;IACA,iBAAA;IACA,uBAAA;IACA,QAAA;IACA,sBAAA;EAh0BF;EAm0BA;IACE,OAAA;IACA,YAAA;IACA,WAAA;EAj0BF;EAo0BA;IACE,0BAAA;IACA,2BAAA;IACA,4BAAA;EAl0BF;EAq0BA;IACE,0BAAA;IACA,yBAAA;IACA,eAAA;EAn0BF;EAs0BA;IACE,yBAAA;IACA,YAAA;IACA,cAAA;IACA,wBAAA;IACA,QAAA;IACA,gBAAA;EAp0BF;EAu0BA;IACE,2BAAA;IACA,4BAAA;EAr0BF;EAw0BA;IACE,sBAAA;IACA,uBAAA;IACA,uBAAA;EAt0BF;EAy0BA;IACE,cAAA;IACA,eAAA;IACA,WAAA;EAv0BF;EA00BA;IACE,WAAA;IACA,eAAA;IACA,2BAAA;EAx0BF;EA20BA;;;MAAA;EAIA;IACE,aAAA;IACA,sBAAA;EAz0BF;EA40BA;wEAAA;EAEA;IACE,iBAAA;EA10BF;EA60BA;;;qFAAA;EAIA;IACE,iBAAA;EA30BF;EA80BA;IACE,QAAA;IACA,kBAAA;IACA,0BAAA;IACA,2BAAA;EA50BF;EA+0BA;IACE,QAAA;IACA,mBAAA;EA70BF;EAg1BA;IACE,QAAA;IACA,mBAAA;EA90BF;EAi1BA;IACE,QAAA;EA/0BF;EAk1BA;IACE,QAAA;EAh1BF;EAm1BA,iFAAA;EACA;IACE,QAAA;IACA,6BAAA;IACA,iBAAA;IACA,eAAA;IACA,QAAA;IACA,iBAAA;IACA,mBAAA;IACA,yBAAA;IACA,WAAA;IACA,aAAA;EAj1BF;EAo1BA,iDAAA;EACA;IACE,cAAA;EAl1BF;EAq1BA;yFAAA;EAEA;IACE,iEAAA;EAn1BF;AACF;AAs1BA;EACE;IAEE,gBAAA;EAr1BF;EAy1BE;IACE,SAAA;IACA,QAAA;EAv1BJ;EA21BA;IACE,mBAAA;IACA,iBAAA;IACA,mBAAA;EAz1BF;EA41BA;IACE,YAAA;IACA,aAAA;IACA,yBAAA;EA11BF;EA41BE;IACE,iBAAA;EA11BJ;EA81BI;IACE,gBAAA;IACA,uBAAA;EA51BN;EAi2BA;IACE,SAAA;EA/1BF;EAm2BE;IACE,4BAAA;IACA,iBAAA;EAj2BJ;EAm2BI;IACE,kBAAA;EAj2BN;AACF;AAm2BM;EARF;IASI,YAAA;EAh2BN;AACF;AA6yBA;EAsDI;IACE,aAAA;EAh2BJ;EAo2BI;IACE,mBAAA;EAl2BN;EAu2BI;IACE,aAAA;EAr2BN;AACF;AAg3BA;EACE;IACE,sBAAA;EA92BF;EAi3BA;IACE,aAAA;IACA,sBAAA;IACA,2BAAA;IACA,uBAAA;EA/2BF;EAk3BA;IACE,gBAAA;IACA,qBAAA;EAh3BF;EAo3BE;IACE,WAAA;IACA,YAAA;EAl3BJ;EAo3BI;IACE,YAAA;IACA,aAAA;EAl3BN;AACF;AAu3BA;EAGM;IACE,eAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;EAv3BN;AACF","sourcesContent":["@import \"./mixins.scss\";\n@import \"./variable.scss\";\n\n.dashboard-main {\n  // 106px is an undocumented, empirically-tuned reservation for the AppBar + the space below\n  // it (predates this file's own comments) — left as-is. .dashboard-marketing-banner used to\n  // live inside here, sharing this box's own flex space \"for free\"; now that it's rendered\n  // from appBar_component.tsx as a separate position:fixed element (so it can reuse the\n  // header's fixed-full-width + centered-content pattern instead of a viewport-width breakout\n  // hack), its real measured height has to be reserved on top of the original constant instead.\n  height: calc(100dvh - 106px - var(--marketing-banner-height, 0px));\n  overflow: hidden;\n  overscroll-behavior: none;\n  display: flex;\n  flex-direction: column;\n  margin-right: 0;\n  font-family: $primaryFont;\n  padding-left: 40px;\n  padding-right: 40px;\n\n\n@media screen and (max-width: 480px){\n  padding-left: 0;\n  padding-right: 0;\n}\n}\n\n.dashboard-shell {\n  background: #F7F7F8;\n}\n\n// Rendered from appBar_component.tsx (conditionally, only on the Dashboard route), as a\n// sibling of .revamp-super-user-banner — same fixed-position pattern, pinned directly under\n// the (also fixed) AppBar so it stays put while the queue list scrolls, instead of scrolling\n// away with it the way a normal-flow element would. Because this takes it out of normal\n// document flow, .revamp-appbar-spacer/.dashboard-main's own height both read its real\n// measured height back via --marketing-banner-height (set in appBar_component.tsx) so page\n// content still starts below it instead of underneath it.\n.dashboard-marketing-banner {\n  position: fixed;\n  top: 64px;\n  left: 0;\n  right: 0;\n  z-index: 1090;\n  width: 100%;\n  box-sizing: border-box;\n  background: #ececef;\n  border-bottom: 1px solid #d6d8de;\n}\n\n// Caps/centers the actual content at the header's own wider cap (1920) — same relationship\n// as .revamp-header inside the full-bleed .revamp-appbar.\n.dashboard-marketing-banner-inner {\n  box-sizing: border-box;\n  max-width: var(--app-header-max-width);\n  margin: 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 18px;\n  padding: 8px 20px 8px 24px;\n  position: relative;\n}\n\n.dashboard-marketing-content {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  min-width: 0;\n  flex: 1;\n}\n\n.dashboard-marketing-badge-wrap {\n  display: inline-flex;\n  align-items: center;\n  gap: 0;\n  flex-shrink: 0;\n}\n\n.dashboard-marketing-icon {\n  color: #2E75B6;\n\n  font-size: 16px !important;\n}\n\n.dashboard-marketing-badge {\n  color: #2E75B6;\n  background: #E1E8EF;\n  border-radius: 999px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 6px;\n  line-height: 0;\n}\n\n.dashboard-marketing-text-wrap {\n  flex: 1 1 0;\n  min-width: 0;\n  transition: opacity 0.25s ease, transform 0.25s ease;\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.dashboard-marketing-text-wrap.is-fading {\n  opacity: 0;\n  transform: translateY(4px);\n}\n\n.dashboard-marketing-text {\n  color: #1f2937;\n  font-size: 14px;\n  line-height: 20px;\n  font-weight: 400;\n  white-space: normal;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.dashboard-marketing-indicators {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.dashboard-marketing-indicator {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: #8f9198;\n  opacity: 0.8;\n}\n\n.dashboard-marketing-indicator.is-active {\n  width: 26px;\n  border-radius: 999px;\n  background: #2E75B6;\n  opacity: 1;\n}\n\n// ── Super User pill ──────────────────────────────────────────────────────────\n// Shared between the Dashboard marketing banner (right side) and the standalone\n// banner that appears below the AppBar on all other screens.\n%super-user-pill-base {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  border: 1px solid #D7D7DA;\n  border-radius: 999px;\n  padding: 5px 14px 5px 10px;\n  background: #ffffff;\n  flex-shrink: 0;\n  white-space: nowrap;\n}\n\n.dashboard-super-user-pill {\n  @extend %super-user-pill-base;\n\n  &.is-centered {\n    margin: 0 auto;\n  }\n}\n\n.dashboard-super-user-text {\n  font-size: 14px !important;\n  font-weight: 400;\n  color: #6E6E77 !important;\n  line-height: 20px;\n}\n\n// Standalone super user banner — pinned directly under the (also fixed) AppBar on non-dashboard\n// screens, so it stays put while the page scrolls instead of scrolling away with content.\n// Because this takes it out of normal document flow, .revamp-appbar-spacer's height (below)\n// grows to match it via the --super-user-banner-height custom property (set from\n// appBar_component.tsx) so page content still starts below both instead of underneath them.\n.revamp-super-user-banner {\n  position: fixed;\n  top: 64px;\n  left: 0;\n  right: 0;\n  z-index: 1090;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 12px 24px;\n  background: #F2F2F3;\n  border-bottom: 1px solid #E8E8EC;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.revamp-super-user-pill {\n  @extend %super-user-pill-base;\n}\n\n.revamp-super-user-text {\n  font-size: 14px !important;\n  font-weight: 400;\n  color: #6E6E77 !important;\n  line-height: 20px;\n}\n\n.dashboard-marketing-close {\n  color: #717784 !important;\n  flex-shrink: 0;\n  margin-left: 2px !important;\n  width: 28px;\n  height: 28px;\n\n  &:hover {\n    background: rgba(0, 0, 0, 0.05);\n  }\n}\n\n@media screen and (max-width: 480px) {\n  .dashboard-main {\n    height: calc(100dvh - 118px - var(--marketing-banner-height, 0px));\n  }\n\n  .dashboard-marketing-banner-inner {\n    padding: 8px 10px;\n    gap: 10px;\n    align-items: center;\n  }\n\n  .dashboard-marketing-content {\n    align-items: center;\n    gap: 8px;\n  }\n\n  .dashboard-marketing-badge {\n    padding: 6px;\n    color: #2E75B6;\n  }\n\n  .dashboard-marketing-text {\n    font-size: 14px;\n    line-height: 20px;\n    -webkit-line-clamp: unset;\n    line-clamp: unset;\n    display: block;\n    overflow: visible;\n  }\n\n  .dashboard-marketing-text-wrap {\n    max-width: calc(100vw - 100px);\n  }\n\n  .dashboard-marketing-indicator {\n    width: 7px;\n    height: 7px;\n  }\n\n  .dashboard-marketing-indicator.is-active {\n    width: 16px;\n  }\n}\n\n.version-wrapper-dashboard {\n  padding: 10px 24px;\n  // Full-bleed breakout: this footer should render at the wider header cap (1920) even though\n  // it sits inside .app-content-shell, which is capped to the narrower body width (1440). Safe\n  // here because none of its ancestors (.app-content-shell, the Dashboard root fragment) clip\n  // overflow — unlike .dashboard-main, which this element is a SIBLING of, not a child of.\n  width: 100vw;\n  max-width: var(--app-header-max-width);\n  margin-left: calc(50% - 50vw);\n\n  .tc-pp-container {\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n\n    .terms-wrapper {\n      width: 100%;\n      display: flex;\n      flex-direction: row;\n      // justify-content: space-between;\n\n      .tc-content {\n        color: gray;\n        font-size: 14px;\n        text-decoration: underline;\n        cursor: pointer;\n      }\n    }\n\n    .pp-wrapper {\n      width: 100%;\n\n      p {\n        color: gray;\n        font-size: 14px;\n        text-decoration: underline;\n        cursor: pointer;\n      }\n    }\n\n    .hr-divider {\n      padding: 0 10px;\n    }\n  }\n}\n\n.MuiAppBar-root {\n  &.revamp-appbar {\n    background: #ffffff !important;\n    color: #20242e;\n    box-shadow: none;\n    border-bottom: 1px solid #bdbdc2;\n    position: fixed !important;\n    // Full viewport width, no cap — this is the header's BACKGROUND layer. .revamp-header below\n    // (the actual logo/nav/search content) is what caps at --app-header-max-width (1920) and\n    // centers itself, so the background stays full-bleed edge-to-edge while only the content is\n    // capped/centered inside it.\n    left: 0;\n    right: 0;\n    width: 100%;\n    top: 0 !important;\n    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;\n    // z-index: 1300;\n  }\n\n  .MuiToolbar-root {\n    min-height: 64px;\n\n    .header {\n      @include d_flex($justify_content: space_between);\n      flex-direction: row;\n      width: 100%;\n\n      .header-logo {\n        max-width: 160px;\n        display: flex;\n        align-items: center;\n\n        svg {\n          // color:#fff;\n          font-size: 30px;\n        }\n\n        img {\n          width: 100%;\n          min-width: 100%;\n          max-width: 100%;\n          margin-left: 16px;\n\n          @media (max-width: 540px) {\n            margin-left: 0px;\n            min-width: 110px;\n          }\n        }\n\n        @media (max-width: 540px) {\n          .MuiButtonBase-root {\n            padding-left: 0px;\n          }\n        }\n      }\n\n      @media (max-width: 540px) {\n        // flex-direction: column;\n        align-items: center;\n        row-gap: 8px;\n      }\n    }\n\n    .logout-btn {\n      .MuiButtonBase-root {\n        padding: 7px 16px;\n\n        @media (max-width: 540px) {\n          padding: 10px 9px;\n          min-width: 50px;\n        }\n      }\n\n      .app-bar {\n        .select-dropdown {\n          .MuiInputBase-root {\n            border: 1px solid $white_color;\n            width: 120px;\n\n            .MuiOutlinedInput-notchedOutline {\n              border: none;\n            }\n\n            .MuiSelect-outlined {\n              padding-left: 32px;\n            }\n\n            @media (max-width: 540px) {\n              width: 60px;\n\n              .MuiSelect-outlined {\n                padding-left: 0px;\n                color: transparent !important;\n              }\n            }\n\n            &.Mui-focused {\n              .MuiOutlinedInput-notchedOutline {\n                display: none;\n              }\n\n              font-family: $primaryFont;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n.revamp-appbar-spacer {\n  // + the super user banner's and/or the Dashboard marketing banner's real measured height\n  // (0px when not shown, see appBar_component.tsx) — both are position:fixed right below the\n  // AppBar, so this spacer has to reserve room for whichever is present instead of just the\n  // 64px AppBar alone. The two are mutually exclusive (one only shows off the Dashboard route,\n  // the other only on it), so adding both vars is safe — the inactive one is always 0px.\n  height: calc(64px + var(--super-user-banner-height, 0px) + var(--marketing-banner-height, 0px));\n}\n\n// ── Dashboard scroll-to-hide header ──────────────────────────────────────────\n// Class set on body only from the Dashboard page scroll handler — never affects other pages.\nbody.nav-scrolled-away {\n\n  // AppBar is position:fixed and lives outside .dashboard-shell, so target it directly\n  .MuiAppBar-root.revamp-appbar {\n    transform: translateY(-64px);\n  }\n\n  // The marketing banner stays visible (unlike the AppBar, it doesn't hide on scroll) but\n  // slides up by the same 64px to sit flush where the AppBar used to be, instead of leaving a\n  // 64px gap above it.\n  .dashboard-marketing-banner {\n    transform: translateY(-64px);\n  }\n\n  // Reclaim only the AppBar's 64px — NOT the marketing banner's height too, even though the\n  // banner is fixed like the AppBar. Unlike the AppBar, the banner doesn't hide on scroll (see\n  // .dashboard-marketing-banner's own translateY above) — it just slides up to sit flush where\n  // the AppBar used to be. .dashboard-main is a normal-flow sibling that starts right after\n  // this spacer, so collapsing it all the way to 0 (as if the banner had hidden too) put\n  // dashboard-main's top edge at y:0, directly underneath the still-visible, higher-z-index\n  // banner — hiding the top of the queue content behind it. Keeping var(--marketing-banner-height)\n  // reserved here starts dashboard-main right after the banner instead.\n  .revamp-appbar-spacer {\n    height: var(--marketing-banner-height, 0px);\n  }\n\n  // Reclaim the 60px freed by hiding the AppBar (106px base reservation - 60px = 46px left for\n  // whatever's below it), plus reserve room for the marketing banner on top — it's still\n  // visible while scrolled away, just repositioned (see .dashboard-marketing-banner above).\n  .dashboard-main {\n    height: calc(100dvh - 46px - var(--marketing-banner-height, 0px));\n  }\n\n  @media screen and (max-width: 480px) {\n    .revamp-appbar-spacer {\n      height: var(--marketing-banner-height, 0px);\n    }\n\n    .dashboard-main {\n      height: calc(100dvh - 46px - var(--marketing-banner-height, 0px));\n    }\n  }\n\n  /* version-wrapper is hidden on mobile — nothing left to subtract for it when header also\n     hides, but the marketing banner (if present) still needs its own room reserved */\n  @media screen and (max-width: 600px) {\n    .dashboard-main {\n      height: calc(100dvh - var(--marketing-banner-height, 0px));\n    }\n  }\n}\n\n.revamp-header {\n  box-sizing: border-box;\n  width: 100%;\n  // Caps/centers the header's actual content (logo, nav tabs, search, right icons) at 1920px\n  // while .revamp-appbar (its fixed-position ancestor) stays full viewport width as the\n  // background layer — margin:auto here only has room to center once this element's own\n  // max-width is narrower than its 100%-width parent.\n  max-width: var(--app-header-max-width);\n  margin: 0 auto;\n  min-height: 64px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 24px;\n  // No row-level gap here — spacing between the tabs group, search box, and right-icon\n  // cluster is applied as explicit margins on those elements instead (see\n  // revamp-search-container's marginLeft in appBar_component.tsx and this class's own\n  // marginLeft below), since a shared gap can't give the two boundaries different widths\n  // (16px vs 12px) without a fragile negative-margin offset.\n\n  @media screen and (max-width: 480px) {\n    padding: 10px;\n  }\n}\n\n.revamp-header-left {\n  display: flex;\n  align-items: center;\n  // flex: 0 0 auto — never grows, never shrinks below natural content (logo + whichever tabs\n  // the JS fit algorithm decided to show).\n  //\n  // Grow used to be enabled (flex-grow: 1) to create a \"big gap before search\" look when\n  // nothing was collapsed. But then header-left's rendered width depended on search's own\n  // width (search growing shrinks header-left's share of the free space) — and that resize\n  // isn't a CSS property value actually changing (flex-grow stayed \"1\", only the resolved\n  // layout width did), so it can't be transitioned: it snapped instantly while search's own\n  // width eased in via CSS transition, reading as search \"jumping\" left. The leftover-space/\n  // \"big gap\" look now lives in the invisible spacer before the search box (see\n  // revamp-header-flex-spacer in appBar_component.tsx) instead, so growing search only ever\n  // eats into that empty space and never displaces the tabs.\n  //\n  // Shrink stays disabled too: if header-left could shrink, the browser would split any space\n  // deficit between this and revamp-search-container (both flex-shrink-able) roughly by\n  // content size, meaning header-left — being larger — absorbs more of the squeeze than\n  // intended, letting tabs get visually clipped/overlapped while search stays at its target\n  // width. Pinning shrink:0 forces the *entire* deficit onto search instead, which is the\n  // element actually meant to yield.\n  flex: 0 0 auto;\n  gap: 24px;\n  min-width: 0;\n}\n\n.revamp-mobile-menu-btn {\n  display: none !important;\n}\n\n.revamp-brand-logo {\n  // width: 140px;\n  // min-width: 34px;\n  height: 42px;\n  max-width: 130px;\n  object-fit: contain;\n  object-position: left center;\n}\n\n.revamp-header-tabs {\n  display: flex;\n  align-items: center;\n  // Spacing between tabs is applied per-tab as margin-right (see appBar_component.tsx) —\n  // each tab wrapper animates its own max-width/opacity/margin when collapsing into \"More\",\n  // which a flex `gap` here can't participate in.\n}\n\n.revamp-tab {\n  &.MuiButtonBase-root {\n    min-width: unset;\n    border-radius: 8px;\n    color: #3d3d42;\n    text-transform: none;\n    font-size: 14px;\n    font-weight: 400;\n    font-family: $primaryFont;\n    padding: 8px;\n    gap: 8px;\n    min-height: 36px;\n  }\n\n  &:hover {\n    background: #F5F6F8 !important;\n  }\n\n  &.Mui-disabled {\n    opacity: 0.5;\n  }\n\n  &.active.MuiButtonBase-root {\n    background: $primary_color;\n    color: var(--color-contrast-text);\n\n    &:hover {\n      background: $primary_color !important;\n    }\n  }\n}\n\n.revamp-tab-label {\n  // Inline text node wrapper — allows CSS to hide labels at compact viewports\n  // without touching the icon or the Button element itself.\n  display: inline;\n}\n\n.revamp-tab-icon-wrap {\n  width: 16px;\n  height: 16px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n\n  // svg {\n  //   width: 16px;\n  //   height: 16px;\n  // }\n}\n\n.revamp-header-right {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-left: 12px;\n}\n\n// Search text (input, category selector, persisted-text pill) is set inline via sx at a\n// fixed 14px in appBar_component.tsx. Rather than hardcode a matching size in each of those\n// scattered Typography/input elements, they defer to this container's own font-size — which\n// the breakpoint tiers below then shrink in lockstep with .revamp-tab, so search and the\n// nav tabs never show mismatched sizes at the same viewport width.\n.revamp-search-container {\n  font-size: 14px;\n\n  // Scoped to this class (rather than a blanket input/p/Typography selector) so the\n  // search-results dropdown — also rendered inside this container — keeps its own\n  // fixed, readable text size instead of shrinking along with the header's compression tiers.\n  .revamp-search-header-text {\n    font-size: inherit !important;\n    font-family: $primaryFont !important;\n  }\n\n  // Expanded (focused/typing) width — a flat 450px target at every viewport width. Trimmed\n  // down from 530px so the tab-fit budget (see recompute() in appBar_component.tsx) has more\n  // room to keep tabs visible instead of collapsing them into \"More\" while search is open.\n  &.is-expanded {\n    width: min(450px, 100%);\n    max-width: 450px;\n  }\n}\n\n@media screen and (max-width: 900px) {\n  .revamp-mobile-menu-btn {\n    display: inline-flex !important;\n    width: 34px;\n    height: 34px;\n    color: #3d3d42;\n  }\n\n  .revamp-header-left {\n    gap: 10px;\n  }\n\n  .revamp-brand-logo {\n    width: 120px;\n    min-width: 120px;\n    height: 28px;\n  }\n\n  .revamp-header-right {\n    gap: 8px;\n  }\n\n  .revamp-user-info {\n    display: none;\n  }\n\n  .revamp-lang-btn.MuiButtonBase-root {\n    padding: 5px 8px;\n  }\n}\n\n// ─── 1201–1380px: moderate compression — tighten tabs, keep name/role visible ───\n@media screen and (min-width: 1201px) and (max-width: 1380px) {\n  .revamp-header-left {\n    gap: 6px;\n  }\n\n  .revamp-brand-logo {\n    width: 115px;\n    min-width: 100px;\n    height: 28px;\n  }\n\n  .revamp-tab {\n    &.MuiButtonBase-root {\n      font-size: 13px;\n      padding: 6px 8px;\n      gap: 5px;\n    }\n  }\n\n  .revamp-search-container {\n    font-size: 13px;\n  }\n\n  .revamp-header-right {\n    gap: 8px;\n  }\n\n  .revamp-lang-btn.MuiButtonBase-root {\n    padding: 5px 8px;\n    gap: 5px;\n    font-size: 13px;\n  }\n}\n\n// ─── 1024–1200px: text+icon tabs, capped search bar ─────────────────────────\n// Name/role stays visible here — the tabs group (flex:1) already absorbs the\n// tighter space via smaller fonts/padding, so there's no need to hide it too.\n@media screen and (min-width: 1024px) and (max-width: 1200px) {\n  .revamp-header-left {\n    gap: 4px;\n  }\n\n  .revamp-brand-logo {\n    width: 100px;\n    min-width: 90px;\n    height: 26px;\n  }\n\n  .revamp-tab {\n    &.MuiButtonBase-root {\n      font-size: 12px;\n      padding: 6px 7px;\n      gap: 4px;\n    }\n  }\n\n  .revamp-search-container {\n    font-size: 12px;\n  }\n\n  .revamp-header-right {\n    gap: 6px;\n  }\n\n  .revamp-lang-btn.MuiButtonBase-root {\n    padding: 5px 7px;\n    gap: 4px;\n    font-size: 12px;\n  }\n}\n\n// ─── 901–1023px: icon-only tabs — major space saving for search + right ──────\n@media screen and (min-width: 901px) and (max-width: 1023px) {\n  .revamp-header-left {\n    gap: 6px;\n  }\n\n  .revamp-brand-logo {\n    width: 100px;\n    min-width: 90px;\n    height: 26px;\n  }\n\n  // Icon-only: hide the text label, keep icon\n  .revamp-tab-label {\n    display: none;\n  }\n\n  .revamp-tab {\n    &.MuiButtonBase-root {\n      padding: 6px;\n      gap: 0;\n      min-width: 36px;\n    }\n  }\n\n  .revamp-search-container {\n    font-size: 13px;\n  }\n\n  .revamp-header-right {\n    gap: 6px;\n  }\n\n  .revamp-user-info {\n    display: none;\n  }\n\n  .revamp-lang-btn.MuiButtonBase-root {\n    padding: 5px 8px;\n    gap: 4px;\n    font-size: 13px;\n  }\n}\n\n.revamp-lang-btn {\n  &.MuiButtonBase-root {\n    min-width: unset;\n    border-radius: 8px;\n    background: rgba(10, 10, 10, 0.05);\n    color: #3d3d42;\n    font-family: $primaryFont;\n    text-transform: none;\n    padding: 8px;\n    gap: 8px;\n    font-size: 14px;\n\n    &:hover {\n      background: #F2F2F3;\n    }\n  }\n}\n\n.revamp-globe-icon {\n  width: 16px;\n  height: 16px;\n\n  svg {\n    width: 16px;\n    height: 16px;\n  }\n}\n\n.revamp-chevron-icon {\n  width: 8px;\n  height: 5px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n\n  svg {\n    width: 8px;\n    height: 5px;\n    display: block;\n  }\n}\n\n.revamp-lang-menu {\n  .MuiPaper-root {\n    border: 1px solid #dfe3ef;\n    border-radius: 10px;\n    margin-top: 6px;\n    min-width: 140px;\n    box-shadow: 0 10px 24px rgba(23, 33, 61, 0.12);\n  }\n\n  .MuiMenuItem-root {\n    font-size: 14px;\n    color: #2d3345;\n  }\n\n  .MuiMenuItem-root.Mui-selected {\n    background: #eef2ff;\n    color: #20285c;\n    font-weight: 600;\n  }\n}\n\n.revamp-bell-wrap {\n  width: 32px;\n  height: 32px;\n  border-radius: 64px;\n  background: rgba(10, 10, 10, 0.05);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  &:hover {\n    background: rgba(10, 10, 10, 0.1);\n  }\n}\n\n.revamp-notification-icon {\n  // position: relative;\n  // width: 16px;\n  // height: 16px;\n\n  // svg:first-child {\n  //   position: absolute;\n  //   width: 6px;\n  //   height: 6px;\n  //   top: -1px;\n  //   right: -1px;\n  // }\n\n  svg // :last-child \n\n    {\n    position: absolute;\n    width: 18px;\n    height: 18px;\n    right: 0px;\n  }\n}\n\n.revamp-user-info {\n  text-align: right;\n  min-width: 80px;\n  max-width: 180px;\n\n  .name {\n    font-size: 14px;\n    color: #18181b;\n    line-height: 18px;\n    font-weight: 400;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .role {\n    font-size: 12px;\n    color: #3d3d42;\n    line-height: 16px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n}\n\n.revamp-user-avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  svg {\n    width: 40px;\n    height: 40px;\n  }\n}\n\n.revamp-profile-trigger {\n  width: 40px;\n  height: 40px;\n  padding: 0;\n}\n\n.revamp-profile-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(16, 19, 31, 0.35);\n  z-index: 1390;\n}\n\n.revamp-profile-menu-panel {\n  position: fixed;\n  top: 66px;\n  // right: 24px from the CONTENT's actual right edge, not the viewport's — .revamp-header caps\n  // at 1920px and centers itself inside the full-width .revamp-appbar, so above 1920px viewport\n  // width the profile icon sits inboard of the true screen edge by half the leftover space. A\n  // plain \"right: 24px\" (relative to the viewport, since this is position:fixed) ignored that\n  // gap and rendered this panel in the literal screen corner instead of near the icon.\n  right: calc((100vw - min(100vw, 1920px)) / 2 + 24px);\n  width: 260px;\n  min-height: 85px;\n  gap: 4px;\n  opacity: 1;\n  border-radius: 8px;\n  padding: 10px;\n  background: $primary_color;\n  box-shadow: 0px 10px 24px rgba(20, 27, 62, 0.35);\n  display: flex;\n  flex-direction: column;\n  z-index: 1400;\n}\n\n// Name/role block inside the profile popup — only shown when the header's own\n// name/role text (.revamp-user-info) is hidden to save space, so it's always\n// reachable somewhere rather than disappearing entirely on smaller/zoomed screens.\n.revamp-profile-menu-user {\n  display: none;\n  flex-direction: column;\n  padding: 4px 8px 8px;\n  margin-bottom: 4px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.15);\n\n  .name {\n    color: var(--color-contrast-text);\n    font-size: 15px;\n    line-height: 20px;\n    font-weight: 600;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    font-family: $primaryFont !important;\n  }\n\n  .role {\n    color: var(--color-contrast-text);\n    opacity: 0.7;\n    font-size: 12px;\n    line-height: 16px;\n    font-weight: 400;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    font-family: $primaryFont !important;\n  }\n\n  @media screen and (max-width: 1023px) {\n    display: flex;\n  }\n}\n\n.revamp-profile-menu-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-height: 40px;\n  border-radius: 6px;\n  padding: 0 8px;\n\n  .item-icon {\n    color: var(--color-contrast-text);\n    font-size: 18px;\n  }\n\n  .item-text {\n    color: var(--color-contrast-text);\n    font-size: 15px;\n    line-height: 20px;\n    font-weight: 400;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    font-family: $primaryFont !important;\n  }\n\n  &.clickable {\n    cursor: pointer;\n\n    &:hover {\n      background: rgba(255, 255, 255, 0.08);\n    }\n  }\n}\n\n@media screen and (max-width: 900px) {\n  .revamp-profile-menu-panel {\n    top: auto;\n    bottom: 80px;\n    left: 16px;\n    right: auto;\n  }\n}\n\n.MuiStack-root.dashboard-heading {\n  flex-direction: row;\n  max-width: 100% !important;\n  padding: 16px 10px 16px 10px;\n  align-items: center;\n  justify-content: space-between;\n  // margin: 0 auto;\n  background: transparent;\n  border: 0;\n  box-shadow: none;\n  gap: 16px;\n  flex-shrink: 0;\n\n  .black-btn {\n    text-transform: capitalize;\n    letter-spacing: 0.25px;\n    border-radius: 8px;\n    min-height: 40px;\n    font-family: $primaryFont !important;\n  }\n\n  @media screen and (max-width: 480px) {\n    padding-top: 8px;\n  }\n}\n\n.dashboard-heading-copy {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.pending-approval-banner {\n  border: 1px solid #d6dce9;\n}\n\n.dashboard-welcome-title {\n  // letter-spacing: -0.4px;\n  color: #000000 !important;\n  line-height: 1.2;\n  font-family: $primaryFont !important;\n  font-size: 18px !important;\n  font-weight: 600 !important;\n}\n\n.dashboard-welcome-subtitle {\n  color: #6e6e77;\n  font-size: 14px;\n  line-height: 20px;\n  font-weight: 400;\n  font-family: $primaryFont !important;\n\n  .attention-count {\n    color: #f00214;\n    font-weight: 500;\n  }\n}\n\n.dashboard-status-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  min-height: 26px;\n  padding: 0 14px;\n  border: 1px solid #bdbdc2;\n  border-radius: 999px;\n  background: #efeff1;\n  cursor: default;\n}\n\n.dashboard-status-chip-icon {\n  font-size: 16px !important;\n  color: #6e6e77;\n}\n\n.dashboard-status-chip-label {\n  color: #1f1f23;\n  font-family: $primaryFont !important;\n  font-size: 14px !important;\n  font-weight: 500 !important;\n  line-height: 20px !important;\n}\n\n.dashboard-status-tooltip-popper {\n  .dashboard-status-tooltip {\n    background: #6E6E77 !important;\n    color: #ffffff !important;\n    border-radius: 4px !important;\n    max-width: 360px;\n    padding: 12px 14px !important;\n    // box-shadow: 0px 10px 24px rgba(17, 24, 39, 0.24) !important;\n  }\n\n  .dashboard-status-tooltip-arrow {\n    color: #6E6E77 !important;\n    font-size: 18px !important;\n  }\n}\n\n.dashboard-status-tooltip-text {\n  font-family: $primaryFont !important;\n  font-size: 14px !important;\n  font-weight: 500 !important;\n  line-height: 20px !important;\n  color: #ffffff;\n}\n\n@media screen and (min-width: 900px) {\n  .dashboard-welcome-subtitle {\n    font-size: 16px;\n    line-height: 24px;\n    color: #6e6e77;\n  }\n\n  .dashboard-welcome-subtitle .attention-count {\n    font-size: 16px;\n  }\n}\n\n.dashboard-heading .header-btns .MuiButtonBase-root {\n  border-radius: 8px;\n  font-weight: 400;\n  min-height: 40px;\n  padding: 8px 16px;\n\n  .MuiTypography-root {\n    font-size: 14px;\n    line-height: normal;\n    font-weight: 400;\n    font-family: $primaryFont !important;\n  }\n}\n\n.dashboard-heading .header-btns {\n  flex-wrap: nowrap;\n  align-items: center;\n  min-width: 0;\n}\n\n.dashboard-header-search {\n  flex: 1 1 auto;\n  min-width: 120px;\n  max-width: 370px;\n\n  .MuiOutlinedInput-root {\n    width: 100%;\n    min-height: 40px;\n    border-radius: 8px;\n    background: #ffffff;\n    color: #3d3d42;\n    font-family: $primaryFont !important;\n\n    .MuiOutlinedInput-input {\n      padding: 10px 12px 10px 0;\n      font-size: 14px;\n      line-height: 20px;\n      color: #3d3d42;\n\n      &::placeholder {\n        color: #6E6E77;\n        opacity: 1;\n      }\n    }\n\n    .MuiInputAdornment-root {\n      color: #6e6e77;\n      margin-right: 8px;\n    }\n\n    .MuiSvgIcon-root {\n      font-size: 16px;\n      color: #6B7280;\n    }\n  }\n}\n\n.MuiInputBase-root {\n  .MuiOutlinedInput-notchedOutline {\n    border-color: #BDBDC2;\n  }\n}\n\n.dashboard-heading .header-btns .revamp-extra-btn {\n  display: none;\n}\n\n.dashboard-heading .header-btns .dashboard-refresh-btn.MuiButtonBase-root {\n  border: 0;\n  background: transparent;\n  color: #2e75b6;\n  min-height: 40px;\n  min-width: 102px;\n  padding: 8px 12px;\n  flex-shrink: 0;\n  align-self: center;\n\n  .MuiTypography-root {\n    color: #2e75b6;\n    font-weight: 400;\n  }\n\n  .MuiButton-startIcon {\n    margin-right: 6px;\n  }\n\n  .MuiButton-startIcon .MuiSvgIcon-root {\n    font-size: 18px;\n  }\n\n  &:hover {\n    border: 0;\n    background: rgba(46, 117, 182, 0.08) !important;\n  }\n}\n\n.dashboard-heading .header-btns .MuiButton-contained {\n  box-shadow: none;\n}\n\n.dashboard-heading .header-btns .send-link-btn.MuiButtonBase-root {\n  border: 1px solid $primary_color;\n  background: #ffffff;\n  color: #215c20;\n  border-radius: 8px;\n  min-height: 40px;\n  padding: 8px 16px;\n  text-transform: none;\n  flex-shrink: 0;\n\n  // &:hover {\n  //   border-color: #bdbdc2;\n  //   background: #ffffff;\n  // }\n\n  .MuiTypography-root {\n    color: $primary_color;\n  }\n\n  .MuiButton-startIcon {\n    margin-right: 8px;\n  }\n\n  .MuiButton-startIcon svg {\n    width: 16px;\n    height: 16px;\n  }\n\n  //  &:hover {\n  //           // background: #F5F6F8;\n  //           border-color: #B0B4C0;\n  //           color:#000000 !important\n  //       }\n}\n\n.dashboard-heading .header-btns .MuiButton-contained.MuiButtonBase-root {\n  background: $primary_color;\n  color: var(--color-contrast-text);\n  flex-shrink: 0;\n\n  &:hover {\n    // background: #a61e32;\n  }\n}\n\n.dashboard-heading .header-btns .new-application-btn.MuiButtonBase-root {\n  min-width: 192px;\n}\n\n.dashboard-heading .header-btns .MuiButtonBase-root {\n  white-space: nowrap;\n}\n\n@media screen and (max-width: 900px) {\n  .MuiStack-root.dashboard-heading {\n    padding: 16px 20px;\n    gap: 14px;\n  }\n\n  .dashboard-welcome-title {\n    font-size: 28px;\n  }\n\n  .dashboard-welcome-subtitle {\n    font-size: 14px;\n    line-height: 20px;\n  }\n\n  .dashboard-status-chip {\n    min-height: 32px;\n    padding: 0 12px;\n  }\n\n  .dashboard-status-chip-label {\n    font-size: 13px !important;\n  }\n\n  .dashboard-heading .header-btns {\n    gap: 8px;\n    min-width: 0;\n  }\n\n  .dashboard-header-search {\n    flex: 1 1 auto;\n    min-width: 100px;\n    max-width: 370px;\n  }\n\n  .dashboard-heading .header-btns .MuiButtonBase-root {\n    min-width: 0;\n    padding-left: 12px;\n    padding-right: 12px;\n    min-height: 36px;\n\n    .MuiTypography-root {\n      font-size: 13px;\n    }\n  }\n}\n\n@media screen and (max-width: 600px) {\n  .MuiStack-root.dashboard-heading {\n    flex-wrap: nowrap;\n    flex-direction: row;\n    align-items: center;\n  }\n\n  .dashboard-heading .header-btns {\n    gap: 8px;\n    min-width: 0;\n    align-items: center;\n  }\n\n  // Uniform 36×36 tap targets — overrides sx-prop min-height from MUI\n  .dashboard-heading .header-btns .MuiButtonBase-root {\n    width: 36px;\n    height: 36px;\n    min-width: 36px !important;\n    min-height: 36px !important;\n    padding: 0;\n    flex-shrink: 0;\n\n    .MuiButton-startIcon {\n      margin: 0;\n    }\n\n    .MuiTypography-root {\n      font-size: 14px;\n      line-height: 1;\n    }\n  }\n\n  // Quote-history-actions (All Applications PageHeader) — same alignment rules\n  .quote-history-actions .MuiButtonBase-root {\n    width: 36px;\n    height: 36px;\n    min-width: 36px !important;\n    min-height: 36px !important;\n    padding: 0;\n    flex-shrink: 0;\n\n    .MuiButton-startIcon {\n      margin: 0;\n    }\n  }\n\n  .quote-history-actions {\n    gap: 8px;\n    align-items: center;\n  }\n\n  .dashboard-header-search {\n    flex: 1 1 auto;\n    min-width: 80px;\n  }\n\n  .dashboard-heading .header-btns .dashboard-refresh-btn.MuiButtonBase-root {\n    padding: 0;\n  }\n\n  .dashboard-status-chip {\n    min-height: 30px;\n    padding: 0 10px;\n  }\n\n  .dashboard-status-chip-label {\n    font-size: 12px !important;\n    line-height: 18px !important;\n  }\n\n  .dashboard-heading .header-btns .new-application-btn.MuiButtonBase-root {\n    min-width: 0;\n  }\n}\n\n.MuiPopover-root {\n  .MuiPaper-root {\n    .dialog-wrapper.MuiBox-root {\n      .each-create {\n        border: 1px solid $primary_color;\n        margin: 8px 18px;\n        padding: 6px;\n        border-radius: 4px;\n        cursor: pointer;\n\n        .dialog-icon {\n          background-color: $icon_bg;\n          height: 32px;\n          width: 32px;\n          border-radius: 50%;\n          align-items: center;\n          justify-content: center;\n          display: flex;\n\n          svg {\n            width: 19px;\n            color: $primary_color;\n          }\n        }\n\n        .dialog-text {\n          .dialog-header {\n            font-size: 14px;\n            font-weight: 500;\n            color: $primary_color;\n          }\n\n          .dialog-label {\n            font-size: 14px;\n            font-weight: 400;\n            color: $light_gray;\n          }\n        }\n\n        &:hover {\n          background-color: $quote-bgColor;\n        }\n      }\n    }\n\n    .dialog-wrapper:not(:first-child) {\n      svg {\n        path {\n          stroke: $primary_color;\n        }\n      }\n    }\n\n    .dialog-wrapper:first-child {\n      .each-create {\n        margin-top: 18px;\n      }\n    }\n\n    .dialog-wrapper:last-child {\n      .each-create {\n        margin-bottom: 18px;\n      }\n    }\n  }\n}\n\n.cstPopover {\n  .MuiPaper-root {\n    left: auto !important;\n    top: 140px !important;\n    right: 30px;\n  }\n\n  .cstLocIcon {\n    path {\n      stroke: $primary_color !important;\n    }\n  }\n}\n\n.program-salesrep-dialog {\n  .MuiDialog-paper {\n    border-radius: 12px;\n    max-width: 600px;\n    width: 100%;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);\n  }\n\n  .select-app-type-dialog {\n    .select-app-type-header {\n      background-color: #f5f5f5;\n      border-bottom: 1px solid #e0e0e0;\n\n      .select-app-type-title {\n        font-size: 18px;\n        font-weight: 600;\n        color: #2b2b30;\n      }\n\n      .select-app-type-close-btn {\n        color: #666;\n      }\n    }\n  }\n\n  // Grid and form control styling\n  .MuiGrid-root {\n    .MuiFormControl-root {\n      width: 100%;\n    }\n\n    // Smooth transition for conditional fields\n    .MuiBox-root {\n      animation: slideIn 0.3s ease-in-out;\n    }\n\n    @keyframes slideIn {\n      from {\n        opacity: 0;\n        transform: translateY(-10px);\n      }\n\n      to {\n        opacity: 1;\n        transform: translateY(0);\n      }\n    }\n  }\n\n  // AutoComplete dropdown styling when opened\n  .MuiAutocomplete-paper {\n    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);\n    border-radius: 8px;\n  }\n\n  .MuiAutocomplete-popper {\n    max-width: 100% !important;\n  }\n\n  .MuiAutocomplete-listbox {\n    padding: 8px 0;\n\n    .MuiAutocomplete-option {\n      &:hover {\n        background-color: rgba(66, 133, 244, 0.08);\n      }\n\n      &[aria-selected=\"true\"] {\n        background-color: rgba(66, 133, 244, 0.12);\n\n        &:hover {\n          background-color: rgba(66, 133, 244, 0.12);\n        }\n      }\n    }\n  }\n\n  // Input field styling\n  .MuiOutlinedInput-root {\n    border-radius: 8px;\n    transition: all 0.2s ease-in-out;\n\n    &:hover {\n      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n    }\n\n    &.Mui-focused {\n      box-shadow: 0 2px 12px rgba(66, 133, 244, 0.15);\n    }\n\n    &.Mui-error {\n      .MuiOutlinedInput-notchedOutline {\n        border-color: #f44336;\n      }\n    }\n  }\n\n  // Label styling\n  .MuiInputLabel-root {\n    color: #666;\n\n    &.Mui-error {\n      color: #f44336;\n    }\n  }\n\n  // Helper text (errors)\n  .MuiFormHelperText-root {\n    margin-top: 4px;\n    font-size: 12px;\n\n    &.Mui-error {\n      color: #f44336;\n    }\n  }\n\n  // Button styles\n  .MuiButton-outlined {\n    text-transform: none;\n    color: $primary_color;\n    border-color: $primary_color;\n    border-radius: 8px;\n    padding: 8px 16px;\n    font-size: 14px;\n    font-weight: 500;\n    transition: all 0.2s ease-in-out;\n\n    &:hover {\n      // border-color: #3d3d42;\n      // background-color: #f7f7f8;\n    }\n\n    &:active {\n      transform: scale(0.98);\n    }\n  }\n\n  .MuiButton-contained {\n    text-transform: none;\n    background-color: $primary_color;\n    border-radius: 8px;\n    padding: 8px 24px;\n    font-size: 14px;\n    font-weight: 600;\n    transition: all 0.2s ease-in-out;\n    box-shadow: 0 2px 8px rgba(66, 133, 244, 0.3);\n\n    &:hover {\n      opacity: 0.88;\n      // background-color: #a61e32;\n      box-shadow: 0 4px 12px rgba(66, 133, 244, 0.4);\n    }\n\n    &:active {\n      transform: scale(0.98);\n    }\n\n    &:disabled {\n      background-color: #ccc;\n      box-shadow: none;\n    }\n  }\n\n  // Dialog content padding and spacing\n  .MuiBox-root[role=\"presentation\"] {\n    >.MuiBox-root {\n      padding: 24px;\n    }\n  }\n}\n\n.create-app-dialog {\n  .MuiDialog-paper {\n    border-radius: 12px;\n    max-width: 480px;\n    width: 100%;\n  }\n\n  .select-app-type-dialog {\n    padding: 0;\n  }\n\n  .select-app-type-header {\n    padding: 16px 20px;\n  }\n\n  .select-app-type-title {\n    font-size: 16px;\n    font-weight: 400;\n    color: #10131f;\n  }\n\n  .select-app-type-close-btn {\n    width: 32px;\n    height: 32px;\n  }\n\n  .select-app-type-list {\n    padding: 0 12px 12px;\n  }\n\n  .dialog-wrapper {\n    cursor: pointer;\n\n    .each-create {\n      border: none;\n      background-color: #f7f7f8;\n      margin: 8px 6px;\n      padding: 12px;\n      border-radius: 8px;\n\n      .dialog-icon {\n        background-color: $primary_color;\n        height: 40px;\n        width: 40px;\n        min-width: 40px;\n        border-radius: 8px;\n        align-items: center;\n        justify-content: center;\n        display: flex;\n\n        svg {\n          width: 20px;\n          color: var(--color-contrast-text);\n\n          path {\n            stroke: var(--color-contrast-text);\n          }\n        }\n      }\n\n      .dialog-text {\n        .dialog-header {\n          font-size: 15px;\n          font-weight: 600;\n          color: $primary_color;\n        }\n\n        .dialog-label {\n          font-size: 13px;\n          font-weight: 400;\n          color: $light_gray;\n        }\n      }\n\n      &:hover {\n        background-color: #ededf0;\n      }\n    }\n  }\n}\n\n.filtr-date-pkr {\n  .MuiOutlinedInput-root {\n    background-color: #fff;\n  }\n\n  .MuiStack-root {\n    padding: 0px;\n    width: 100%;\n  }\n\n  // .Mui-error {\n  //   margin: 0px;\n  // }\n\n  &.analyticsPicker {\n    .clear-date {\n      top: 26px;\n    }\n\n    @media screen and (max-width: 1024px) {\n      .clear-date {\n        top: 8px;\n      }\n    }\n  }\n}\n\n.dashboard-application {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  padding: 0px 24px;\n\n  .reset-search-btn {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    position: relative;\n    top: 17px;\n\n    @media only screen and (min-width: 481px) and (max-width: 768px) {\n      top: 0;\n    }\n\n    @media only screen and (min-width: 320px) and (max-width: 480px) {\n      top: 0;\n    }\n  }\n}\n\n.dashboard-filters-panel {\n  max-width: 1300px;\n  margin: 20px auto 8px;\n  padding: 18px;\n  background: #ffffff;\n  border: 1px solid #dfe3ef;\n  border-radius: 14px;\n  box-shadow: 0 6px 20px rgba(24, 39, 75, 0.05);\n}\n\n.dashboard-filters-panel .reset-search-btn {\n  width: 100%;\n  gap: 12px;\n}\n\n.dashboard-filters-panel .filtr-search {\n  width: 100%;\n}\n\n.dashboard-filters-panel .filtr-search .MuiFormControl-root {\n  width: 100%;\n}\n\n.dashboard-reset-stack .btn-txt {\n  height: 40px;\n  border-radius: 10px;\n  border-color: #cfd6e6;\n  color: #2a3555;\n  font-weight: 600;\n}\n\n.dashboard-queue-heading {\n  max-width: 100% !important;\n  // margin: 0 auto;\n  padding: 0 0px;\n  border-radius: 8px;\n  flex-shrink: 0;\n}\n\n.dashboard-queue-heading .queue-heading-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.dashboard-queue-heading .queue-heading-icon {\n  width: 28px;\n  height: 28px;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n\n  svg {\n    width: 20px;\n    height: 20px;\n  }\n}\n\n.dashboard-queue-heading .queue-heading-text {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n// Title + \" - \" + subtitle rendered as one non-wrapping line — the subtitle is the one that\n// truncates with an ellipsis if the pair is too long for the available width; the title\n// (flex-shrink: 0 below) always stays fully visible.\n.dashboard-queue-heading .queue-title-line {\n  display: flex;\n  align-items: baseline;\n  min-width: 0;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.dashboard-queue-heading .queue-title {\n  flex-shrink: 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: #6E6E77;\n  font-family: $primaryFont !important;\n  line-height: 1.3;\n}\n\n.dashboard-queue-heading .queue-subtitle {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  min-width: 0;\n  font-size: 14px;\n  font-weight: 400;\n  color: #3D3D42;\n  font-family: $primaryFont !important;\n  line-height: 1.4;\n}\n\n.dashboard-kpi-grid {\n  max-width: 100% !important;\n  // margin: 0 auto;\n  display: grid;\n  grid-template-columns: repeat(6, minmax(0, 1fr));\n  gap: 16px;\n  padding: 0px 10px;\n  flex-shrink: 0;\n  transform: translateZ(0);\n  will-change: transform;\n}\n\n.kpi-card {\n  background: #ffffff;\n  border: 1px solid #d7d7da;\n  border-radius: 8px;\n  height: 69px;\n  padding: 0;\n  display: flex;\n  align-items: stretch;\n  gap: 8px;\n  overflow: hidden;\n  cursor: pointer;\n  transition:\n    transform 0.15s ease,\n    box-shadow 0.15s ease;\n\n  &:hover {\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n\n    transform: translateY(-1px);\n  }\n\n  // &.active {\n  //     box-shadow: 0 0 0 2px rgba(32, 40, 92, 0.12);\n  // }\n}\n\n// Staggered rise + fade — plays once when the KPI strip first mounts on landing (see\n// playLandingEntrance in Dashboard.tsx). Below 1024px, where the strip becomes a horizontal\n// swipe row (see .dashboard-kpi-grid), it cascades in left-to-right instead, matching the\n// strip's own left-to-right scroll direction.\n.kpi-card.kpi-card-enter {\n  opacity: 0;\n  transform: translateY(26px);\n  animation: dashboardKpiCardRiseUp 0.55s cubic-bezier(0.22, 0.9, 0.32, 1) forwards;\n\n  @for $i from 1 through 6 {\n    &:nth-child(#{$i}) {\n      animation-delay: #{($i - 1) * 0.1}s;\n    }\n  }\n}\n\n@keyframes dashboardKpiCardRiseUp {\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@media screen and (max-width: 1024px) {\n  .kpi-card.kpi-card-enter {\n    transform: translateX(-18px);\n    animation-name: dashboardKpiCardCascadeIn;\n    animation-duration: 0.48s;\n    animation-timing-function: cubic-bezier(0.16, 0.84, 0.44, 1);\n\n    @for $i from 1 through 6 {\n      &:nth-child(#{$i}) {\n        animation-delay: #{($i - 1) * 0.07}s;\n      }\n    }\n  }\n\n  @keyframes dashboardKpiCardCascadeIn {\n    to {\n      opacity: 1;\n      transform: translateX(0);\n    }\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .kpi-card.kpi-card-enter {\n    animation: none;\n    opacity: 1;\n    transform: none;\n  }\n}\n\n.kpi-card-left {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 7px;\n  width: 32px;\n  // min-width: 52px;\n  height: 67px;\n  padding: 6px 12px;\n  background: #f2f2f3;\n  border-radius: 4px 0 0 8px;\n}\n\n.kpi-card-left .kpi-count {\n  font-size: 24px;\n  line-height: 28px;\n  font-weight: 700;\n  color: #3d3d42;\n  font-family: $primaryFont !important;\n}\n\n.kpi-card-right {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 11px;\n  justify-content: center;\n  padding: 12px 8px 12px 0;\n  flex: 1;\n  min-width: 0;\n}\n\n.kpi-icon {\n  width: 20px;\n  height: 20px;\n  border-radius: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n\n  svg {\n    width: 100%;\n    height: 100%;\n  }\n}\n\n.kpi-label {\n  font-size: 12px !important;\n  line-height: 14px;\n  font-weight: 500;\n  font-family: $primaryFont !important;\n  white-space: nowrap;\n  text-align: left;\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.kpi-card-right .kpi-amount {\n  font-size: clamp(14px, 1.05vw, 16px);\n  line-height: 19px;\n  color: #3d3d42;\n  font-weight: 400;\n  font-family: $primaryFont !important;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.kpi-danger {\n  // border: 1px solid #ED0012 !important;\n  // box-shadow: 0px -4px 12px 22px rgba(0, 0, 0, 0.04), 4px 4px 12px 22px rgba(0, 0, 0, 0.04);\n\n  // .kpi-card-left {\n  //   border-left: 2px solid #ED0012;\n  // }\n\n  .kpi-icon {\n    color: #f00214;\n  }\n\n  .kpi-label {\n    color: #f00214;\n  }\n\n  // .kpi-card-right .kpi-amount {\n  //   font-weight: 600;\n  //   font-size: 16px;\n  // }\n}\n\n.kpi-card.kpi-danger {\n  border-left: 4px solid #f00214;\n}\n\n.kpi-success {\n  .kpi-icon {\n    color: #12b981;\n  }\n\n  .kpi-label {\n    color: #12b981;\n  }\n}\n\n.kpi-card.kpi-success {\n  border-left: 4px solid #12b981;\n}\n\n.kpi-warning {\n  .kpi-icon {\n    color: #6E6E77;\n  }\n\n  .kpi-label {\n    color: #6E6E77;\n  }\n}\n\n.kpi-card.kpi-warning {\n  border-left: 4px solid #6E6E77;\n}\n\n.kpi-info {\n  .kpi-icon {\n    color: #4F46E5;\n  }\n\n  .kpi-label {\n    color: #4F46E5;\n  }\n}\n\n.kpi-card.kpi-info {\n  border-left: 4px solid #4F46E5;\n}\n\n.kpi-neutral {\n  .kpi-icon {\n    color: #18181b;\n  }\n\n  .kpi-label {\n    color: #18181b;\n  }\n}\n\n.kpi-card.kpi-neutral {\n  border-left: 4px solid #18181b;\n}\n\n.kpi-request-docs {\n  .kpi-icon {\n    color: #CC4F00;\n  }\n\n  .kpi-label {\n    color: #CC4F00;\n  }\n}\n\n.kpi-card.kpi-request-docs {\n  border-left: 4px solid #CC4F00;\n}\n\n.kpi-docs-out {\n  .kpi-icon {\n    color: #2E75B6;\n  }\n\n  .kpi-label {\n    color: #2E75B6;\n  }\n}\n\n.kpi-card.kpi-docs-out {\n  border-left: 4px solid #2E75B6;\n}\n\n.kpi-card.kpi-teal {\n  border-left: 4px solid #08704E;\n}\n.kpi-teal {\n  .kpi-icon {\n    color: #08704E;\n  }\n\n  .kpi-label {\n    color: #08704E;\n  }\n}\n\n// Selected-state glow — offset/blur/spread match the Figma \"State=Selected\" spec\n// (0px 2px 12px 8px); each card uses its own supplied tint/alpha.\n.kpi-card.kpi-danger.active {\n  border: 1.5px solid #f00214;\n  border-left: 4px solid #f00214;\n  box-shadow: 0px 2px 12px 8px #EF798314;\n}\n\n.kpi-card.kpi-success.active {\n  border: 1.5px solid #12b981;\n  border-left: 4px solid #12b981;\n  box-shadow: 0px 2px 12px 8px rgba(18, 185, 129, 0.08);\n}\n\n.kpi-card.kpi-warning.active {\n  border: 1.5px solid #6E6E77;\n  border-left: 4px solid #6E6E77;\n  box-shadow: 0px 2px 12px 8px #3D3D421F;\n}\n\n.kpi-card.kpi-info.active {\n  border: 1.5px solid #4F46E5;\n  border-left: 4px solid #4F46E5;\n  box-shadow: 0px 2px 12px 8px #4F46E514;\n}\n\n.kpi-card.kpi-neutral.active {\n  border: 1.5px solid #18181b;\n  border-left: 4px solid #18181b;\n  box-shadow: 0px 2px 12px 8px rgba(24, 24, 27, 0.08);\n}\n\n.kpi-card.kpi-request-docs.active {\n  border: 1.5px solid #CC4F00;\n  border-left: 4px solid #CC4F00;\n  box-shadow: 0px 2px 12px 8px #993B0014;\n}\n\n.kpi-card.kpi-docs-out.active {\n  border: 1.5px solid #2E75B6;\n  border-left: 4px solid #2E75B6;\n  box-shadow: 0px 2px 12px 8px #2E75B614;\n}\n\n.kpi-card.kpi-teal.active {\n  border: 1.5px solid #08704E;\n  border-left: 4px solid #08704E;\n  box-shadow: 0px 2px 12px 8px #0D946814;\n}\n\n.kpi-card.search-disabled {\n  opacity: 0.35;\n  cursor: not-allowed;\n  pointer-events: none;\n\n  &:hover {\n    box-shadow: none;\n    transform: none;\n  }\n}\n\n// Wrapper that owns the flex-grow and hosts the custom scrollbar track. overflow stays visible\n// (rather than hidden) specifically so that track — absolutely positioned outside this box, out\n// in .dashboard-main's own right padding — isn't clipped; .dashboard-action-queue-list itself\n// still clips its own vertical scroll via overflow-y on that element alone.\n.dashboard-queue-scroll-wrap {\n  flex: 1 1 0;\n  min-height: 0;\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  overflow: visible;\n}\n\n.dashboard-action-queue-list {\n  max-width: 100% !important;\n  // Top padding gives the first card's own top-side box-shadow (see .action-queue-card-item's\n  // hover shadow, offset upward) room to render instead of being clipped flush against this\n  // scroll container's own boundary — every other card already has that room \"for free\" via the\n  // gap above it from its previous sibling, which is why only the first item looked cut off.\n  padding: 10px 10px 8px 10px;\n  display: flex;\n  flex-direction: column;\n  // gap: 16px;\n  flex: 1 1 0;\n  min-height: 0;\n  overflow-y: auto;\n  // Left/right box-shadow on the cards below was being clipped too: setting overflow-y alone\n  // implicitly computes overflow-x as non-visible as well (per the CSS spec, an axis left at its\n  // 'visible' default gets forced to 'auto' once the other axis isn't 'visible'), which clips\n  // any shadow bleeding past this container's own left/right edges. Same split-axis technique\n  // already used on .dashboard-main elsewhere in this file for the same reason.\n  overflow-x: visible;\n  overscroll-behavior: contain;\n\n  // The native scrollbar is replaced by .dashboard-queue-scrollbar-track/-thumb (a separate\n  // element living outside this list, in the page's own margin — see the JS-driven thumb in\n  // Dashboard.tsx) — hide the browser's own so they don't render two scrollbars side by side.\n  scrollbar-width: none;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n}\n\n// Positioned outside .dashboard-queue-scroll-wrap's own box entirely — out in .dashboard-main's\n// 40px right padding (see dashboard.scss:4-19) — rather than in the gap between it and the queue\n// list, so it reads as sitting past the card content, not as part of the card's own layout.\n.dashboard-queue-scrollbar-track {\n  position: absolute;\n  top: 6px;\n  bottom: 0;\n  right: -18px;\n  width: 8px;\n  background: #d0d0d4;\n  border-radius: 999px;\n}\n\n.dashboard-queue-scrollbar-thumb {\n  position: absolute;\n  left: 0;\n  width: 100%;\n  border-radius: 999px;\n  background: #8e8e9a;\n  cursor: pointer;\n\n  &:hover {\n    background: #6e6e77;\n  }\n}\n\n.action-queue-card {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  // border: 1px solid #f2f2f3;\n  border-radius: 8px;\n  padding: 16px 10px 8px 10px;\n  // margin-bottom: 10px;\n  // min-height: 100px;\n  // transition: box-shadow 0.2s ease, background 0.2s ease;\n  // &:hover {\n  //   // background: #f9f9fb;\n  //   box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  // }\n}\n\n// Tablet range (iPad Mini 768px / iPad Air ~820px portrait, up through iPad landscape) — the\n// queue title/subtitle and the Sort control used to fight for the same row's width here and\n// visibly collide/truncate. Below 601px .dashboard-queue-heading is hidden entirely (see the\n// max-width:600px block further down), so this range only needs to handle the width in between.\n// Stacking the Sort control onto its own row (rather than relying on flex-wrap's width-dependent\n// threshold) keeps the layout the same and predictable across the whole range, instead of\n// wrapping only for some queues' longer titles and not others.\n@media screen and (min-width: 601px) and (max-width: 1024px) {\n  .action-queue-card {\n    flex-wrap: wrap;\n    row-gap: 8px;\n  }\n\n  .dashboard-queue-heading .queue-heading-row {\n    flex: 1 1 100%;\n    min-width: 0;\n  }\n\n  .action-queue-card .queue-sort-trigger {\n    margin-left: auto;\n  }\n}\n\n// .action-queue-card-item {\n//   box-sizing: border-box;\n//   display: flex;\n//   flex-direction: row;\n//   justify-content: space-between;\n//   align-items: center;\n//   padding: 12px 16px 12px 24px;\n//   gap: 10px;\n//   background: #ffffff;\n//   border-radius: 8px;\n//   border: 1px solid #e8eaf0;\n//   transition: box-shadow 0.2s ease, border-color 0.2s ease;\n\n//   &:hover {\n//     box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.06), 0px 4px 12px rgba(0, 0, 0, 0.06);\n//     // border-color: #c5c9d6;\n//   }\n// }\n\n// dashbaird card highlight\n// .action-queue-card-item {\n//   box-sizing: border-box;\n//   display: flex;\n//   flex-direction: row;\n//   justify-content: space-between;\n//   align-items: center;\n//   padding: 12px 16px 12px 24px;\n//   gap: 10px;\n\n//   background: #fff;\n//   border: 1px solid #e8eaf0;\n//   border-radius: 8px;\n\n//   transition:\n//     transform 0.2s ease,\n//     box-shadow 0.2s ease,\n//     border-color 0.2s ease,\n//     background-color 0.2s ease;\n\n//   &:hover {\n//     transform: translateX(-2px);\n//     background-color: #fcfcfd;\n//     border-color: #d6dae5;\n//     box-shadow:\n//       0 4px 10px rgba(0, 0, 0, 0.08),\n//       0 10px 20px rgba(0, 0, 0, 0.05);\n//   }\n\n//   &:active {\n//     transform: translateX(0);\n//     box-shadow:\n//       0 2px 6px rgba(0, 0, 0, 0.08);\n//   }\n// }\n\n.action-queue-card-item {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 16px 12px 24px;\n  gap: 10px;\n\n  position: relative;\n  isolation: isolate;\n\n  background: #ffffff;\n  border-radius: 8px;\n  // Figma \"List card\" style — shadow only, no border.\n  // box-shadow: 0px 2px 12px 4px rgba(17, 24, 40, 0.06);\n\n  transition:\n    box-shadow 0.2s ease,\n    border-color 0.2s ease,\n    background 0.2s ease;\n\n  &:active {\n    box-shadow:\n      0 2px 8px rgba(0, 0, 0, 0.08);\n    border-radius: 8px;\n  }\n}\n\n// Staggered rise + fade — plays once when the queue list first mounts on landing (see\n// playQueueLandingEntrance in Dashboard.tsx), not on every subsequent card-category switch.\n.action-queue-card-item.queue-card-enter {\n  opacity: 0;\n  transform: translateY(26px);\n  animation: dashboardQueueCardRiseUp 0.55s cubic-bezier(0.22, 0.9, 0.32, 1) forwards;\n\n  @for $i from 1 through 8 {\n    &:nth-child(#{$i}) {\n      animation-delay: #{($i - 1) * 0.1}s;\n    }\n  }\n  // Beyond the first 8, keep entering rather than staying invisible if the delay rule above\n  // doesn't cover them — same delay as the 8th card so the list doesn't have a long tail wait.\n  &:nth-child(n + 9) {\n    animation-delay: 0.7s;\n  }\n}\n\n@keyframes dashboardQueueCardRiseUp {\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .action-queue-card-item.queue-card-enter {\n    animation: none;\n    opacity: 1;\n    transform: none;\n  }\n}\n\n// Hover gradient matches the active KPI card colour.\n// The KPI class is set on .dashboard-action-queue-list so all items inherit it.\n@mixin queue-item-hover($r, $g, $b) {\n  &:hover {\n    // background:\n    //   linear-gradient(270deg, rgba($r, $g, $b, 0) 0%, rgba($r, $g, $b, 0.07) 100%),\n    //   #ffffff;\n    // The directional layers below only really show up near the corners they're offset\n    // toward — along the middle of the left/right edges (between the top and bottom-corner\n    // layers) there was no layer casting shadow straight sideways, so that stretch of each\n    // side still looked shadow-less. Added explicit 0-y, ±x \"pure side\" layers (no vertical\n    // offset) so the full height of both edges gets consistent coverage, not just the corners.\n    box-shadow: 0 0 10px 2px #b8bec7;\n    border-color: #d8dde8;\n    cursor: pointer;\n  }\n}\n\n.dashboard-action-queue-list.kpi-danger      .action-queue-card-item { @include queue-item-hover(240, 2, 20); }\n.dashboard-action-queue-list.kpi-request-docs .action-queue-card-item { @include queue-item-hover(204, 79, 0); }\n.dashboard-action-queue-list.kpi-docs-out    .action-queue-card-item { @include queue-item-hover(46, 117, 182); }\n.dashboard-action-queue-list.kpi-warning     .action-queue-card-item { @include queue-item-hover(110, 110, 119); }\n.dashboard-action-queue-list.kpi-info        .action-queue-card-item { @include queue-item-hover(79, 70, 229); }\n.dashboard-action-queue-list.kpi-teal        .action-queue-card-item { @include queue-item-hover(8, 112, 78); }\n\n// ── Action Needed expanded card layout ───────────────────────────────────────\n.action-queue-card-item.action-queue-card-action-needed {\n  flex-direction: column;\n  align-items: stretch;\n  padding: 12px 16px;\n  gap: 0;\n}\n\n.action-needed-top-row {\n  display: flex;\n  justify-content: space-between;\n  // Buttons now center against the combined height of the title+metadata column beside them\n  // (see .action-needed-title-meta-col) instead of just the title's own line height.\n  align-items: center;\n  // margin-bottom: 8px;\n  gap: 12px;\n}\n\n// Title + metadata stacked together so .action-needed-top-actions (a row sibling) can center\n// vertically against their combined height, not just the title line alone.\n.action-needed-title-meta-col {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-width: 0;\n}\n\n.action-needed-company {\n  font-size: 20px !important;\n  font-weight: 700 !important;\n  color: #3D3D42 !important;\n  font-family: $primaryFont !important;\n  line-height: normal;\n  min-width: 0;\n}\n\n.action-needed-top-actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n}\n\n.action-needed-edit-btn.MuiButtonBase-root {\n  // gap: 4px;\n}\n\n.action-needed-meta-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px 18px;\n  margin-bottom: 12px;\n  margin-top: 5px;\n  font-family: $primaryFont !important;\n  font-size: 14px;\n\n  .action-needed-meta-item {\n    font-size: 14px;\n    font-family: $primaryFont !important;\n    color: #6E6E77; // label text — lighter gray\n\n    strong {\n      font-weight: 600;\n      color: #111827; // value text — dark\n    }\n  }\n}\n\n.action-needed-pills-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 10px;\n}\n\n// Only rendered when the reasons block shows — separates it from the pills row with a\n// visible rule instead of a large unbroken gap.\n.action-needed-reasons-divider.MuiDivider-root {\n  border-color: #D7D7DA;\n  margin: 0 -16px;\n}\n\n.action-needed-pill {\n  display: inline-flex;\n  align-items: center;\n  border: 1px solid #A2A2A9;\n  border-radius: 4px;\n  padding: 4px 8px;\n  gap: 8px;\n  font-size: 12px;\n  color: #374151;\n  font-family: $primaryFont !important;\n  white-space: nowrap;\n\n  &.action-needed-pill-blue {\n    background: #EFF6FF;\n    border-color: #BFDBFE;\n    color: #2E75B6;\n  }\n\n  // Documents Sent chip (Docs Out for Signature queue card) only — flat grey fill instead of\n  // the bordered look every other pill here uses.\n  &.action-needed-pill-docs-sent {\n    border: none;\n    background: #F2F2F3;\n    border-radius: 4px;\n  }\n\n  // In Queue status — stands out from every other status value (which just uses the plain\n  // grey/dark pill above) with its own amber chip, per design.\n  &.action-needed-pill-in-queue {\n    background: #FFF8E9;\n    border-color: #C8BA9D;\n    gap: 4px;\n  }\n}\n\n// Stage + Status combined in one bordered box with a divider\n.action-needed-pill-combined {\n  gap: 0;\n}\n\n.action-needed-pill-divider {\n  color: #bdbdc2;\n  font-weight: 300;\n  margin: 0 10px;\n  line-height: 1;\n  user-select: none;\n}\n\n// Pill label — regular weight, muted color; VALUE gets bold via action-needed-pill-value\n.action-needed-pill-key {\n  font-weight: 400;\n  color: #6E6E77;\n  margin-right: 2px;\n}\n\n.action-needed-pill-value {\n  font-weight: 500;\n  color: #3D3D42;\n}\n\n// Stage pill: value in primary brand color\n.action-needed-pill-value-primary {\n  color: $primary_color;\n}\n\n// Blue pill overrides — key slightly muted, value full blue bold\n.action-needed-pill-blue {\n  .action-needed-pill-key {\n    font-weight: 600;\n    color: #2E75B6;\n  }\n\n  .action-needed-pill-value {\n    font-weight: 600;\n    color: #2E75B6;\n  }\n}\n\n// In Queue pill overrides — both key and value in the same amber tone (per design, unlike the\n// blue pill above which only bolds the value)\n.action-needed-pill-in-queue {\n  .action-needed-pill-key {\n    color: #993B00;\n  }\n\n  .action-needed-pill-value {\n    color: #993B00;\n  }\n}\n\n.action-needed-reasons {\n  background: #FFFFFF;\n  border-radius: 8px;\n  padding: 12px 0 8px;\n}\n\n.action-needed-reasons-heading {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 10px;\n}\n\n.action-needed-reasons-title {\n  font-size: 14px !important;\n  font-weight: 600 !important;\n  color: #ED0012 !important;\n  font-family: $primaryFont !important;\n  line-height: 16px;\n}\n\n// \"Task List\" — a single bordered table, cells divided by 1px lines rather than a\n// gapped card grid, per Figma.\n.action-needed-reasons-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  // Reasons can render 1-3 lines (title, note, uploaded filename) — leave Grid's default\n  // \"stretch\" in place so both cells in a row match height and their borders/dividers stay\n  // aligned; each item then vertically centers its own content (see .action-needed-reason-item).\n  gap: 0;\n  border: 1px solid #D7D7DA;\n  border-radius: 8px;\n  overflow: hidden;\n\n  // Exactly one reason total — keep it at single-column width instead of the usual 2-column\n  // layout (no filler cell is rendered for this case — see Dashboard.tsx).\n  &.action-needed-reasons-grid--single {\n    grid-template-columns: 1fr;\n    width: 50%;\n\n    .action-needed-reason-item {\n      grid-column: auto !important;\n      border-right: none !important;\n    }\n  }\n}\n\n.action-needed-reason-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  font-size: 14px;\n  color: #3D3D42;\n  font-family: $primaryFont !important;\n  font-weight: 400;\n  // Without this, min-height applies only to the content box (this element isn't covered by\n  // a border-box reset here), so the padding on top adds on top of min-height instead of\n  // counting toward it — inflating the row past its intended height.\n  box-sizing: border-box;\n  background: #F7F7F8;\n  padding: 8px;\n  min-height: 40px;\n  border-bottom: 1px solid #D7D7DA;\n\n  // Only the item actually under the cursor gets highlighted, not every row in the grid.\n  &:hover {\n    background-color: #FFFFFF;\n  }\n\n  // Left-column cells get a vertical divider; the last row (1 or 2 cells) drops the\n  // bottom divider so the table doesn't end with a trailing line.\n  &:nth-child(odd) {\n    border-right: 1px solid #D7D7DA;\n  }\n\n  // The true last row is the final pair — for an odd reason count, Dashboard.tsx renders an\n  // extra filler cell so the DOM count is always even and this pairing logic just works.\n  &:last-child {\n    border-bottom: none;\n  }\n\n  &:nth-last-child(2):nth-child(odd) {\n    border-bottom: none;\n  }\n}\n\n// A row-mate carrying an uploaded filename renders 2 lines and stretches the row taller than\n// this cell's own 1-line content — center it in that stretched height instead of leaving it\n// pinned to the top with uneven space below. Only applies when this cell itself has no\n// filename line (see Dashboard.tsx's hasSubtitle) — a cell that does have one keeps the\n// default top-align above so its own 2-line block doesn't get pushed by centering.\n.action-needed-reason-item--no-subtitle {\n  align-items: center;\n}\n\n// Odd-total filler cell (see Dashboard.tsx) — an empty grid item so the last row's right\n// track still shows the grey background + divider instead of collapsing to blank space.\n// It carries no content, so it never needs its own bottom/right divider logic beyond what\n// .action-needed-reason-item already applies by DOM position (it's always last-child, and\n// always in an even position so it never gets a right-hand divider of its own).\n.action-needed-reason-item--filler {\n  gap: 0;\n\n  // Base .action-needed-reason-item:hover swaps in the \"active row\" white background — this\n  // cell has no content of its own, so keep it on the grid's grey background regardless of hover.\n  &:hover {\n    background-color: #F7F7F8;\n  }\n}\n\n.action-needed-reason-status {\n  display: flex;\n  flex-shrink: 0;\n  color: #BDBDC2;\n\n  svg {\n    width: 18px;\n    height: 18px;\n  }\n\n  &.action-needed-reason-status--done {\n    color: #0D9468;\n  }\n}\n\n.action-needed-reason-text {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n  flex: 1;\n}\n\n.action-needed-reason-title {\n  font-size: 14px !important;\n  font-weight: 600 !important;\n  color: #000000 !important;\n  font-family: $primaryFont !important;\n  line-height: 16px !important;\n}\n\n// Document-type chip at the end of a reason's text — inline so it wraps with the last word.\n// No margin on the chip: the gap before it is a zero-width space carrying a fixed 10px margin\n// (below). The space is still the line-break point, and at a break the margin stays at the end\n// of the previous line, so a wrapped chip starts flush with the text — and the gap is the same\n// in every vendor font. The gap is top-aligned (a 0-size span left on the baseline makes its\n// line 5px taller) and the chip is the title's 16px line height, so a reason with a chip is\n// exactly as tall as one without.\n.action-needed-reason-doc-chip-gap {\n  font-size: 0;\n  margin-right: 10px;\n  vertical-align: top;\n}\n\n// 12px line + 2px top/bottom padding = the title's 16px line, with the label centered in the chip\n// (the chip's center also lines up with the reason text's center).\n.action-needed-reason-doc-chip {\n  display: inline-block;\n  padding: 2px 6px;\n  border-radius: 4px;\n  background-color: #E4E4E7;\n  color: #3F3F46;\n  font-family: $primaryFont;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 12px;\n  white-space: nowrap;\n  vertical-align: top;\n}\n\n.action-needed-reason-subtitle {\n  font-size: 12px !important;\n  font-weight: 400 !important;\n  color: #6E6E77 !important;\n  font-family: $primaryFont !important;\n  line-height: 14px !important;\n}\n\n.action-needed-reason-action {\n  flex-shrink: 0;\n  // Nudged in from the row's own right edge so it doesn't sit flush against it.\n  // margin-right: 30px;\n  color: #2E75B6 !important;\n  font-size: 12px !important;\n  font-weight: 400 !important;\n  line-height: 14px !important;\n  text-transform: none !important;\n  min-width: unset !important;\n  white-space: nowrap;\n  border: 1px solid #2E75B6;\n  min-height: 26px !important;\n  height: 26px !important;\n  box-shadow: none;\n  border-radius: 6px !important;\n  padding: 0 10px !important;\n\n  .MuiButton-startIcon,\n  .MuiButton-endIcon {\n    margin: 0;\n  }\n\n  .MuiButton-startIcon {\n    margin-right: 4px;\n  }\n\n  .MuiButton-endIcon {\n    margin-left: 4px;\n  }\n\n  &:hover {\n    background-color: rgba(46, 117, 182, 0.08) !important;\n  }\n\n  // The plain color: #2E75B6 !important above wins regardless of state, so a disabled button\n  // (e.g. In Queue rows) never looked any different from an enabled one — override it explicitly\n  // to MUI's own disabled-action grey instead.\n  &.Mui-disabled {\n    color: rgba(0, 0, 0, 0.26) !important;\n\n    &:hover {\n      background-color: transparent !important;\n    }\n  }\n}\n\n// ─────────────────────────────────────────────────────────────────────────────\n\n// ── Responsive: action-needed card ───────────────────────────────────────────\n@media screen and (max-width: 768px) {\n  .action-queue-card-item.action-queue-card-action-needed {\n    padding: 14px 14px;\n  }\n\n  .action-needed-top-row {\n    flex-wrap: wrap;\n    gap: 8px;\n    margin-bottom: 10px;\n  }\n\n  .action-needed-company {\n    font-size: 16px !important;\n  }\n\n  // Forces the title+meta column onto its own full-width line so .action-needed-top-actions\n  // (a row sibling) wraps below it instead of squeezing beside it — moved here from\n  // .action-needed-company directly, since the title is no longer a direct child of the\n  // wrapping row (it's nested inside .action-needed-title-meta-col alongside the meta row).\n  .action-needed-title-meta-col {\n    flex: 1 1 100%;\n  }\n\n  /* 601px–768px: actions stay in the top row, pushed right */\n  @media screen and (min-width: 601px) {\n    .action-needed-top-actions {\n      flex: 1 1 auto;\n      justify-content: flex-end;\n      flex-wrap: nowrap;\n      gap: 6px;\n      align-items: center;\n    }\n  }\n\n  .action-needed-meta-row {\n    gap: 4px 16px;\n    margin-bottom: 10px;\n  }\n\n  .action-needed-reasons-grid {\n    grid-template-columns: 1fr;\n\n    &.action-needed-reasons-grid--single {\n      width: 100%;\n    }\n  }\n\n  // Single column: every cell is a \"left\" cell in DOM order, so the odd-child vertical\n  // divider from the 2-column layout would otherwise show up as a stray trailing edge.\n  .action-needed-reason-item:nth-child(odd) {\n    border-right: none;\n  }\n\n  // Single column: every item is its own row, so the desktop \"second-to-last drops its\n  // border when the total is even\" pairing rule doesn't apply here — restore it, then\n  // remove only the true last item's border below.\n  .action-needed-reason-item:nth-last-child(2) {\n    border-bottom: 1px solid #D7D7DA;\n  }\n\n  .action-needed-reason-item:last-child {\n    border-bottom: none;\n  }\n\n  // Single column: the desktop filler cell (see Dashboard.tsx) would otherwise stack in as\n  // an empty trailing row here, so hide it — then remove the border-bottom the rule above\n  // restored on the item right before it, since that item is now the true last visible row.\n  .action-needed-reason-item--filler {\n    display: none;\n  }\n\n  .action-needed-reason-item:has(+ .action-needed-reason-item--filler) {\n    border-bottom: none;\n  }\n}\n\n@media screen and (max-width: 480px) {\n  .action-needed-pill {\n    font-size: 12px;\n    padding: 3px 8px;\n  }\n\n  .action-needed-meta-row .action-needed-meta-item {\n    font-size: 13px;\n  }\n}\n\n// Matches the plain-fill layout the table empty-states (NoApplicationsFound, NoQuotesFound,\n// NoSentApplications) use — no card background/border, just a centered column filling the\n// available space.\n.action-queue-empty-state {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  // gap: 24px;\n  padding: 32px 16px;\n  background: #ffffff;\n  border: 1px solid #f2f2f3;\n  border-radius: 8px;\n}\n\n.action-queue-empty-icon-wrap {\n  // ActionQueueEmptyIcon is now a wider self-contained illustration (mailbox + badge +\n  // decorative marks) with its own coloring — no circular backing needed behind it, unlike\n  // the plain glyph icon this previously wrapped.\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.action-queue-empty-icon {\n  font-size: 44px !important;\n  color: #6e6e77;\n}\n\n// Title styling and the 20px/4px spacing rhythm below both match the table empty-states'\n// inline sx (mt: 2.5 after the icon, mt: 0.5 between title and subtitle).\n.action-queue-empty-text {\n  color: #3D3D42;\n  font-family: $primaryFont !important;\n  font-size: 16px !important;\n  font-weight: 600 !important;\n  line-height: normal !important;\n  text-align: center;\n  padding-top: 20px;\n}\n\n// Subtext shown alongside .action-queue-empty-text only for the \"search matched nothing\"\n// variant (see the headerSearchText branch above).\n.action-queue-empty-subtext {\n  color: #6E6E77;\n  font-family: $primaryFont !important;\n  font-size: 12px !important;\n  font-weight: 400 !important;\n  line-height: normal !important;\n  text-align: center;\n  padding-top: 8px;\n}\n\n.dashboard-accordian {\n  max-width: 1300px;\n  margin: 0 auto;\n}\n\n.action-queue-main {\n  min-width: 0;\n  flex: 1;\n\n  .contract-id {\n    font-weight: 600;\n    color: #6E6E77;\n    margin-left: 4px;\n  }\n}\n\n.action-queue-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n  margin-bottom: 15px;\n\n  .company {\n    font-size: 16px;\n    line-height: normal;\n    font-weight: 500;\n    color: #000000;\n    font-family: $primaryFont !important;\n  }\n}\n\n.status-pill {\n  border: 1px solid #bdbdc2;\n  background: #ffffff;\n  border-radius: 24px;\n  font-size: 12px !important;\n  line-height: normal;\n  color: #3d3d42;\n  padding: 0 8px;\n  height: 24px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  white-space: nowrap;\n  font-family: $primaryFont !important;\n  font-weight: 400;\n}\n\n.status-pill.soft {\n  background: #f9f9f9;\n  border-color: #d7d7da;\n  border-radius: 100px;\n}\n\n.status-pill.time {\n  border: none;\n  color: #6e6e77;\n  padding: 0;\n  border-radius: 0;\n  background: transparent;\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 12px;\n  line-height: normal;\n  font-family: $primaryFont !important;\n  font-weight: 400;\n  white-space: nowrap;\n\n  svg {\n    width: 12px;\n    height: 12px;\n  }\n}\n\n.equipment-line {\n  margin: 0 0 12px;\n  color: #6E6E77;\n  font-size: 14px;\n  line-height: 20px;\n  font-family: $primaryFont !important;\n}\n\n.action-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 0 8px;\n  // height: 24px;\n  border-radius: 4px;\n  background: rgba(249, 154, 162, 0.2);\n  color: #f00214;\n  font-size: 12px;\n  line-height: normal;\n  font-weight: 400;\n\n  .MuiTypography-root {\n    color: #f00214;\n    font-size: 12px;\n    line-height: normal;\n    font-family: $primaryFont !important;\n    font-weight: 400;\n  }\n\n  .queue-arrow-sm,\n  .queue-arrow-lg {\n    width: 12px;\n    height: 12px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n\n    svg {\n      display: block;\n      width: 100%;\n      height: 100%;\n    }\n  }\n\n  &.success {\n    background: rgba(18, 185, 129, 0.2);\n    color: #12b981;\n\n    .MuiTypography-root {\n      color: #12b981;\n    }\n  }\n\n  &.warning {\n    background: rgba(248, 184, 75, 0.2);\n    color: #f8b84b;\n\n    .MuiTypography-root {\n      color: #f8b84b;\n    }\n  }\n\n  &.info {\n    background: rgba(0, 102, 244, 0.2);\n    color: #0066f4;\n\n    .MuiTypography-root {\n      color: #0066f4;\n    }\n  }\n\n  &.neutral {\n    background: rgba(24, 24, 27, 0.08);\n    color: #18181b;\n\n    &.clickable {\n      cursor: pointer;\n    }\n\n    .MuiTypography-root {\n      color: #18181b;\n    }\n  }\n\n  &.orange {\n    background: rgba(249, 115, 22, 0.15);\n    color: #f97316;\n\n    .MuiTypography-root {\n      color: #f97316;\n    }\n  }\n\n  &.teal {\n    background: rgba(20, 184, 166, 0.15);\n    color: #14b8a6;\n\n    .MuiTypography-root {\n      color: #14b8a6;\n    }\n  }\n}\n\n.action-queue-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding-left: 24px;\n  justify-content: flex-end;\n}\n\n// Button styles apply to both the old right-side action area and the new top-row area\n.action-queue-actions,\n.action-needed-top-actions {\n  .queue-icon-btn.MuiButtonBase-root {\n    width: 32px;\n    height: 32px;\n    border-radius: 6px;\n    // padding: 8px;\n    background: #ffffff;\n    color: #18181b;\n    border: 1px solid #D7D7DA;\n\n    svg {\n      width: 16px;\n      height: 16px;\n    }\n\n    &:hover {\n      background: #f9fafc;\n    }\n  }\n  .action-file-upload-btn.MuiButtonBase-root {\n    text-transform: none;\n    min-width: unset;\n    min-height: 32px !important;\n    height: 32px !important;\n    font-family: $primaryFont !important;\n    box-shadow: none;\n    border-radius: 6px !important;\n    padding: 8px 16px !important;\n    font-weight: 400 !important;\n    font-size: 12px !important;\n\n    // Matches the 16px icon size used by .queue-icon-btn's action icons (App Summary,\n    // Preview, etc.) so the primary button's icon reads as the same icon, not an\n    // oversized variant of it.\n    .MuiButton-startIcon > * {\n      width: 16px;\n      height: 16px;\n      font-size: 16px;\n    }\n\n    &:hover {\n      // opacity: 0.95;\n      border: 1px solid #D7D7DA !important;\n    }\n  }\n\n  .action-open-btn.MuiButtonBase-root {\n    border-radius: 8px;\n    text-transform: none;\n    min-width: unset;\n    min-height: 32px !important;\n    height: 32px !important;\n    padding: 8px 18px;\n    font-weight: 400;\n    font-size: 13px;\n    line-height: normal;\n    font-family: $primaryFont !important;\n    box-shadow: none;\n\n    // Matches the 16px icon size used by .queue-icon-btn's action icons (App Summary,\n    // Preview, etc.) so the primary button's icon reads as the same icon, not an\n    // oversized variant of it.\n    .MuiButton-startIcon > * {\n      width: 16px;\n      height: 16px;\n      font-size: 16px;\n    }\n\n    &:hover {\n      opacity: 0.95;\n    }\n  }\n\n  // Every queue card's primary action button shares this one outlined-with-primary-color\n  // style (border/text/icon in $primary_color, white fill) so the action buttons look the\n  // same across all queue card types instead of some being filled and some outlined.\n  .action-needed-edit-btn-outlined.MuiButtonBase-root {\n    background: #ffffff !important;\n    color: $primary_color !important;\n    border: 1px solid $primary_color !important;\n    border-radius: 6px !important;\n    padding: 8px 24px !important;\n    font-weight: 400 !important;\n    font-size: 12px !important;\n\n    &:hover {\n      background: #F5F6F8 !important;\n      opacity: 1;\n    }\n  }\n\n}\n\n.queue-contact-tooltip.MuiPaper-root {\n  background: #6E6E77;\n  color: #ffffff;\n  border-radius: 4px;\n  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.35);\n  padding: 10px 12px;\n  overflow: visible;\n  width: 277px;\n\n  &::after {\n    content: \"\";\n    position: absolute;\n    left: 50%;\n    bottom: -6px;\n    width: 12px;\n    height: 12px;\n    background: #6E6E77;\n    transform: translateX(-50%) rotate(45deg);\n  }\n}\n\n.queue-contact-tooltip-content {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.queue-contact-tooltip-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 5px;\n}\n\n.queue-contact-tooltip-text {\n  flex: 1;\n  min-width: 0;\n  font-size: 14px;\n  line-height: 16px;\n  color: #ffffff;\n  font-family: $primaryFont !important;\n  overflow-wrap: anywhere;\n  word-break: break-all;\n}\n\n// Shared look for the small single-purpose action tooltips on the dashboard queue cards\n// (file upload, delete, app summary, preview, file name) — same rounded gray bubble as\n// .queue-contact-tooltip / .dashboard-status-tooltip, just using MUI Tooltip's built-in\n// `arrow` prop instead of a hand-rolled ::after caret.\n.dashboard-icon-tooltip.MuiTooltip-tooltip {\n  background: #6E6E77 !important;\n  color: #ffffff !important;\n  border-radius: 4px !important;\n  // max-width: 360px;\n  padding: 8px !important;\n}\n\n// MUI keys the tooltip-to-anchor gap off `[data-popper-placement*=\"...\"]` on the *popper*\n// (the tooltip's own parent), not on the tooltip element itself — so the override has to be\n// written as a descendant selector, not a same-element attribute selector.\n.MuiTooltip-popper[data-popper-placement*=\"top\"] .dashboard-icon-tooltip.MuiTooltip-tooltip {\n  margin-bottom: 4px !important;\n}\n.MuiTooltip-popper[data-popper-placement*=\"bottom\"] .dashboard-icon-tooltip.MuiTooltip-tooltip {\n  margin-top: 4px !important;\n}\n\n.dashboard-icon-tooltip-arrow.MuiTooltip-arrow {\n  color: #6E6E77 !important;\n  font-size: 15px !important;\n}\n\n.queue-contact-copy-btn.MuiButtonBase-root {\n  width: 24px;\n  height: 24px;\n  color: #ffffff;\n  padding: 0;\n  border-radius: 4px;\n  flex-shrink: 0;\n\n  &:hover {\n    background: rgba(255, 255, 255, 0.16);\n  }\n}\n\n@media screen and (max-width: 1024px) {\n  .dashboard-kpi-grid {\n    display: flex;\n    flex-wrap: nowrap;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    gap: 12px;\n    padding-bottom: 8px;\n    scrollbar-width: none;\n    padding: 0px 10px;\n\n    &::-webkit-scrollbar {\n      display: none;\n    }\n  }\n\n  .kpi-card {\n    flex-shrink: 0;\n    width: 180px;\n    height: 75px;\n  }\n}\n\n.create-app-container {\n  .stepper-wrapper {\n    background-color: $quote-bgColor;\n    padding: 16px;\n\n    .arrow-icon-btn {\n      border: 1px solid $light_border_color;\n      border-radius: 4px;\n      padding: 16px;\n    }\n\n    .stepper-wrapper-arrows {\n      display: flex;\n      align-items: center;\n      max-width: 100%;\n      margin: 0px auto;\n\n      .arrow-icon-btn {\n        padding: 14px 16px;\n        display: flex;\n        align-items: center;\n      }\n    }\n\n    p {\n      padding-top: 6px;\n      font-size: 12px;\n      font-weight: 600;\n    }\n\n    @media (max-width: 576px) {\n      .stepper-wrapper-arrows {\n        max-width: 100%;\n\n        .arrow-icon-btn {\n          display: none;\n        }\n      }\n\n      .stepper-container {\n        max-width: 100%;\n\n        .MuiStepper-root {\n          .MuiStep-root {\n            .MuiStepLabel-root {\n              .MuiStepLabel-labelContainer {\n                display: none;\n              }\n            }\n          }\n        }\n      }\n    }\n\n    @media (max-width: 900px) {\n      .stepper-wrapper-arrows {\n        max-width: 100%;\n      }\n    }\n  }\n\n  .footer-wrapper {\n    position: fixed;\n    bottom: 0;\n    width: 100%;\n    z-index: 999;\n    background-color: $light_background;\n    border-top: 1px solid #c2c7d0;\n\n    .footer-content {\n      padding: 8px 16px;\n      @include d_flex($justify_content: space_between);\n    }\n\n    // Create APP TC and PP css\n    .tc-pp-container {\n      display: flex;\n      flex-direction: row;\n\n      .hr-divider {\n        padding: 0 10px;\n      }\n\n      p {\n        font-size: 14px;\n        color: gray;\n        text-decoration: underline;\n      }\n    }\n  }\n\n  @media screen and (min-width: 1200px) {\n    .stepper-wrapper {\n      padding: 8px 16px;\n\n      p {\n        padding-top: 0px;\n      }\n    }\n  }\n}\n\n.bg-white {\n  background-color: #ffffff !important;\n}\n\n.dashboard-accordian {\n  padding: 8px 24px 24px;\n\n  .MuiPaper-root {\n    &.MuiAccordion-root {\n      box-shadow: none;\n      border: 1px solid #d7deec;\n      margin-bottom: 14px;\n      border-radius: 12px;\n      overflow: hidden;\n\n      &.Mui-expanded {\n        border-style: none;\n      }\n\n      .MuiAccordionSummary-root {\n        min-height: 60px;\n        background: #ffffff;\n\n        &.Mui-expanded {\n          border: 1px solid #d7deec;\n          border-radius: 12px;\n          margin: 0px;\n        }\n\n        .MuiAccordionSummary-content {\n          justify-content: space-between;\n          align-items: center;\n          margin-right: 10px;\n\n          &.Mui-expanded {\n            // border: 1px solid #C2C7D0;\n            // border-radius: 4px;\n            margin: 0px 10px 0px 0px;\n          }\n\n          .warning {\n            // color: #E99921;\n            font-size: 17px;\n            font-weight: 600;\n\n            display: flex;\n            align-items: center;\n            gap: 5px;\n\n            .MuiButtonBase-root {\n              font-size: 12px;\n              // background: #E99921;\n              border-radius: 50%;\n              width: 20px;\n              height: 20px;\n              color: #fff;\n            }\n          }\n\n          .warning-amount {\n            // color: #E99921;\n            font-size: 26px;\n            font-weight: 600;\n          }\n\n          .sucess {\n            color: #4caf50;\n            font-size: 14px;\n\n            display: flex;\n            align-items: center;\n            gap: 5px;\n\n            .MuiButtonBase-root {\n              font-size: 12px;\n              background: #4caf50;\n              border-radius: 50%;\n              width: 17px;\n              height: 17px;\n              color: #fff;\n            }\n          }\n\n          .sucess-amount {\n            color: #4caf50;\n            font-size: 26px;\n          }\n\n          .error {\n            color: #ee5b3a;\n            font-size: $font_14;\n            display: flex;\n            align-items: center;\n            gap: 5px;\n\n            .MuiButtonBase-root {\n              font-size: 12px;\n              background: #ee5b3a;\n              border-radius: 50%;\n              width: 17px;\n              height: 17px;\n              color: #fff;\n            }\n          }\n\n          .error-amount {\n            color: #ee5b3a;\n            font-size: 26px;\n          }\n        }\n\n        .MuiAccordionSummary-expandIconWrapper {\n          .collapsIconWrapper {\n            font-size: 25px;\n          }\n\n          .expandIconWrapper {\n            font-size: 25px;\n          }\n        }\n      }\n\n      // Accoordian inner styles\n      .MuiAccordionDetails-root {\n        padding: 0px;\n\n        .table-component {\n          box-shadow: none;\n          border-radius: 0px;\n\n          thead {\n            background-color: #e4e9f3;\n            border-top-left-radius: 0px;\n            border-top-right-radius: 0px;\n\n            tr {\n              th {\n                padding: 14px;\n                font-weight: 600;\n                color: #2f3750;\n                white-space: nowrap;\n\n                .MuiButtonBase-root {\n                  padding: 0px 8px;\n                }\n\n                &:last-child {\n                  text-align: center;\n                  width: 100%;\n\n                  @media screen and (min-width: 1024px) {\n                    text-align: start;\n                    padding-left: 3.8rem;\n                  }\n                }\n              }\n            }\n          }\n\n          tbody {\n            tr {\n              border-bottom: 1px solid #edf1f7;\n\n              td {\n                padding: 10px 14px;\n                color: #333c57;\n              }\n\n              .txt-elipsis {\n                max-width: 60px;\n                text-overflow: ellipsis;\n                overflow: hidden;\n                white-space: nowrap;\n              }\n            }\n          }\n        }\n\n        .document-table-component {\n          table {\n            .MuiTableCell-root {\n              &:last-child {\n                .MuiStack-root {\n\n                  // width:'240px',\n                  .MuiGrid-root {\n                    flex-wrap: nowrap;\n\n                    .MuiGrid-item {\n                      @media screen and (max-width: 430px) {\n                        min-width: 60px;\n                      }\n                    }\n                  }\n                }\n              }\n            }\n\n            tr {\n              th {\n                &:last-child {\n                  text-align: center;\n\n                  @media screen and (min-width: 1024px) {\n                    // padding-left: 0rem;\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n.confirmScreen {\n  height: 100dvh;\n  background: #f1f2f5;\n\n  .deeplink-content {\n    text-align: center;\n    background: white;\n    border-radius: 10px;\n    padding: 8% 15%;\n    margin: 9%;\n\n    svg {\n      width: 150px;\n      height: 150px;\n      margin-bottom: 16px;\n    }\n\n    .MuiTypography-root {\n      line-height: 35px;\n    }\n  }\n}\n\n// @media screen and (max-width: 765px) {\n\n.MuiAccordionDetails-root {\n  .table-component {\n    tbody {\n      tr {\n        .action-col {\n\n          // display: inline-flex;\n          .actions-data {\n            .MuiGrid-item {\n              width: 90px;\n\n              .actions-label {\n                width: 90px;\n                text-overflow: ellipsis;\n                overflow: hidden;\n                white-space: nowrap;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n// }\n\n.MuiButtonBase-root {\n  .MuiTypography-root {\n    white-space: nowrap;\n  }\n}\n\n@media screen and (max-width: 600px) {\n  .dashboard-kpi-grid {\n    padding: 0 12px 8px;\n    gap: 10px;\n  }\n\n  .kpi-card {\n    width: 170px;\n    // min-height: 65px;\n    // height: 65px;\n    margin-top: 5px;\n  }\n\n  .dashboard-welcome-title {\n    font-size: 24px;\n    line-height: 32px;\n  }\n\n  .dashboard-welcome-subtitle {\n    font-size: 14px;\n    line-height: 20px;\n  }\n\n  .dashboard-welcome-subtitle .attention-count {\n    font-size: 14px;\n  }\n\n  .dashboard-action-queue-list {\n    padding: 12px 12px 0;\n  }\n\n  .action-queue-empty-state {\n    flex: 1;\n    min-height: 0;\n    padding: 24px 12px;\n  }\n\n  .action-queue-empty-icon-wrap svg {\n    width: 90px;\n    height: auto;\n  }\n\n  .action-queue-empty-text {\n    font-size: 16px !important;\n    line-height: normal !important;\n  }\n\n  .action-queue-card {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 10px;\n  }\n\n  .revamp-header-tabs {\n    display: none;\n  }\n\n  .revamp-user-info {\n    display: none;\n  }\n\n  .dashboard-filters-panel {\n    margin: 12px auto 0;\n    padding: 14px;\n  }\n\n  .dashboard-queue-heading {\n    display: none;\n  }\n\n  .version-wrapper-dashboard {\n    display: none;\n  }\n\n  .tc-pp-container {\n    justify-content: center;\n  }\n\n  .MuiDialog-root.create-app-dialog {\n    .MuiDialog-container {\n      right: -3px;\n      top: 82px;\n    }\n  }\n\n  .MuiStack-root.dashboard-heading {\n    flex-direction: row;\n    flex-wrap: nowrap;\n    align-items: flex-start;\n    gap: 8px;\n    padding: 12px 12px 8px;\n  }\n\n  .MuiStack-root.dashboard-heading > .MuiBox-root:first-child {\n    flex: 1;\n    min-width: 0;\n    width: auto;\n  }\n\n  .dashboard-welcome-title {\n    font-size: 18px !important;\n    font-weight: 700 !important;\n    line-height: 28px !important;\n  }\n\n  .dashboard-welcome-subtitle {\n    font-size: 12px !important;\n    color: #6B7280 !important;\n    margin-top: 2px;\n  }\n\n  .dashboard-heading .header-btns {\n    justify-content: flex-end;\n    min-width: 0;\n    flex-shrink: 0;\n    display: flex !important;\n    gap: 6px;\n    padding-top: 2px;\n  }\n\n  .dashboard-heading .header-btns .MuiButtonBase-root {\n    min-height: 32px !important;\n    padding: 5px 12px !important;\n  }\n\n  .dashboard-heading .header-btns .MuiIconButton-root {\n    width: 34px !important;\n    height: 34px !important;\n    padding: 6px !important;\n  }\n\n  .dashboard-header-search {\n    flex: 1 1 auto;\n    min-width: 80px;\n    width: auto;\n  }\n\n  .action-queue-actions {\n    width: 100%;\n    padding-left: 0;\n    justify-content: flex-start;\n  }\n\n  /* ── Queue card mobile reflow ─────────────────────────────────────────────\n     Use display:contents on the top-row to dissolve it, then order the card\n     sections: name → meta → pills → reasons → actions (bottom).\n  ── */\n  .action-queue-card-item.action-queue-card-action-needed {\n    display: flex;\n    flex-direction: column;\n  }\n\n  /* Dissolve the wrapper so company-name and top-actions become\n     direct flex children of the card and can be individually ordered. */\n  .action-needed-top-row {\n    display: contents;\n  }\n\n  /* Also dissolve the title+metadata column (added so the two center against the actions'\n     combined height on desktop) — otherwise .action-needed-company/.action-needed-meta-row\n     stay nested one level deeper than .action-needed-top-actions/pills/reasons, and their\n     order:1/2 below has no effect since they're no longer siblings of order:3/4/5. */\n  .action-needed-title-meta-col {\n    display: contents;\n  }\n\n  .action-needed-company {\n    order: 1;\n    margin-bottom: 6px;\n    font-size: 18px !important;\n    font-weight: 700 !important;\n  }\n\n  .action-needed-meta-row {\n    order: 2;\n    margin-bottom: 10px;\n  }\n\n  .action-needed-pills-row {\n    order: 3;\n    margin-bottom: 10px;\n  }\n\n  .action-needed-reasons-divider {\n    order: 4;\n  }\n\n  .action-needed-reasons {\n    order: 4;\n  }\n\n  /* Actions row moves to the bottom with a hairline divider above, right-aligned */\n  .action-needed-top-actions {\n    order: 5;\n    border-top: 1px solid #EAECF0;\n    padding-top: 12px;\n    margin-top: 8px;\n    gap: 8px;\n    flex-wrap: nowrap;\n    align-items: center;\n    justify-content: flex-end;\n    width: 100%;\n    display: flex;\n  }\n\n  /* Edit button stays compact — does not stretch */\n  .action-open-btn.MuiButtonBase-root {\n    flex: 0 0 auto;\n  }\n\n  /* version-wrapper-dashboard is hidden on mobile, so reclaim its height — the marketing\n     banner's own height (if present) is still reserved on top, same as everywhere else */\n  .dashboard-main {\n    height: calc(100dvh - 60px - var(--marketing-banner-height, 0px));\n  }\n}\n\n@media screen and (max-width: 460px) {\n  .MuiStack-root.dashboard-heading {\n    // margin: 0 12px;\n    border-radius: 0;\n  }\n\n  .MuiDialog-root.create-app-dialog {\n    .MuiDialog-container {\n      right: 2%;\n      top: 13%;\n    }\n  }\n\n  .MuiStack-root.dashboard-heading {\n    flex-direction: row;\n    flex-wrap: nowrap;\n    align-items: center;\n  }\n\n  .header-btns {\n    min-width: 0;\n    display: flex;\n    justify-content: flex-end;\n\n    button:not(:last-child) {\n      margin-right: 8px;\n    }\n\n    button {\n      p {\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n    }\n  }\n\n  .dashboard-header-search {\n    order: -1;\n  }\n\n  .create-app-container {\n    .MuiBox-root.create-app-comp-wrapper {\n      height: calc(100dvh - 360px);\n      margin-right: 5px;\n\n      .accordion-styles {\n        padding: 10px 16px;\n      }\n\n      @media screen and (max-width: 460px) {\n        height: auto;\n      }\n    }\n\n    .MuiStack-root.create-app-heading {\n      padding: 16px;\n    }\n\n    .stepper-wrapper {\n      .MuiBox-root {\n        padding-bottom: 6px;\n      }\n    }\n\n    .footer-wrapper {\n      .footer-content {\n        padding: 14px;\n      }\n    }\n  }\n}\n\n// @media screen and (min-width:1200px) {\n//     .dashboard-accordian{\n//         height: calc(100vh - 312px);\n//         overflow: auto;\n//     }\n// }\n@media screen and (max-width: 540px) {\n  .dashboard-accordian {\n    padding: 8px 12px 16px;\n  }\n\n  .dashboard-accordian .MuiPaper-root.MuiAccordion-root .MuiAccordionSummary-root .MuiAccordionSummary-content {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: flex-start;\n  }\n\n  .dashboard-accordian .MuiPaper-root.MuiAccordion-root .MuiAccordionSummary-root .MuiAccordionSummary-content .warning-amount {\n    max-width: 320px;\n    word-wrap: break-word;\n  }\n\n  .confirmScreen {\n    .deeplink-content {\n      padding: 8%;\n      margin: 22px;\n\n      svg {\n        width: 100px;\n        height: 100px;\n      }\n    }\n  }\n}\n\n@media screen and (max-width: 1024px) {\n  .create-app-container {\n    .stepper-wrapper {\n      p {\n        font-size: 14px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n      }\n    }\n  }\n}",":root {\n    --color: #000;\n    // --font-family: \"sans-serif\";\n    // Single source of truth for the app's max BODY content width (page content + non-dashboard\n    // footers, e.g. the createApplication sticky footer). Change this value to resize that column.\n    // See .app-content-shell in form_styles.scss, which reads this variable.\n    --app-max-content-width: 1440px;\n    // Caps the header's CONTENT (.revamp-header in dashboard.scss) and the Dashboard-page footer\n    // (.version-wrapper-dashboard) / IndeterminateLoadingBar.tsx, all of which center/cap at this\n    // width. .revamp-appbar itself (the header's background) stays full viewport width regardless\n    // — it does not read this variable — so the bar's background spans edge-to-edge while its\n    // content stays capped and centered inside it.\n    --app-header-max-width: 1920px;\n}\n\n// Color codes\n// $primary_color: #054E5A;\n$primary_color:  var(--color);\n$page_bg: #F7F7F8;\n$quote-bgColor:#EAF3F5;\n$accordion-bgColor:#F5F6F8;\n$grey_color: #A3A9B9;\n$light_black: #14151C;\n$input_text: #696F88;\n$light_bgcolor: #F3F4F6;\n$color: #A3A9B9;\n$error: #D84315;\n$white_color: #fff;\n$light_background: #F3F4F6;\n$light_border_color: #C2C7D0;\n$label_color: #808080;\n$light_gray:#718899;\n$icon_bg:#DDDEE9;\n$header_bgcolor: #DFE2E7;\n$table_border:#D9D9D9;\n$cards_bg:#F9F9F9;\n$bg_text:#666;\n//Font Family\n$primaryFont:var(--font-family);\n// Font sizes   \n$font_10: 10px;\n$font_11: 11px;\n$font_12: 12px;\n$font_13: 13px;\n$font_14: 14px;\n$font_15: 15px;\n$font_16: 16px;\n$font_18: 18px;\n$font_20: 20px;\n$font_21: 21px;\n$font_22: 22px;\n$font_24: 24px;\n$font_25: 25px;\n$font_26: 26px;\n$font_28: 28px;\n$font_29: 29px;\n$font_30: 30px;\n\n// Font weights\n$font_weight_normal: normal;\n$font_weight_bold: bold;\n$font_weight_medium: Medium;\n$font_weight_300: 300;\n$font_weight_500: 500;\n$font_weight_600: 600;\n$font_weight_700: 700;\n\n// Font Family\n// $robot: 'robotoregular';\n\n// Box shadow\n$box_shadow_1: 0 1px 3px 0 rgba(63, 63, 68, 0.15),\n    0 0 0 1px rgba(63, 63, 68, 0.05);\n$box_shadow_2: 0 0 7px 0 rgba(0, 0, 0, 0.23);\n$box_shadow_3: 0 0 6px 0 rgba(0, 0, 0, 0.27);\n$box_shadow_4: 0 0 0 1px #e4e7eb;\n$box_shadow_5: 0 0 15px 0 rgba(0, 0, 0, 0.23);\n$box_shadow_1: 0 4px 6px 0 rgba(0, 0, 0, 0.06);\n$box_shadow: 2px 4px 16px rgba(50, 98, 149, 0.15);\n\n//Border radius\n$border_4: 4px;\n$border_10: 10px;\n$border_15: 15px;\n$border_100: 100%;\n\n///margin scss \n//------------------\n$margin-5: 5px 5px 5px 5px;\n$margin-10: 10px 10px 10px 10px;\n$margin-15: 15px 15px 15px 15px;\n$margin-10-15: 10px 15px 10px 15px;\n\n//Media quries\n$mobile_breakpoint: 576px;\n$tablet_breakpoint: 768px;\n$laptop_breakpoint: 992px;\n$large_laptop_breakpoint: 1280px;\n$desktop_breakpoint: 1440px;\n$desktop_point: 1024px;","@import \"./variable.scss\";\n// Mixins and Base Styles\n\n\n// Filled blue button mixin\n\n/////////////////////////////// Heading Mixins ///////////////////////\n\n@mixin heading_1 ($color, $font_size, $font_family, $font_weight) {\n    font-size: $font_size !important;\n    font-family: $font_family !important;\n    font-weight: $font_weight !important;\n    color: $color;\n  }\n\n  @mixin paragraph($color, $font_size, $font_family) {\n    font-size: $font_size !important;\n    font-family: $font_family !important;\n    color: $color;\n  }\n\n\n////////////////////////////// Error /////////////////////////////\n\n@mixin Error($color, $font_size, $font_family) {\n    font-size: $font_size;\n    font-family: $font_family;\n    font-weight: $font_weight_normal;\n    color: $color;\n}\n\n\n /////////////////////////////// Flex Mixin ///////////////////////\n\n @mixin d_flex($justify_content) {\n  display: flex;\n  align-items: center;\n\n  @if $justify_content=='center' {\n      justify-content: center;\n  }\n\n  @else if $justify_content=='space_between' {\n      justify-content: space-between;\n  }\n\n  @else if $justify_content=='space_around' {\n      justify-content: space-around;\n  }\n\n  @else if $justify_content=='flex_start' {\n      justify-content: flex-start;\n  }\n\n  @else if $justify_content=='flex_end' {\n      justify-content: flex-end;\n  }\n\n  @else if $justify_content=='space_evenly' {\n      justify-content: space-evenly;\n  }\n }\n/////////////////////////////// Media queries ///////////////////////\n\n//upto mobile\n@mixin mobile() {\n    @media screen and (max-width:$mobile_breakpoint) {\n        @content;\n    }\n  }\n  \n  //upto 768\n  @mixin tablet() {\n    @media screen and (max-width:$tablet_breakpoint) {\n        @content;\n    }\n  }\n  \n  //upto 992\n  @mixin laptop() {\n    @media screen and (max-width:$laptop_breakpoint) {\n        @content;\n    }\n  }\n  \n  //upto 1280\n  @mixin large_laptop() {\n    @media screen and (max-width:$large_laptop_breakpoint) {\n        @content;\n    }\n  }\n  \n  //upto 1440\n  @mixin desktop() {\n    @media screen and (max-width:$desktop_breakpoint) {\n        @content;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
